import React, { useCallback, useEffect, useState, useMemo, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/DatePicker.css';
import { marked } from 'marked';


import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Tooltip,
    Select,
    MenuItem,
    Chip,
    Button,
    IconButton,
    Box,
    Typography,
    useTheme,
    useMediaQuery,
    TextField,
    FormControl,
    InputLabel,
    CircularProgress,
    Autocomplete,
    Checkbox,
    ListItemText,
    Menu,
    Divider,
    TableSortLabel,
    Popper,
} from '@mui/material';
import {
    Edit as EditIcon,
    Add as AddIcon,
    Business as BusinessIcon,
    Search as SearchIcon,
    FilterList as FilterIcon,
    DarkMode as DarkModeIcon,
    LightMode as LightModeIcon,
    Delete as DeleteIcon,
    History as HistoryIcon,
    Clear as ClearIcon,
    Save as SaveIcon,
    LocationOn as LocationOnIcon,
    FileDownload as FileDownloadIcon,
    PictureAsPdf as PictureAsPdfIcon,
    KeyboardArrowDown as KeyboardArrowDownIcon,
    ArrowUpward as ArrowUpwardIcon,
    ArrowDownward as ArrowDownwardIcon,
    UnfoldMore as UnfoldMoreIcon,
    ViewColumn as ViewColumnIcon,
    VisibilityOff as VisibilityOffIcon,
    Visibility as VisibilityIcon,
} from '@mui/icons-material';
import ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { TableVirtuoso, GroupedTableVirtuoso } from 'react-virtuoso';
import ObjectDialog from './ObjectsReestrView/ObjectDialogV3.jsx';
import AuditHistoryDialog from './common/AuditHistoryDialog.jsx';
import EquipmentTextEditDialog from './ObjectsReestrView/EquipmentTextEditDialog.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { fetchState, toggleDarkMode } from '../../store/reducers/stateReducer.js';
import { $authHost } from '../../http/index.js';
import { ktpIcon, projectStatusOreolIcon } from '../layers/icons.js';
import '../../utils/arial-normal.js'
import '../../utils/arial-bold.js'
import { values } from 'lodash';
import { AdvancedFiltersComponent } from './common/AdvancedFilters.jsx';
import { selectMappedElectricity } from '../../store/selectors/supervisionSelector.js'

import MarkdownContent from './ObjectsReestrView/common/MarkdownContent.jsx';
import EditableDateCell from './ObjectsReestrView/common/EditableDateCell.jsx';
import EditableNumberCell from './ObjectsReestrView/common/EditableNumberCell.jsx';
import EditableTextAreaCell from './ObjectsReestrView/common/EditableTextAreaCell.jsx';
import EditableSelectCell from './ObjectsReestrView/common/EditableSelectCell.jsx';
// Регистрируем русскую локаль
registerLocale('ru', ru);

const requirementsTree = {
    '48': [67, 72, 73, 74],
    '49': [66],
    '50': [68, 75],
    '51': [67, 69, 72, 73, 74],
    '52': [66],
    '53': [68, 70, 75],
    '55': [65],
    '61': [65, 71],
    '63': [65]
}


function formatRuble(str) {
    return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
    }).format(str || 0)
}

function formatDateShort(str) {
    return formatDate(str, true)
}

function formatDate(str, short = false) {
    if (!str) return '';

    // Если дата в формате "YYYY-MM-DD" (из базы данных)
    if (str.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [, year, month, day] = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        return `${day}.${month}.${year}`;
    }

    // Если дата уже в формате "DD-MM-YYYY"
    if (str.match(/^\d{2}-\d{2}-\d{4}$/)) {
        const [, day, month, year] = str.match(/^(\d{2})-(\d{2})-(\d{4})$/);
        return `${day}.${month}.${year}`;
    }

    // Если дата в формате "HH:MM DD-MM-YYYY"
    if (str.match(/^\d{2}:\d{2}\s\d{2}-\d{2}-\d{4}$/)) {
        const [, hours, minutes, day, month, year] = str.match(/^(\d{2}):(\d{2})\s(\d{2})-(\d{2})-(\d{4})$/);
        return `${hours}:${minutes} ${day}.${month}.${year}`;
    }

    // Попытка парсинга как обычной даты
    try {
        const date = new Date(str);
        if (isNaN(date.getTime())) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return short ? `${day}.${month}.${year}` : `${hours}:${minutes} ${day}.${month}.${year}`;
    } catch {
        return '';
    }
}

// Компонент для отображения markdown контента
// const MarkdownContent = ({ content, darkMode }) => {
//     if (!content) return null;

//     const htmlContent = marked(content);

//     return (
//         <Box
//             sx={{
//                 '& p': {
//                     margin: '1px 0',
//                     fontSize: '0.75rem',
//                     lineHeight: '1.2',
//                 },
//                 '& strong': {
//                     fontWeight: 'bold',
//                 },
//                 '& em': {
//                     fontStyle: 'italic',
//                 },
//                 '& ul, & ol': {
//                     margin: '1px 0',
//                     paddingLeft: '8px',
//                 },
//                 '& li': {
//                     margin: '0px 0',
//                     fontSize: '0.75rem',
//                 },
//                 '& code': {
//                     backgroundColor: darkMode ? '#333' : '#f5f5f5',
//                     padding: '1px 2px',
//                     borderRadius: '2px',
//                     fontSize: '0.7rem',
//                     fontFamily: 'monospace',
//                 },
//                 '& pre': {
//                     backgroundColor: darkMode ? '#333' : '#f5f5f5',
//                     padding: '2px',
//                     borderRadius: '2px',
//                     overflow: 'auto',
//                     fontSize: '0.7rem',
//                 },
//                 '& blockquote': {
//                     borderLeft: `2px solid ${darkMode ? '#2196f3' : '#1565c0'}`,
//                     paddingLeft: '4px',
//                     margin: '1px 0',
//                     fontStyle: 'italic',
//                 },
//                 '& h1, & h2, & h3, & h4, & h5, & h6': {
//                     margin: '1px 0',
//                     fontWeight: 'bold',
//                 },
//                 '& h1': { fontSize: '0.9rem' },
//                 '& h2': { fontSize: '0.85rem' },
//                 '& h3': { fontSize: '0.8rem' },
//                 '& h4': { fontSize: '0.75rem' },
//                 '& h5': { fontSize: '0.7rem' },
//                 '& h6': { fontSize: '0.65rem' },
//             }}
//             dangerouslySetInnerHTML={{ __html: htmlContent }}
//         />
//     );
// };

// const formatDateForInput = (dateString) => {
//     if (!dateString) return '';
//     try {
//         // Если дата уже в формате "YYYY-MM-DD" (из базы данных)
//         if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
//             return dateString;
//         }

//         // Если дата в формате "HH:MM DD-MM-YYYY"
//         const dateTimeMatch = dateString.match(/^(\d{2}):(\d{2})\s(\d{2})-(\d{2})-(\d{4})$/);
//         if (dateTimeMatch) {
//             const [, hours, minutes, day, month, year] = dateTimeMatch;
//             return `${year}-${month}-${day}`;
//         }

//         // Если дата в формате "DD-MM-YYYY"  
//         const dateMatch = dateString.match(/^(\d{2})-(\d{2})-(\d{4})$/);
//         if (dateMatch) {
//             const [, day, month, year] = dateMatch;
//             return `${year}-${month}-${day}`;
//         }

//         // Попытка парсинга как обычной даты
//         const date = new Date(dateString);
//         if (isNaN(date.getTime())) return '';
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const day = String(date.getDate()).padStart(2, '0');
//         return `${year}-${month}-${day}`;
//     } catch {
//         return '';
//     }
// };

// Функция для форматирования даты из input в формат "YYYY-MM-DD" для базы данных
// const formatDateFromInput = (inputValue) => {
//     if (!inputValue) return '';
//     try {
//         const date = new Date(inputValue);
//         if (isNaN(date.getTime())) return '';

//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const day = String(date.getDate()).padStart(2, '0');

//         return `${year}-${month}-${day}`;
//     } catch {
//         return '';
//     }
// };

const columns = [
    {
        id: 'fid', label: '№', minWidth: 30, width: 30, maxWidth: 30, // Немного больше для лучшей читаемости
        align: 'center',
    },
    // {
    //     id: 'name', label: 'Наименование', minWidth: 150, width: 150, maxWidth: 150,// Больше места для названий
    //     align: 'center', // Лучше выравнивание для текста
    // },
    {
        id: 'name_by_acts', label: 'Наименование по актам', minWidth: 150, width: 150, maxWidth: 150, // Больше для текста
        align: 'start',
    },
    {
        id: 'start',
        label: 'Начало строительства',
        minWidth: 160, width: 160, maxWidth: 160, // По 120px на каждую подколонку
        colSpan: 2,
        align: 'center',
        tooltip: 'Плановое начало | Фактическое начало',
    },
    {
        id: 'end',
        label: 'Завершение строительства',
        minWidth: 160, width: 160, maxWidth: 160, // По 120px на каждую подколонку
        colSpan: 2,
        align: 'center',
        tooltip: 'Плановое завершение | Фактическое завершение',
    },
    {
        id: 'stage', label: 'Этап', minWidth: 60, width: 60, maxWidth: 60, // Немного больше для цифр
        align: 'center',
    },
    {
        id: 'closing', label: 'Закрытие без НДС', minWidth: 100, width: 100, maxWidth: 100, // Немного больше для цифр
        align: 'center',
    },
    {
        id: 'cost', label: 'Стоимость без НДС', minWidth: 100, width: 100, maxWidth: 100, // Немного больше для цифр
        align: 'center',
    },
    {
        id: 'comment', label: 'Комментарий', minWidth: 200, width: 200, maxWidth: 200,// Больше для текста
        align: 'start',
    },
    {
        id: 'responsible', label: 'Ответственный', minWidth: 120, width: 120, maxWidth: 120, // Больше для имен
        align: 'center',
    },
    {
        id: 'coexecutors', label: 'Соисполнители', minWidth: 120, width: 120, maxWidth: 120, // Больше для имен
        align: 'center',
    },
    {
        id: 'equipment', label: 'Оснащение', minWidth: 200, width: 200, maxWidth: 200, // Больше для названий
        align: 'center',
    },
    {
        id: 'created', label: 'Создано', minWidth: 120, width: 120, maxWidth: 120, // Больше для дат и имен
        align: 'center',
    },
    {
        id: 'modified', label: 'Изменено', minWidth: 120, width: 120, maxWidth: 120, // Больше для дат и имен
        align: 'center',
    },
    // { id: 'actions', label: 'Действия', minWidth: 80, align: 'center' },
];


const VirtuosoTableComponents = {

    Scroller: React.forwardRef((props, ref) => (
        <TableContainer component={Paper} {...props} ref={ref} sx={{
            bgcolor: 'transparent',
            boxShadow: 'none',
            width: '100%',
            minWidth: '100%',
            overflowX: 'auto', // для скролла
        }} />
    )),
    Table: (props) => (
        <Table {...props} sx={{
            borderCollapse: 'separate',
            tableLayout: 'fixed', // Автоматическое распределение ширины
            bgcolor: 'transparent',
            width: 'fit-content',
            // width: '100%', // Используем всю доступную ширину
            // minWidth: '100%', // Минимальная ширина 100%
        }} />
    ),
    TableHead: React.forwardRef((props, ref) => (
        <TableHead {...props} ref={ref} />
    )),
    TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

function fixedHeaderContent(darkMode, editMode, selectedRows, filteredData, handleSelectAll, sortBy, sortDirection, handleSort, visibleColumns, columnWidths, getColumnWidth, handleResizeStart) {

    // Функция для получения иконки сортировки
    const getSortIcon = (columnId) => {
        if (sortBy !== columnId) {
            return null;
        }
        return sortDirection === 'asc'
            ? <ArrowUpwardIcon fontSize="small" />
            : <ArrowDownwardIcon fontSize="small" />;
    };

    // Получаем только видимые столбцы
    const visibleColumnsArray = columns.filter(col => visibleColumns[col.id]);

    return (
        <>
            <TableRow>
                {visibleColumnsArray.map((column, index) => {
                    const columnWidth = getColumnWidth(column.id);
                    return (
                        <TableCell
                            key={column.id}
                            variant="head"
                            align={column.align || 'left'}
                            // style={{
                            //     width: columnWidth,
                            //     minWidth: column.minWidth,
                            //     maxWidth: 'none',
                            //     position: 'relative'
                            // }}
                            colSpan={column.colSpan}
                            sx={{
                                width: columnWidth,
                                minWidth: columnWidth,
                                maxWidth: columnWidth,
                                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                color: darkMode ? '#f5f7fa' : '#333',
                                fontWeight: 600,
                                fontSize: '0.8rem',
                                lineHeight: '1.2',
                                borderBottom: darkMode
                                    ? '2px solid rgba(255, 255, 255, 0.12)'
                                    : '2px solid rgba(0, 0, 0, 0.12)',
                                borderRight: darkMode
                                    ? '1px solid rgba(255, 255, 255, 0.08)'
                                    : '1px solid rgba(0, 0, 0, 0.08)',
                                position: 'sticky',
                                top: 0,
                                zIndex: 10,
                                p: '2px 8px',
                                cursor: 'pointer',
                                '&:hover': {
                                    // bgcolor: darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
                                },
                                // Принудительно переопределяем цвета для всех дочерних элементов
                                '& .MuiTableSortLabel-root': {
                                    color: darkMode ? '#f5f7fa' : '#333',
                                },
                                '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
                                    color: darkMode ? '#64b5f6' : '#1976d2',
                                },
                                '& .MuiTableSortLabel-root:hover': {
                                    color: darkMode ? '#ffffff' : '#1976d2',
                                },
                                '& .MuiTableSortLabel-icon': {
                                    color: darkMode ? '#f5f7fa' : '#333',
                                },
                                '& .MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
                                    color: darkMode ? '#64b5f6' : '#1976d2',
                                },
                                '& .MuiTableSortLabel-root:hover .MuiTableSortLabel-icon': {
                                    color: darkMode ? '#ffffff' : '#1976d2',
                                },
                            }}
                            onClick={(e) => {
                                // Не вызываем handleSort, если клик был на разделителе
                                if (e.target.closest('.column-resizer')) {
                                    return;
                                }
                                handleSort(column.id);
                            }}
                        >
                            <TableSortLabel
                                active={sortBy === column.id}
                                direction={sortBy === column.id ? sortDirection : 'asc'}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleSort(column.id);
                                }}
                                sx={{
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    '&:hover': {
                                        color: darkMode ? '#ffffff' : '#1976d2',
                                    },
                                    '&.MuiTableSortLabel-active': {
                                        color: darkMode ? '#64b5f6' : '#1976d2',
                                    },
                                    '& .MuiTableSortLabel-icon': {
                                        color: darkMode ? '#f5f7fa' : '#333',
                                    },
                                    '&.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
                                        color: darkMode ? '#64b5f6' : '#1976d2',
                                    },
                                    '&:hover .MuiTableSortLabel-icon': {
                                        color: darkMode ? '#ffffff' : '#1976d2',
                                    },
                                    // Принудительно переопределяем цвета для всех состояний
                                    '&.MuiTableSortLabel-root': {
                                        color: darkMode ? '#f5f7fa' : '#333',
                                    },
                                    '&.MuiTableSortLabel-root.MuiTableSortLabel-active': {
                                        color: darkMode ? '#64b5f6' : '#1976d2',
                                    },
                                    '&.MuiTableSortLabel-root:hover': {
                                        color: darkMode ? '#ffffff' : '#1976d2',
                                    },
                                    // Стили для иконки во всех состояниях
                                    '& .MuiTableSortLabel-iconDirectionAsc': {
                                        color: darkMode ? '#f5f7fa' : '#333',
                                    },
                                    '& .MuiTableSortLabel-iconDirectionDesc': {
                                        color: darkMode ? '#f5f7fa' : '#333',
                                    },
                                    '&.MuiTableSortLabel-active .MuiTableSortLabel-iconDirectionAsc': {
                                        color: darkMode ? '#64b5f6' : '#1976d2',
                                    },
                                    '&.MuiTableSortLabel-active .MuiTableSortLabel-iconDirectionDesc': {
                                        color: darkMode ? '#64b5f6' : '#1976d2',
                                    },
                                    '&:hover .MuiTableSortLabel-iconDirectionAsc': {
                                        color: darkMode ? '#ffffff' : '#1976d2',
                                    },
                                    '&:hover .MuiTableSortLabel-iconDirectionDesc': {
                                        color: darkMode ? '#ffffff' : '#1976d2',
                                    },
                                    // Принудительно переопределяем все возможные цвета
                                    '& *': {
                                        color: 'inherit !important',
                                    },
                                }}
                            >

                                {index === 0 && editMode ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                                        <Checkbox
                                            checked={selectedRows.size > 0 && selectedRows.size === filteredData.length}
                                            indeterminate={selectedRows.size > 0 && selectedRows.size < filteredData.length}
                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                            size="small"
                                            sx={{
                                                color: darkMode ? '#64b5f6' : '#1976d2',
                                                p: '2px',
                                                '&.Mui-checked': {
                                                    color: darkMode ? '#64b5f6' : '#1976d2',
                                                },
                                                '&.MuiCheckbox-indeterminate': {
                                                    color: darkMode ? '#64b5f6' : '#1976d2',
                                                },
                                            }}
                                        />
                                        <Typography variant="caption" fontWeight={600} sx={{ fontSize: '0.75rem', lineHeight: 1.2 }}>
                                            {column.label}
                                        </Typography>
                                        {/* {getSortIcon(column.id)} */}
                                    </Box>
                                ) : (
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                        {column.tooltip ? (
                                            <Tooltip title={column.tooltip}>
                                                <Typography variant="caption" fontWeight={600} sx={{ fontSize: '0.85rem', lineHeight: 1.2 }}>
                                                    {column.label}
                                                </Typography>
                                            </Tooltip>
                                        ) : (
                                            <Typography variant="caption" fontWeight={600} sx={{ fontSize: '0.85rem', lineHeight: 1.2 }}>
                                                {column.label}
                                            </Typography>
                                        )}
                                        {/* {getSortIcon(column.id)} */}
                                    </Box>
                                )}
                            </TableSortLabel>
                            {/* Разделитель для изменения размера */}
                            <Box
                                className="column-resizer"
                                onMouseDown={(e) => handleResizeStart(e, column.id)}
                                sx={{
                                    position: 'absolute',
                                    right: '-2px',
                                    top: 0,
                                    bottom: 0,
                                    width: '4px',
                                    cursor: 'col-resize',
                                    zIndex: 11,
                                    backgroundColor: 'transparent',
                                    transition: 'background-color 0.2s',
                                    '&:hover': {
                                        backgroundColor: darkMode ? 'rgba(100, 181, 246, 0.6)' : 'rgba(25, 118, 210, 0.4)',
                                    },
                                }}
                            />
                        </TableCell>
                    );
                })}
            </TableRow>
            {/* Второй ряд заголовков для подколонок дат */}
            {/* <TableRow>
        <TableCell sx={{
          bgcolor: darkMode ? '#2b2b2b' : '#fff',
          borderBottom: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.12)' 
            : '1px solid rgba(0, 0, 0, 0.12)',
          borderRight: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.08)' 
            : '1px solid rgba(0, 0, 0, 0.08)',
          position: 'sticky',
          top: 57,
          zIndex: 10,
        }}></TableCell>
        <TableCell sx={{
          bgcolor: darkMode ? '#2b2b2b' : '#fff',
          borderBottom: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.12)' 
            : '1px solid rgba(0, 0, 0, 0.12)',
          borderRight: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.08)' 
            : '1px solid rgba(0, 0, 0, 0.08)',
          position: 'sticky',
          top: 57,
          zIndex: 10,
        }}></TableCell>
        <TableCell align="center" sx={{
          minWidth: 85,
          bgcolor: darkMode ? '#2b2b2b' : '#fff',
          color: darkMode ? '#64b5f6' : '#1976d2',
          fontWeight: 500,
          fontSize: '0.75rem',
          borderBottom: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.12)' 
            : '1px solid rgba(0, 0, 0, 0.12)',
          borderRight: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.08)' 
            : '1px solid rgba(0, 0, 0, 0.08)',
          position: 'sticky',
          top: 57,
          zIndex: 10,
        }}>План</TableCell>
        <TableCell align="center" sx={{
          minWidth: 85,
          bgcolor: darkMode ? '#2b2b2b' : '#fff',
          color: darkMode ? '#4caf50' : '#2e7d32',
          fontWeight: 500,
          fontSize: '0.75rem',
          borderBottom: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.12)' 
            : '1px solid rgba(0, 0, 0, 0.12)',
          borderRight: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.08)' 
            : '1px solid rgba(0, 0, 0, 0.08)',
          position: 'sticky',
          top: 57,
          zIndex: 10,
        }}>Факт</TableCell>
        <TableCell align="center" sx={{
          minWidth: 85,
          bgcolor: darkMode ? '#2b2b2b' : '#fff',
          color: darkMode ? '#64b5f6' : '#1976d2',
          fontWeight: 500,
          fontSize: '0.75rem',
          borderBottom: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.12)' 
            : '1px solid rgba(0, 0, 0, 0.12)',
          borderRight: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.08)' 
            : '1px solid rgba(0, 0, 0, 0.08)',
          position: 'sticky',
          top: 57,
          zIndex: 10,
        }}>План</TableCell>
        <TableCell align="center" sx={{
          minWidth: 85,
          bgcolor: darkMode ? '#2b2b2b' : '#fff',
          color: darkMode ? '#4caf50' : '#2e7d32',
          fontWeight: 500,
          fontSize: '0.75rem',
          borderBottom: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.12)' 
            : '1px solid rgba(0, 0, 0, 0.12)',
          borderRight: darkMode 
            ? '1px solid rgba(255, 255, 255, 0.08)' 
            : '1px solid rgba(0, 0, 0, 0.08)',
          position: 'sticky',
          top: 57,
          zIndex: 10,
        }}>Факт</TableCell>
        {[...Array(6)].map((_, index) => (
          <TableCell key={index} sx={{
            bgcolor: darkMode ? '#2b2b2b' : '#fff',
            borderBottom: darkMode 
              ? '1px solid rgba(255, 255, 255, 0.12)' 
              : '1px solid rgba(0, 0, 0, 0.12)',
            borderRight: darkMode 
              ? '1px solid rgba(255, 255, 255, 0.08)' 
              : '1px solid rgba(0, 0, 0, 0.08)',
            position: 'sticky',
            top: 57,
            zIndex: 10,
          }}></TableCell>
        ))}
      </TableRow> */}
        </>
    );
}

// Функция для отображения заголовка группы КДП
function groupContent(index, groupedData, darkMode, user, handleOpenCreateDialog, projectsList, visibleColumns) {
    if (!groupedData.groupedData || groupedData.groupedData.length === 0) {
        return null;
    }
    // Находим первый элемент группы для получения названия КДП
    const firstItemInGroup = groupedData.groupedData.find(item => item.group === index);
    const groupName = firstItemInGroup?.groupName || `Группа ${index}`;
    const groupCount = groupedData.groupCountsRows[index];

    // Находим KDP ID для этой группы
    const itemKdpId = firstItemInGroup?.project_id;
    // Если KDP ID не найден в объекте, ищем по названию группы в списке KDP
    const groupKdpId = itemKdpId || projectsList.find(p => p.name === groupName)?.id;

    // Подсчет стоимости и закрытия для группы
    // Фильтруем только строки объектов (purpose === 'object'), чтобы не считать дважды
    const groupCost = groupedData.groupedData
        .filter(item => item.group === index && item.purpose === 'object')
        .reduce((total, item) => {
            const data = item.data || { categories: [] };
            // Суммируем cost из всех категорий
            // Если у категории есть работы - суммируем из работ, иначе берем значение категории
            const itemCost = (data.categories || []).reduce((catSum, category) => {
                const categoryWorks = category.works || [];
                if (categoryWorks.length > 0) {
                    const categoryCost = categoryWorks.reduce((workSum, work) => {
                        return workSum + (Number(work.cost || 0));
                    }, 0);
                    return catSum + categoryCost;
                } else {
                    return catSum + (Number(category.cost || 0));
                }
            }, 0);
            return total + itemCost;
        }, 0);

    const groupClosing = groupedData.groupedData
        .filter(item => item.group === index && item.purpose === 'object')
        .reduce((total, item) => {
            const data = item.data || { categories: [] };
            // Суммируем closing из всех категорий
            // Если у категории есть работы - суммируем из работ, иначе берем значение категории
            const itemClosing = (data.categories || []).reduce((catSum, category) => {
                const categoryWorks = category.works || [];
                if (categoryWorks.length > 0) {
                    const categoryClosing = categoryWorks.reduce((workSum, work) => {
                        return workSum + (Number(work.closing || 0));
                    }, 0);
                    return catSum + categoryClosing;
                } else {
                    return catSum + (Number(category.closing || 0));
                }
            }, 0);
            return total + itemClosing;
        }, 0);

    return (
        <td colSpan={columns.filter(col => visibleColumns[col.id]).reduce((a, v) => a + (v.colSpan || 1), 0)} style={{
            backgroundColor: darkMode ? '#1a1a1a' : '#f0f0f0',
            color: darkMode ? '#64b5f6' : '#1976d2',
            fontWeight: 600,
            fontSize: '0.9rem',
            padding: '2px 16px',
            borderBottom: darkMode
                ? '2px solid rgba(255, 255, 255, 0.12)'
                : '2px solid rgba(0, 0, 0, 0.12)',
            borderTop: darkMode
                ? '2px solid rgba(255, 255, 255, 0.12)'
                : '2px solid rgba(0, 0, 0, 0.12)',
        }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/* Кнопка создания объекта в группе */}
                    {user.roles?.includes('project_manager') && (
                        <Button
                            variant="contained"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleOpenCreateDialog(groupKdpId)}
                            sx={{
                                bgcolor: '#4caf50',
                                color: 'white',
                                px: 1.5,
                                py: 0.2,
                                textTransform: 'none',
                                fontSize: '0.7rem',
                                fontWeight: 600,
                                borderRadius: 1.5,
                                boxShadow: '0 2px 4px rgba(76, 175, 80, 0.3)',
                                '&:hover': {
                                    bgcolor: '#388e3c',
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 4px 8px rgba(76, 175, 80, 0.4)'
                                },
                                transition: 'all 0.2s ease',
                            }}
                        >
                            Добавить
                        </Button>
                    )}
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        Проект: {groupName}
                    </Typography>
                </Box>

                {(visibleColumns['closing'] || visibleColumns['cost']) && (
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>

                        {visibleColumns['closing'] &&
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Chip
                                    label={`Закрытие: ${new Intl.NumberFormat('ru-RU', {
                                        style: 'currency',
                                        currency: 'RUB',
                                    }).format(groupClosing || 0)}`}
                                    size="small"
                                    onClick={() => { }}
                                    sx={{
                                        bgcolor: darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)',
                                        color: darkMode ? '#ff8f00' : '#e65100',
                                        fontWeight: 500,
                                        fontSize: '0.75rem',
                                        border: `1px solid ${darkMode ? '#ff8f00' : '#e65100'}30`,
                                        height: 'auto',
                                        minHeight: '24px',
                                        maxWidth: '100%',
                                        cursor: 'auto',
                                        '&:hover': {
                                            bgcolor: darkMode ? 'rgba(255, 143, 0, 0.3)' : 'rgba(230, 81, 0, 0.2)',
                                            transform: 'scale(1.02)',
                                        },
                                        transition: 'all 0.2s ease',
                                        '& .MuiChip-label': {
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            textAlign: 'center',
                                            lineHeight: '1.2',
                                            padding: '4px 8px',
                                        },
                                    }}
                                />



                            </Box>
                        }

                        {visibleColumns['cost'] &&
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Chip
                                    label={`Стоимость: ${new Intl.NumberFormat('ru-RU', {
                                        style: 'currency',
                                        currency: 'RUB',
                                    }).format(groupCost || 0)}`}
                                    size="small"
                                    onClick={() => { }}
                                    sx={{
                                        bgcolor: darkMode ? 'rgba(233, 30, 99, 0.2)' : 'rgba(194, 24, 91, 0.1)',
                                        color: darkMode ? '#e91e63' : '#c2185b',
                                        fontWeight: 500,
                                        fontSize: '0.75rem',
                                        border: `1px solid ${darkMode ? '#e91e63' : '#c2185b'}30`,
                                        height: 'auto',
                                        minHeight: '24px',
                                        maxWidth: '100%',
                                        cursor: 'auto',
                                        '&:hover': {
                                            bgcolor: darkMode ? 'rgba(233, 30, 99, 0.3)' : 'rgba(194, 24, 91, 0.2)',
                                            transform: 'scale(1.02)',
                                        },
                                        transition: 'all 0.2s ease',
                                        '& .MuiChip-label': {
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            textAlign: 'center',
                                            lineHeight: '1.2',
                                            padding: '4px 8px',
                                        },
                                    }}
                                />



                            </Box>
                        }

                    </Box>
                )}

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {/* Chip с количеством объектов */}
                    <Chip
                        label={`${groupCount}`}
                        size="small"
                        onClick={() => { }}
                        sx={{
                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.1)',
                            color: darkMode ? '#64b5f6' : '#1976d2',
                            fontSize: '0.7rem',
                            fontWeight: 600,
                            border: `1px solid ${darkMode ? 'rgba(100, 181, 246, 0.3)' : 'rgba(25, 118, 210, 0.3)'}`,
                        }}
                    />


                </Box>
            </Box>
        </td>
    );
}

// const fieldColors = {
//     name: { light: '#2e7d32', dark: '#4caf50' },
//     dates: { light: '#1976d2', dark: '#64b5f6' },
//     stage: { light: '#6a1b9a', dark: '#ab47bc' },
//     responsible: { light: '#d32f2f', dark: '#f44336' },
//     coexecutors: { light: '#f57c00', dark: '#ffb74d' },
//     equipment: { light: '#3949ab', dark: '#5c6bc0' },
//     closing: { light: '#e65100', dark: '#ff8f00' },
//     cost: { light: '#c2185b', dark: '#e91e63' },
//     closing: { light: '#e65100', dark: '#ff8f00' },
//     comment: { light: '#1565c0', dark: '#2196f3' },
//     name_by_acts: { light: '#1565c0', dark: '#2196f3' },
// };

// Функция для генерации цвета чипа этапа в зависимости от номера этапа
const getStageColor = (stageNumber, darkMode) => {
    // if (!stageNumber || stageNumber === '') return null;

    const num = parseInt(stageNumber || 0);
    if (isNaN(num)) return null;

    // Базовые цвета (синий как основа для лучшей генерации оттенков)
    const baseColors = {
        light: { bg: 'rgba(33, 150, 243, 0.1)', text: '#1976d2', hover: 'rgba(33, 150, 243, 0.2)' },
        dark: { bg: 'rgba(100, 181, 246, 0.2)', text: '#64b5f6', hover: 'rgba(100, 181, 246, 0.3)' }
    };

    const colors = darkMode ? baseColors.dark : baseColors.light;

    // Плавный переход по цветовой палитре с меньшим шагом
    const hueShift = ((num - 1) * 20) % 360; // шаг 20° для плавного перехода
    const saturationModifier = 0.8 + (num % 2) * 0.1; // небольшое изменение насыщенности
    const lightnessModifier = 0.85 + (num % 2) * 0.1; // небольшое изменение яркости

    // Конвертируем hex в HSL для модификации
    const hexToHsl = (hex) => {
        const r = parseInt(hex.slice(1, 3), 16) / 255;
        const g = parseInt(hex.slice(3, 5), 16) / 255;
        const b = parseInt(hex.slice(5, 7), 16) / 255;

        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h, s, l = (max + min) / 2;

        if (max === min) {
            h = s = 0;
        } else {
            const d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h /= 6;
        }

        return { h: h * 360, s: s * 100, l: l * 100 };
    };

    const hslToRgb = (h, s, l) => {
        h /= 360;
        s /= 100;
        l /= 100;

        const hue2rgb = (p, q, t) => {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };

        let r, g, b;
        if (s === 0) {
            r = g = b = l;
        } else {
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }

        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255)
        };
    };

    // Получаем HSL базового цвета текста
    const baseHsl = hexToHsl(colors.text);

    // Применяем модификации с более сильными изменениями
    const modifiedH = (baseHsl.h + hueShift + 360) % 360;
    const modifiedS = Math.min(100, Math.max(20, baseHsl.s * saturationModifier)); // ограничиваем от 20% до 100%
    const modifiedL = Math.min(90, Math.max(30, baseHsl.l * lightnessModifier)); // ограничиваем от 30% до 90%

    // Конвертируем обратно в RGB
    const modifiedRgb = hslToRgb(modifiedH, modifiedS, modifiedL);

    // Генерируем цвета фона с прозрачностью
    const bgAlpha = darkMode ? 0.25 : 0.15; // увеличиваем прозрачность для лучшей видимости
    const hoverAlpha = darkMode ? 0.35 : 0.25;

    return {
        bgcolor: `rgba(${modifiedRgb.r}, ${modifiedRgb.g}, ${modifiedRgb.b}, ${bgAlpha})`,
        color: `rgb(${modifiedRgb.r}, ${modifiedRgb.g}, ${modifiedRgb.b})`,
        hoverBgcolor: `rgba(${modifiedRgb.r}, ${modifiedRgb.g}, ${modifiedRgb.b}, ${hoverAlpha})`
    };
};

// const EditableSelectCell = ({ id, field, value, label, saveEditedField, darkMode, options, multiple = false, equipment, categoryUuid, workId }) => {
//     // Определяем цвета в зависимости от поля
//     const getFieldColors = (field) => {
//         switch (field) {
//             case 'responsible':
//                 return {
//                     bgcolor: darkMode ? 'rgba(211, 47, 47, 0.2)' : 'rgba(211, 47, 47, 0.1)',
//                     color: darkMode ? '#f44336' : '#d32f2f',
//                     selectedBg: darkMode ? 'rgba(211, 47, 47, 0.2)' : 'rgba(211, 47, 47, 0.1)',
//                 };
//             case 'coexecutors':
//                 return {
//                     bgcolor: darkMode ? 'rgba(245, 124, 0, 0.2)' : 'rgba(245, 124, 0, 0.1)',
//                     color: darkMode ? '#ffb74d' : '#f57c00',
//                     selectedBg: darkMode ? 'rgba(245, 124, 0, 0.2)' : 'rgba(245, 124, 0, 0.1)',
//                 };
//             case 'equipment':
//                 return {
//                     bgcolor: darkMode ? 'rgba(92, 107, 192, 0.2)' : 'rgba(57, 73, 171, 0.1)',
//                     color: darkMode ? '#5c6bc0' : '#3949ab',
//                     selectedBg: darkMode ? 'rgba(92, 107, 192, 0.2)' : 'rgba(57, 73, 171, 0.1)',
//                 };
//             case 'stage':
//                 return {
//                     bgcolor: darkMode ? 'rgba(171, 71, 188, 0.2)' : 'rgba(106, 27, 154, 0.1)',
//                     color: darkMode ? '#ab47bc' : '#6a1b9a',
//                     selectedBg: darkMode ? 'rgba(171, 71, 188, 0.2)' : 'rgba(106, 27, 154, 0.1)',
//                 };
//             case 'closing':
//                 return {
//                     bgcolor: darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)',
//                     color: darkMode ? '#ff8f00' : '#e65100',
//                     selectedBg: darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)',
//                 };
//             case 'cost':
//                 return {
//                     bgcolor: darkMode ? 'rgba(233, 30, 99, 0.2)' : 'rgba(194, 24, 91, 0.1)',
//                     color: darkMode ? '#e91e63' : '#c2185b',
//                     selectedBg: darkMode ? 'rgba(233, 30, 99, 0.2)' : 'rgba(194, 24, 91, 0.1)',
//                 };
//             case 'closing':
//                 return {
//                     bgcolor: darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)',
//                     color: darkMode ? '#ff8f00' : '#e65100',
//                     selectedBg: darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)',
//                 };
//             case 'comment':
//             case 'name_by_acts':
//                 return {
//                     bgcolor: darkMode ? 'rgba(33, 150, 243, 0.2)' : 'rgba(21, 101, 192, 0.1)',
//                     color: darkMode ? '#2196f3' : '#1565c0',
//                     selectedBg: darkMode ? 'rgba(33, 150, 243, 0.2)' : 'rgba(21, 101, 192, 0.1)',
//                 };
//             default:
//                 return {
//                     bgcolor: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.1)',
//                     color: darkMode ? '#ce93d8' : '#9c27b0',
//                     selectedBg: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.1)',
//                 };
//         }
//     };

//     const fieldColors = getFieldColors(field);
//     const [localValue, setLocalValue] = useState(value || (multiple ? [] : null));
//     const [inputValue, setInputValue] = useState('');

//     const handleChange = (event, newValue) => {
//         console.log(event, newValue)
//         setLocalValue(newValue);
//     };

//     const saveEditedEquipment = useCallback((newValue, deleted = null) => {
//         saveEditedField({
//             rowId: id,
//             field: field,
//             value: newValue,
//             isValueChanged: JSON.stringify(value) !== JSON.stringify(newValue),
//             shouldExitEditMode: false,
//             deleted: deleted
//         });

//     }, [])


//     const handleInputChange = (event, newInputValue) => {
//         console.log(newInputValue)
//         setInputValue(newInputValue);
//     };

//     const handleBlur = () => {

//         saveEditedField({
//             rowId: id,
//             field: field,
//             value: multiple ? localValue.map(v => v?.id || v || null) : (localValue?.id || localValue || null),
//             isValueChanged: JSON.stringify(value) !== JSON.stringify(localValue),
//             shouldExitEditMode: false,
//             equipment: equipment,
//             categoryUuid: categoryUuid,
//             workId: workId,
//         });


//     };

//     const handleClear = () => {
//         setLocalValue(multiple ? [] : null);
//     };

//     const handleSave = () => {
//         handleBlur();
//     };

//     const getOptionLabel = (option) => {
//         return option?.name || option?.display_name || String(option || '');
//     };

//     const isOptionEqualToValue = (option, value) => {
//         return option?.id === value?.id;
//     };

//     return (
//         <Autocomplete
//             data-editing-cell="true"
//             value={localValue}
//             onChange={handleChange}
//             inputValue={inputValue}
//             onInputChange={handleInputChange}
//             onBlur={handleBlur}
//             options={options || []}
//             getOptionLabel={getOptionLabel}
//             isOptionEqualToValue={isOptionEqualToValue}
//             multiple={multiple}

//             size="small"
//             autoFocus
//             freeSolo
//             disableClearable={true}
//             // clearOnBlur={false}
//             selectOnFocus
//             handleHomeEndKeys
//             disableCloseOnSelect={multiple}
//             renderInput={(params) => (
//                 <TextField
//                     {...params}
//                     placeholder={label}
//                     size="small"
//                     rows={multiple ? 3 : 1}
//                     // InputProps={{
//                     //     ...params.InputProps,
//                     //     endAdornment: (
//                     //         <Box sx={{
//                     //             position: multiple ? 'absolute' : '',

//                     //             bottom: '5px',
//                     //             right: '10px',
//                     //             display: 'flex',
//                     //             alignItems: 'center',
//                     //             gap: 0.5
//                     //         }}>
//                     //             {multiple && localValue.length > 0 && (
//                     //                 <IconButton
//                     //                     size="small"
//                     //                     onClick={(e) => {
//                     //                         e.stopPropagation();
//                     //                         handleClear();
//                     //                     }}
//                     //                     edge="end"
//                     //                     tabIndex={-1}
//                     //                     sx={{
//                     //                         color: darkMode ? '#f44336' : '#d32f2f',
//                     //                         p: 0.3,
//                     //                         '&:hover': {
//                     //                             bgcolor: darkMode ? 'rgba(244, 67, 54, 0.1)' : 'rgba(211, 47, 47, 0.1)',
//                     //                         },
//                     //                     }}
//                     //                 >
//                     //                     <ClearIcon fontSize="small" />
//                     //                 </IconButton>
//                     //             )}
//                     //             <IconButton
//                     //                 size="small"
//                     //                 onClick={(e) => {
//                     //                     e.stopPropagation();
//                     //                     handleSave();
//                     //                 }}
//                     //                 edge="end"
//                     //                 tabIndex={-1}
//                     //                 sx={{
//                     //                     color: darkMode ? '#4caf50' : '#2e7d32',
//                     //                     p: 0.3,
//                     //                     '&:hover': {
//                     //                         bgcolor: darkMode ? 'rgba(76, 175, 80, 0.1)' : 'rgba(46, 125, 50, 0.1)',
//                     //                     }
//                     //                 }}
//                     //             >
//                     //                 <SaveIcon fontSize="small" />
//                     //             </IconButton>
//                     //         </Box>
//                     //     ),
//                     // }}
//                     sx={{
//                         '& .MuiOutlinedInput-input': {

//                             cursor: 'text',
//                             color: darkMode ? '#ffffff' : '#333',
//                             fontSize: '0.875rem',
//                             width: 'fit-content !important',
//                         },
//                         '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                             borderColor: fieldColors.color,
//                             borderWidth: '2px',
//                         },
//                         '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
//                             borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
//                         },
//                         '& .MuiInputLabel-root': {
//                             color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
//                             fontSize: '0.875rem',
//                             '&.Mui-focused': {
//                                 color: fieldColors.color,
//                             }
//                         },
//                         '& .MuiOutlinedInput-notchedOutline': {
//                             borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
//                             borderRadius: '4px',
//                         },
//                         bgcolor: darkMode ? '#2b2b2b' : '#fff',
//                         '& .MuiInputBase-root': {
//                             p: '5px !important',
//                             borderRadius: '4px',
//                         },
//                         '& .MuiInputBase-input': {

//                             fontWeight: 500,
//                             fontSize: '0.8rem',
//                             borderRadius: '4px',
//                         },
//                     }}
//                 />
//             )}
//             renderOption={(props, option) => (
//                 <Box component="li" {...props}>
//                     <Typography variant="body2">
//                         {getOptionLabel(option)}
//                     </Typography>
//                 </Box>
//             )}
//             renderTags={(tagValue, getTagProps) =>
//                 tagValue.map((option, index) => (
//                     <Chip
//                         {...getTagProps({ index })}
//                         key={option.id}
//                         label={getOptionLabel(option)}
//                         onClick={() => { }}
//                         size="small"
//                         sx={{
//                             bgcolor: fieldColors.bgcolor,
//                             color: fieldColors.color,
//                             fontSize: '0.7rem',
//                             height: 'auto',
//                             minHeight: '20px',
//                             '& .MuiChip-label': {
//                                 whiteSpace: 'normal',
//                                 wordBreak: 'break-word',
//                                 textAlign: 'center',
//                                 lineHeight: '1.2',
//                                 padding: '2px 6px',
//                             },
//                         }}
//                     />
//                 ))
//             }
//             sx={{
//                 '& .MuiAutocomplete-popper': {
//                     zIndex: 1300,
//                 },
//                 '& .MuiAutocomplete-paper': {
//                     bgcolor: darkMode ? '#2b2b2b' : '#fff',
//                     border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
//                     '& .MuiAutocomplete-option': {
//                         color: darkMode ? '#f5f7fa' : '#333',
//                         '&:hover': {
//                             bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
//                         },
//                         '&[aria-selected="true"]': {
//                             bgcolor: fieldColors.selectedBg,
//                         },
//                     },
//                 },
//             }}
//         />
//     );
// };

// const EditableNumberCell = ({ id, field, value, label, saveEditedField, darkMode, equipment, categoryUuid, workId }) => {
//     console.log(id, field, value, label, saveEditedField, darkMode, equipment)
//     // Определяем цвета в зависимости от поля
//     const getFieldColors = (field) => {
//         switch (field) {
//             case 'stage':
//                 return {
//                     color: darkMode ? '#ab47bc' : '#6a1b9a',
//                 };
//             case 'closing':
//                 return {
//                     color: darkMode ? '#ff8f00' : '#e65100',
//                 };
//             case 'cost':
//                 return {
//                     color: darkMode ? '#e91e63' : '#c2185b',
//                 };
//             case 'fid':
//                 return {
//                     color: darkMode ? '#1976d2' : '#1976d2',
//                 };
//             default:
//                 return {
//                     color: darkMode ? '#9c27b0' : '#9c27b0',
//                 };
//         }
//     };

//     const fieldColors = getFieldColors(field);
//     // Инициализируем localValue с учетом типа поля
//     const [localValue, setLocalValue] = useState(() => {
//         if (field === 'closing' || field === 'cost') {
//             // Для вещественных чисел отображаем с двумя знаками после запятой
//             return value !== null && value !== undefined ? parseFloat(value).toFixed(2) : '';
//         }
//         if (field === 'stage') {
//             // Для этапа отображаем с одним знаком после запятой или как целое число
//             if (value !== null && value !== undefined) {
//                 const numValue = parseFloat(value);
//                 if (!isNaN(numValue)) {
//                     // Если число целое, отображаем без десятичной части
//                     if (numValue % 1 === 0) {
//                         return String(numValue);
//                     }
//                     // Иначе отображаем с одним знаком после запятой
//                     return numValue.toFixed(1);
//                 }
//             }
//             return '';
//         }
//         return value || '';
//     });

//     const handleNumberChange = (e) => {
//         const inputValue = e.target.value;

//         // Для полей closing и cost разрешаем вещественные числа с двумя знаками после запятой
//         if (field === 'closing' || field === 'cost') {
//             // Разрешаем цифры, точку, запятую и пустую строку
//             // Также разрешаем формат с двумя знаками после запятой
//             if (inputValue === '' || /^[\d.,]+$/.test(inputValue)) {
//                 // Заменяем запятую на точку для корректной обработки
//                 const normalizedValue = inputValue.replace(',', '.');
//                 // Проверяем, что после точки не более двух цифр и нет множественных точек
//                 if (normalizedValue === '' || /^\d*\.?\d{0,2}$/.test(normalizedValue)) {
//                     // Дополнительная проверка на множественные точки
//                     const dotCount = (normalizedValue.match(/\./g) || []).length;
//                     if (dotCount <= 1) {
//                         setLocalValue(inputValue);
//                     }
//                 }
//             }
//         } else if (field === 'stage') {
//             // Для поля stage разрешаем целые числа или числа с одним знаком после запятой
//             if (inputValue === '' || /^[\d.,]+$/.test(inputValue)) {
//                 // Заменяем запятую на точку для корректной обработки
//                 const normalizedValue = inputValue.replace(',', '.');
//                 // Проверяем, что после точки не более одной цифры и нет множественных точек
//                 if (normalizedValue === '' || /^\d*\.?\d{0,1}$/.test(normalizedValue)) {
//                     // Дополнительная проверка на множественные точки
//                     const dotCount = (normalizedValue.match(/\./g) || []).length;
//                     if (dotCount <= 1) {
//                         setLocalValue(inputValue);
//                     }
//                 }
//             }
//         } else {
//             // Для остальных полей оставляем только целые числа
//             if (inputValue === '' || /^\d+$/.test(inputValue)) {
//                 setLocalValue(inputValue);
//             }
//         }
//     };

//     const handleBlur = () => {
//         console.log(value, localValue)
//         let numericValue;

//         if (field === 'closing' || field === 'cost') {
//             // Для вещественных чисел парсим как float
//             numericValue = localValue ? parseFloat(localValue.replace(',', '.')) : value;
//             // Округляем до двух знаков после запятой
//             numericValue = isNaN(numericValue) ? value : Math.round(numericValue * 100) / 100;

//             // Если значение некорректное, восстанавливаем исходное
//             if (isNaN(numericValue)) {
//                 setLocalValue(formatDisplayValue(value));
//                 return;
//             }
//         } else if (field === 'stage') {
//             // Для поля stage парсим как float и округляем до одного знака после запятой
//             numericValue = localValue ? parseFloat(localValue.replace(',', '.')) : value;
//             // Округляем до одного знака после запятой
//             numericValue = isNaN(numericValue) ? value : Math.round(numericValue * 10) / 10;

//             // Если значение некорректное, восстанавливаем исходное
//             if (isNaN(numericValue)) {
//                 if (value !== null && value !== undefined) {
//                     const numValue = parseFloat(value);
//                     if (!isNaN(numValue)) {
//                         if (numValue % 1 === 0) {
//                             setLocalValue(String(numValue));
//                         } else {
//                             setLocalValue(numValue.toFixed(1));
//                         }
//                     } else {
//                         setLocalValue('');
//                     }
//                 } else {
//                     setLocalValue('');
//                 }
//                 return;
//             }
//         } else {
//             // Для остальных полей парсим как целое число
//             numericValue = localValue ? parseInt(localValue, 10) : value;

//             // Если значение некорректное, восстанавливаем исходное
//             if (isNaN(numericValue)) {
//                 setLocalValue(value || '');
//                 return;
//             }
//         }


//         saveEditedField({
//             rowId: id,
//             field: field,
//             value: numericValue,
//             isValueChanged: (value || '') !== localValue,
//             equipment: equipment,
//             categoryUuid: categoryUuid,
//             workId: workId,
//         });


//     };

//     const handleClear = () => {
//         setLocalValue('');
//     };

//     // Функция для форматирования значения при отображении
//     const formatDisplayValue = (val) => {
//         if (field === 'closing' || field === 'cost') {
//             // Для вещественных чисел форматируем с двумя знаками после запятой
//             return val !== null && val !== undefined ? parseFloat(val).toFixed(2) : '';
//         }
//         if (field === 'stage') {
//             // Для этапа форматируем с одним знаком после запятой или как целое число
//             if (val !== null && val !== undefined) {
//                 const numValue = parseFloat(val);
//                 if (!isNaN(numValue)) {
//                     // Если число целое, отображаем без десятичной части
//                     if (numValue % 1 === 0) {
//                         return String(numValue);
//                     }
//                     // Иначе отображаем с одним знаком после запятой
//                     return numValue.toFixed(1);
//                 }
//             }
//             return '';
//         }
//         return val || '';
//     };

//     const handleSave = () => {
//         handleBlur();
//     };

//     // Обработка нажатия Enter
//     const handleKeyPress = (e) => {
//         if (e.key === 'Enter') {
//             handleBlur();
//         }
//     };

//     return (
//         <TextField
//             data-editing-cell="true"
//             fullWidth
//             size="small"
//             value={localValue}
//             onChange={handleNumberChange}
//             onBlur={handleBlur}
//             onKeyPress={handleKeyPress}
//             // placeholder={field === 'closing' || field === 'cost' ? '0.00' : label}
//             autoFocus
//             // InputProps={{
//             //     endAdornment: (
//             //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//             //             {localValue && (
//             //                 <IconButton
//             //                     size="small"
//             //                     onClick={(e) => {
//             //                         e.stopPropagation();
//             //                         handleClear();
//             //                     }}
//             //                     edge="end"
//             //                     tabIndex={-1}
//             //                     sx={{
//             //                         color: darkMode ? '#f44336' : '#d32f2f',
//             //                         p: 0.1,
//             //                         '&:hover': {
//             //                             bgcolor: darkMode ? 'rgba(244, 67, 54, 0.1)' : 'rgba(211, 47, 47, 0.1)',
//             //                         },
//             //                     }}
//             //                 >
//             //                     <ClearIcon fontSize="small" />
//             //                 </IconButton>
//             //             )}
//             //             <IconButton
//             //                 size="small"
//             //                 onClick={(e) => {
//             //                     e.stopPropagation();
//             //                     handleSave();
//             //                 }}
//             //                 edge="end"
//             //                 tabIndex={-1}
//             //                 sx={{
//             //                     color: darkMode ? '#4caf50' : '#2e7d32',
//             //                     p: 0.1,
//             //                     '&:hover': {
//             //                         bgcolor: darkMode ? 'rgba(76, 175, 80, 0.1)' : 'rgba(46, 125, 50, 0.1)',
//             //                     }
//             //                 }}
//             //             >
//             //                 <SaveIcon fontSize="small" />
//             //             </IconButton>
//             //         </Box>
//             //     ),
//             // }}
//             sx={{
//                 '& .MuiOutlinedInput-input': {
//                     p: '5px',
//                     cursor: 'text',
//                     color: darkMode ? '#ffffff' : '#333',
//                     fontSize: '0.875rem',
//                 },
//                 '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                     borderColor: fieldColors.color,
//                     borderWidth: '2px',
//                 },
//                 '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
//                     borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
//                 },
//                 '& .MuiInputLabel-root': {
//                     color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
//                     fontSize: '0.875rem',
//                     '&.Mui-focused': {
//                         color: fieldColors.color,
//                     }
//                 },
//                 '& .MuiOutlinedInput-notchedOutline': {
//                     borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
//                     borderRadius: '4px',
//                 },
//                 bgcolor: darkMode ? '#2b2b2b' : '#fff',
//                 '& .MuiInputBase-root': {
//                     fontWeight: 500,
//                     fontSize: '0.8rem',
//                     borderRadius: '4px',
//                     minWidth: '60px',
//                     // width: '100%'
//                 },
//                 '& .MuiInputBase-input': {
//                     borderRadius: '4px',
//                 },
//             }}
//         />
//     );
// };

// const EditableTextAreaCell = ({ id, field, value, label, saveEditedField, darkMode, focusIndex, categoryUuid, workId }) => {
//     // Определяем цвета в зависимости от поля
//     const getFieldColors = (field) => {
//         switch (field) {
//             case 'comment':
//             case 'name_by_acts':
//                 return {
//                     color: darkMode ? '#2196f3' : '#1565c0',
//                 };
//             case 'closing':
//                 return {
//                     color: darkMode ? '#ff8f00' : '#e65100',
//                 };
//             case 'cost':
//                 return {
//                     color: darkMode ? '#e91e63' : '#c2185b',
//                 };
//             default:
//                 return {
//                     color: darkMode ? '#1976d2' : '#1976d2',
//                 };
//         }
//     };

//     const fieldColors = getFieldColors(field);
//     const [localValue, setLocalValue] = useState(value);

//     const handleTextChange = (e, index) => {
//         if (Array.isArray(localValue)) {
//             const newArray = [...localValue];
//             newArray[index] = e.target.value;

//             setLocalValue(newArray);
//         } else {
//             setLocalValue(e.target.value);
//         }
//     };

//     const handleBlur = () => {
//         console.log(value, localValue)
//         saveEditedField({
//             rowId: id,
//             field: field,
//             value: localValue,
//             isValueChanged: value !== localValue,
//             shouldExitEditMode: false, // Не выходим из режима редактирования при blur
//             categoryUuid: categoryUuid,
//             workId: workId,
//         });
//     };

//     return (
//         <Box data-editing-cell="true" sx={{ display: 'grid', gridAutoRows: '1fr', flex: 1, alignItems: 'center', gap: 0.5, height: '100%' }}>
//             {(Array.isArray(localValue) ? localValue : [localValue]).map((value, index) => (
//                 <TextField
//                     multiline
//                     rows={10}
//                     size="small"
//                     value={value || ''}
//                     onChange={(e) => handleTextChange(e, index)}
//                     onBlur={handleBlur}
//                     autoFocus
//                     data-editing="true"
//                     placeholder={field === 'comment' || field === 'name_by_acts' ? 'Markdown поддерживается: **жирный**, *курсив*, # заголовок' : ''}
//                     sx={{
//                         minWidth: '100px',
//                         '& .MuiOutlinedInput-input': {
//                             p: '0px',
//                             cursor: 'text',
//                             color: darkMode ? '#ffffff' : '#333',
//                             fontSize: '0.8rem',
//                             lineHeight: '1.1',
//                         },
//                         '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                             borderColor: fieldColors.color,
//                             borderWidth: '2px',
//                         },
//                         '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
//                             borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
//                         },
//                         '& .MuiInputLabel-root': {
//                             color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
//                             fontSize: '0.8rem',
//                             '&.Mui-focused': {
//                                 color: fieldColors.color,
//                             }
//                         },
//                         '& .MuiOutlinedInput-notchedOutline': {
//                             borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
//                             borderRadius: '4px',
//                         },
//                         bgcolor: darkMode ? '#2b2b2b' : '#fff',
//                         '& .MuiInputBase-root': {
//                             fontWeight: 500,
//                             fontSize: '0.8rem',
//                             borderRadius: '4px',
//                             minWidth: '120px',
//                             width: '120px'
//                         },
//                         '& .MuiInputBase-input': {
//                             borderRadius: '4px',
//                         },
//                     }}
//                 />
//             ))}
//             {Array.isArray(localValue) && localValue.length > 1 &&
//                 <Box></Box>
//             }
//         </Box>
//     );
// };

// const EditableDateCell = ({ id, field, value, label, saveEditedField, darkMode, equipment, categoryUuid, workId }) => {
//     // Определяем цвета в зависимости от поля
//     const getFieldColors = (field) => {
//         switch (field) {
//             case 'plan_start':
//             case 'fact_start':
//             case 'plan_end':
//             case 'fact_end':
//                 return {
//                     color: darkMode ? '#64b5f6' : '#1976d2',
//                 };
//             case 'closing':
//                 return {
//                     color: darkMode ? '#ff8f00' : '#e65100',
//                 };
//             case 'cost':
//                 return {
//                     color: darkMode ? '#e91e63' : '#c2185b',
//                 };
//             case 'comment':
//                 return {
//                     color: darkMode ? '#4caf50' : '#2e7d32',
//                 };
//             default:
//                 return {
//                     color: darkMode ? '#1976d2' : '#1976d2',
//                 };
//         }
//     };

//     const fieldColors = getFieldColors(field);
//     const [localValue, setLocalValue] = useState(value)

//     // Преобразуем строку даты в объект Date для DatePicker
//     const getDateFromString = (dateString) => {
//         if (!dateString) return null;
//         try {
//             // Если дата в формате "YYYY-MM-DD" (из базы данных)
//             if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
//                 return new Date(dateString);
//             }

//             // Если дата в формате "HH:MM DD-MM-YYYY"
//             const dateTimeMatch = dateString.match(/^(\d{2}):(\d{2})\s(\d{2})-(\d{2})-(\d{4})$/);
//             if (dateTimeMatch) {
//                 const [, hours, minutes, day, month, year] = dateTimeMatch;
//                 return new Date(`${year}-${month}-${day}`);
//             }

//             // Если дата в формате "DD-MM-YYYY"  
//             const dateMatch = dateString.match(/^(\d{2})-(\d{2})-(\d{4})$/);
//             if (dateMatch) {
//                 const [, day, month, year] = dateMatch;
//                 return new Date(`${year}-${month}-${day}`);
//             }

//             // Попытка парсинга как обычной даты
//             const date = new Date(dateString);
//             return isNaN(date.getTime()) ? null : date;
//         } catch {
//             return null;
//         }
//     };

//     const handleDateChange = (date) => {
//         if (date) {
//             const year = date.getFullYear();
//             const month = String(date.getMonth() + 1).padStart(2, '0');
//             const day = String(date.getDate()).padStart(2, '0');
//             const formattedDate = `${year}-${month}-${day}`;
//             setLocalValue(formattedDate);
//         } else {
//             setLocalValue('');
//         }
//     };

//     const handleBlur = () => {
//         saveEditedField({
//             rowId: id,
//             field: field,
//             value: localValue,
//             isValueChanged: value !== localValue,
//             shouldExitEditMode: false,
//             equipment: equipment,
//             categoryUuid: categoryUuid,
//             workId: workId,
//         });
//     };

//     return (
//         <Box data-editing-cell="true" sx={{ position: 'relative' }}>
//             {(() => {
//                 try {
//                     return (
//                         <DatePicker
//                             selected={getDateFromString(localValue)}
//                             // onCalendarClose={handleDateChange}
//                             onChange={handleDateChange}
//                             onBlur={handleBlur}
//                             onCalendarClose={handleBlur}
//                             // onClickOutside={handleBlur}

//                             locale="ru"
//                             dateFormat="dd.MM.yyyy"
//                             // placeholderText={label}
//                             autoFocus
//                             // shouldCloseOnSelect={false}

//                             // isClearable
//                             showYearDropdown
//                             showMonthDropdown
//                             dropdownMode="select"
//                             yearDropdownItemNumber={10}
//                             scrollableYearDropdown
//                             autoComplete="off"
//                             customInput={
//                                 <TextField
//                                     // fullWidth
//                                     // label={label}
//                                     size="small"
//                                     // variant="standard"
//                                     // InputProps={{
//                                     //     endAdornment: (
//                                     //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                                     //             {localValue && (
//                                     //                 <IconButton
//                                     //                     size="small"
//                                     //                     onClick={e => {
//                                     //                         e.stopPropagation();
//                                     //                         setLocalValue('');
//                                     //                     }}
//                                     //                     edge="end"
//                                     //                     tabIndex={-1}
//                                     //                     sx={{
//                                     //                         color: darkMode ? '#f44336' : '#d32f2f',
//                                     //                         p: 0.1,
//                                     //                         '&:hover': {
//                                     //                             bgcolor: darkMode ? 'rgba(244, 67, 54, 0.1)' : 'rgba(211, 47, 47, 0.1)',
//                                     //                         },
//                                     //                     }}
//                                     //                 >
//                                     //                     <ClearIcon fontSize="small" />
//                                     //                 </IconButton>
//                                     //             )}
//                                     //             <IconButton
//                                     //                 size="small"
//                                     //                 onClick={e => {
//                                     //                     e.stopPropagation();
//                                     //                     handleBlur();
//                                     //                 }}
//                                     //                 edge="end"
//                                     //                 tabIndex={-1}
//                                     //                 sx={{
//                                     //                     color: darkMode ? '#4caf50' : '#2e7d32',
//                                     //                     p: 0.1,
//                                     //                     '&:hover': {
//                                     //                         bgcolor: darkMode ? 'rgba(76, 175, 80, 0.1)' : 'rgba(46, 125, 50, 0.1)',
//                                     //                     }
//                                     //                 }}
//                                     //             >
//                                     //                 <SaveIcon fontSize="small" />
//                                     //             </IconButton>
//                                     //         </Box>
//                                     //     ),
//                                     // }}
//                                     sx={{
//                                         '& .MuiOutlinedInput-input': {
//                                             p: '5px',
//                                             cursor: 'pointer',
//                                             color: darkMode ? '#ffffff' : '#333',
//                                             fontSize: '0.875rem',
//                                         },
//                                         '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                                             borderColor: fieldColors.color,
//                                             borderWidth: '2px',
//                                         },
//                                         '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
//                                             borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
//                                         },
//                                         '& .MuiInputLabel-root': {
//                                             color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
//                                             fontSize: '0.875rem',
//                                             '&.Mui-focused': {
//                                                 color: fieldColors.color,
//                                             }
//                                         },
//                                         '& .MuiOutlinedInput-notchedOutline': {
//                                             borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
//                                             borderRadius: '4px',
//                                         },
//                                         bgcolor: darkMode ? '#2b2b2b' : '#fff',
//                                         '& .MuiInputBase-root': {
//                                             // pr: 0,
//                                             fontWeight: 500,
//                                             fontSize: '0.8rem',
//                                             borderRadius: '4px',
//                                             // minWidth: '140px',
//                                             width: '90px'
//                                         },
//                                         '& .MuiInputBase-input': {
//                                             borderRadius: '4px',
//                                         },
//                                     }}
//                                 />
//                             }
//                             calendarClassName={darkMode ? 'dark-datepicker' : 'light-datepicker'}
//                         />
//                     );
//                 } catch (error) {
//                     console.error('DatePicker error:', error);
//                     return null;
//                 }
//             })()}
//         </Box>
//     );
// }

// Функция для открытия обзора опоры в новой вкладке
const openObjectView = (object) => {
    if (!object.coords && !object.x_y_coord) {
        console.warn('Нет координат для опоры:', object);
        return;
    }


    // Определяем тип трансформатора на основе type объекта или используем дефолтный 'transformer'
    const transformerType = object.type || 'transformer';

    // Создаем base64 строку с данными объекта
    const base64 = btoa(JSON.stringify({
        type: transformerType,
        id: object.fid,
    }));

    // Формируем URL с параметром view
    const url = `${window.location.origin}/an?view=${encodeURIComponent(base64)}`;

    // Открываем новую вкладку
    window.open(url, '_blank');
};

function rowContent(_index, row, { editMode, editing, setEditingField, openHistoryDialog, openCommentDialog, openNameByActsDialog, saveEditedField, darkMode, users, equipmentMap, equipmentTree, editedRows, selectedRows, handleRowSelection, handleOpenEditDialog, visibleColumns, handleMoveEquipment, searchQuery, advancedFilters, getColumnWidth, expandedCategories, toggleCategory, handleAddCategoryClick, handleDeleteCategory, handleAddWorkClick, handleDeleteWork, handleMoveCategoryUp, handleMoveCategoryDown, handleMoveWorkUp, handleMoveWorkDown, equipment, stages, sortBy, sortDirection }) {

    // if (!row.rowSpan) return null
    if (row.isPadding) {
        // Получаем только видимые столбцы с учетом colSpan
        const visibleColumnsArray = columns.filter(col => visibleColumns[col.id]);
        const paddingCells = [];

        visibleColumnsArray.forEach(column => {
            if (column.colSpan && column.colSpan > 1) {
                // Для столбцов с colSpan > 1 добавляем соответствующее количество ячеек
                for (let i = 0; i < column.colSpan; i++) {
                    paddingCells.push(
                        <TableCell key={`${column.id}_${i}`} sx={{ height: '1px', padding: 0, border: 'none' }} />
                    );
                }
            } else {
                // Для обычных столбцов добавляем одну ячейку
                paddingCells.push(
                    <TableCell key={column.id} sx={{ height: '1px', padding: 0, border: 'none' }} />
                );
            }
        });

        return (
            <React.Fragment>
                {paddingCells}
            </React.Fragment>
        );
    }
    const isRowEdited = editedRows[row.id];

    if (row.purpose === 'object') {
        // Получаем видимые колонки в правильном порядке из columns
        const visibleColumnsArray = columns.filter(col => visibleColumns[col.id]);

        // Подсчитываем общее количество ячеек с учетом colSpan
        const totalCellsCount = visibleColumnsArray.reduce((sum, column) => {
            return sum + (column.colSpan || 1);
        }, 0);

        // Вычисляем суммы по всем категориям для закрытия и стоимости
        const categories = row.data?.categories || [];
        const totalClosing = categories.reduce((sum, category) => {
            const categoryWorks = category.works || [];
            if (categoryWorks.length > 0) {
                const categoryClosing = categoryWorks.reduce((catSum, work) => {
                    return catSum + (Number(work.closing || 0));
                }, 0);
                return sum + categoryClosing;
            } else {
                return sum + (Number(category.closing || 0));
            }
        }, 0);
        const totalCost = categories.reduce((sum, category) => {
            const categoryWorks = category.works || [];
            if (categoryWorks.length > 0) {
                const categoryCost = categoryWorks.reduce((catSum, work) => {
                    return catSum + (Number(work.cost || 0));
                }, 0);
                return sum + categoryCost;
            } else {
                return sum + (Number(category.cost || 0));
            }
        }, 0);

        // Функция для получения значения столбца для объекта
        const getObjectColumnValue = (columnId) => {
            switch (columnId) {
                case 'fid':
                    return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, textWrap: 'nowrap', position: 'relative' }}>
                        {editMode && <Checkbox
                            checked={selectedRows.has(row.id)}
                            onChange={(e) => {
                                e.stopPropagation()
                                handleRowSelection(row.id, e.target.checked)
                            }}
                            onClick={(e) => {
                                e.stopPropagation()
                            }}
                            size="small"
                            sx={{
                                p: '2px',
                                color: darkMode ? '#64b5f6' : '#1976d2',
                                position: 'relative',
                                zIndex: 1,
                                '&.Mui-checked': {
                                    color: darkMode ? '#64b5f6' : '#1976d2',
                                },
                            }}
                        />}
                        <Typography variant="body2" sx={{
                            position: 'relative',
                            zIndex: 1, fontWeight: 600, color: darkMode ? '#f5f7fa' : '#333'
                        }}>
                            {row.fid}
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                openObjectView(row.object);
                            }}
                            sx={{
                                padding: '0 0 0 10px',
                                color: darkMode ? '#64b5f6' : '#2196F3',
                                position: 'relative',
                                zIndex: 1,
                                '&:hover': {
                                    backgroundColor: darkMode ? 'rgba(100, 181, 246, 0.15)' : 'rgba(33, 150, 243, 0.1)',
                                    color: darkMode ? '#90caf9' : '#1976D2'
                                }
                            }}
                            title="Открыть обзор опоры в новой вкладке"
                        >
                            <Box sx={{ position: 'relative', width: 32, height: 32 }}>
                                <Box style={{ position: 'absolute', margin: '5px 0 0 6px' }}>
                                    {ktpIcon('default', 20, 20)}
                                </Box>
                                {['2', '3', '4', '7'].includes(row.object?.layer) ? (
                                    <Box style={{ position: 'absolute', margin: '0 0 0 0' }}>
                                        {projectStatusOreolIcon('ktp', Number(row.object?.layer), 32)}
                                    </Box>
                                ) : null}
                            </Box>
                        </IconButton>
                        <Typography variant='body2' sx={{
                            position: 'relative',
                            zIndex: 1, fontSize: '0.85rem', color: darkMode ? '#f5f7fa' : '#333'
                        }}>
                            {row.object?.name || ''}{row.object?.town ? ` ${row.object.town}` : ''}
                        </Typography>
                        {editMode && (
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenEditDialog(row);
                                }}
                                sx={{
                                    padding: '2px',
                                    color: darkMode ? '#81c784' : '#4caf50',
                                    position: 'relative',
                                    zIndex: 1,
                                    '&:hover': {
                                        backgroundColor: darkMode ? 'rgba(129, 199, 132, 0.15)' : 'rgba(76, 175, 80, 0.1)',
                                        color: darkMode ? '#a5d6a7' : '#388e3c'
                                    }
                                }}
                                title="Редактировать объект"
                            >
                                <EditIcon sx={{ fontSize: { xs: '12px', md: '16px' } }} />
                            </IconButton>
                        )}
                        {isRowEdited && (
                            <Box
                                sx={{
                                    width: 6,
                                    height: 6,
                                    borderRadius: '50%',
                                    bgcolor: darkMode ? '#ffb74d' : '#f57c00',
                                    animation: 'pulse 2s infinite',
                                    '@keyframes pulse': {
                                        '0%': { opacity: 1 },
                                        '50%': { opacity: 0.5 },
                                        '100%': { opacity: 1 },
                                    }
                                }}
                            />
                        )}
                    </Box>;
                case 'name_by_acts':
                case 'plan_start':
                case 'fact_start':
                case 'plan_end':
                case 'fact_end':
                case 'stage':
                case 'responsible':
                case 'coexecutors':
                case 'comment':
                    return '';
                case 'closing':
                    return <Typography
                        sx={{
                            color: darkMode ? '#ff8f00' : '#e65100',
                            // bgcolor: darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)',
                            border: '1px solid',
                            borderColor: darkMode ? '#ff8f00' : '#e65100',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '0.8rem',
                            px: 1,
                        }}
                    >
                        {new Intl.NumberFormat('ru-RU', {
                            style: 'currency',
                            currency: 'RUB',
                        }).format(totalClosing || 0)}
                    </Typography>;
                case 'cost':
                    return <Typography
                        sx={{
                            color: darkMode ? '#e91e63' : '#c2185b',
                            // bgcolor: darkMode ? 'rgba(233, 30, 99, 0.2)' : 'rgba(194, 24, 91, 0.1)',
                            border: '1px solid',
                            borderColor: darkMode ? '#e91e63' : '#c2185b',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '0.8rem',
                            px: 1,
                        }}
                    >
                        {new Intl.NumberFormat('ru-RU', {
                            style: 'currency',
                            currency: 'RUB',
                        }).format(totalCost || 0)}
                    </Typography>;
                case 'equipment':
                    return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        {editMode && (
                            <Button
                                size="small"
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleAddCategoryClick(e, row.id);
                                }}
                                sx={{
                                    color: darkMode ? '#fff' : '#fff',
                                    bgcolor: darkMode ? '#64b5f6' : '#1976d2',
                                    '&:hover': {
                                        bgcolor: darkMode ? '#90caf9' : '#1565c0',
                                    },
                                    fontSize: '0.75rem',
                                    py: 0.1,
                                    px: 1.5,
                                    fontWeight: 600,
                                    boxShadow: darkMode ? '0 2px 4px rgba(100, 181, 246, 0.3)' : '0 2px 4px rgba(25, 118, 210, 0.3)',
                                }}
                            >
                                Добавить оснащение
                            </Button>
                        )}
                    </Box>;
                default:
                    return '';
            }
        };

        // Создаем расширенный список колонок с учетом colSpan
        const expandedColumns = [];
        visibleColumnsArray.forEach(column => {
            if (column.colSpan && column.colSpan > 1) {
                // Для столбцов с colSpan добавляем подстолбцы
                if (column.id === 'start') {
                    expandedColumns.push({ id: 'plan_start', parentId: 'start', width: getColumnWidth ? getColumnWidth('start') / 2 : column.width / 2, align: column.align, padding: '2px 4px' });
                    expandedColumns.push({ id: 'fact_start', parentId: 'start', width: getColumnWidth ? getColumnWidth('start') / 2 : column.width / 2, align: column.align, padding: '2px 4px' });
                } else if (column.id === 'end') {
                    expandedColumns.push({ id: 'plan_end', parentId: 'end', width: getColumnWidth ? getColumnWidth('end') / 2 : column.width / 2, align: column.align, padding: '2px 4px' });
                    expandedColumns.push({ id: 'fact_end', parentId: 'end', width: getColumnWidth ? getColumnWidth('end') / 2 : column.width / 2, align: column.align, padding: '2px 4px' });
                } else {
                    // Для других столбцов с colSpan просто добавляем основной столбец
                    expandedColumns.push({ id: column.id, width: getColumnWidth ? getColumnWidth(column.id) : column.width, align: column.align, padding: '2px 8px' });
                }
            } else {
                // Для обычных столбцов просто добавляем их
                expandedColumns.push({ id: column.id, width: getColumnWidth ? getColumnWidth(column.id) : column.width, align: column.align, padding: '2px 8px' });
            }
        });

        return <React.Fragment key={`${row.id}-1`}>
            {expandedColumns.map((column) => (
                <TableCell
                    key={`${row.id}-object-${column.id}`}
                    sx={{
                        padding: column.padding || '2px 8px',
                        fontWeight: 600,
                        color: darkMode ? '#f5f7fa' : '#333',
                        bgcolor: darkMode ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
                        width: column.width,
                        minWidth: column.width,
                        maxWidth: column.width,
                        borderBottom: darkMode
                            ? '1px solid rgba(255, 255, 255, 0.08)'
                            : '1px solid rgba(0, 0, 0, 0.08)',
                        // borderRight: darkMode
                        //     ? '1px solid rgba(255, 255, 255, 0.05)'
                        //     : '1px solid rgba(0, 0, 0, 0.05)',
                        position: 'relative',
                        ...(isRowEdited && {
                            bgcolor: darkMode ? 'rgba(255, 152, 0, 0.1)' : 'rgba(255, 152, 0, 0.05)',
                            borderLeft: column.id === 'fid' ? `3px solid ${darkMode ? '#ffb74d' : '#f57c00'}` : undefined,
                        }),
                        // ...(editMode && {
                        //     '&:hover': {
                        //         bgcolor: darkMode ? 'rgba(25, 118, 210, 0.15)' : 'rgba(25, 118, 210, 0.1)',
                        //         cursor: 'pointer'
                        //     },
                        // })
                    }}
                    align={column.align || 'left'}
                >
                    {getObjectColumnValue(column.id)}
                </TableCell>
            ))}
        </React.Fragment>
    }
    if (row.purpose === 'table') {
        // Получаем данные из новой структуры
        const categories = row.data?.categories || [];
        const isCategoryExpanded = (categoryUuid) => {
            const categories = expandedCategories.get(row.id);
            return categories ? categories.has(categoryUuid) : false;
        };

        // Функция для получения значения столбца для категории
        const getCategoryColumnValue = (columnId, category) => {
            if (!category) return '';

            const works = category.works || [];
            const hasWorks = works.length > 0;

            switch (columnId) {
                case 'fid':
                    return <Typography
                        sx={{
                            color: darkMode ? '#f5f7fa' : '#333',
                            fontSize: '0.75rem',
                            fontWeight: 600,
                        }}
                    >
                        {category.id}
                    </Typography>;
                case 'name_by_acts':
                    if (editing.id === row.id && editing.field === 'name_by_acts' && editing.categoryUuid === category.uuid && !editing.workId) {
                        return <EditableTextAreaCell
                            id={row.id}
                            field="name_by_acts"
                            value={category.name_by_acts || ''}
                            label="Наименование по актам"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#f5f7fa' : '#333',
                            fontSize: '0.75rem',
                            fontWeight: 500,
                        }}
                    >
                        {category.name_by_acts || ''}
                    </Typography>;
                case 'plan_start':
                    if (hasWorks) {
                        const filteredValues = works.map(w => w.plan_start ? new Date(w.plan_start) : null).filter(Boolean);
                        const value = filteredValues.length > 0 ? (sortDirection === 'desc' ? Math.max(...filteredValues) : Math.min(...filteredValues)) : null;
                        return (<Typography
                            sx={{
                                color: darkMode ? '#64b5f6' : '#1976d2',
                                bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.1)',
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: '0.75rem'
                            }}
                        >
                            {value ? formatDate(new Date(value).toUTCString(), true) : ''}
                        </Typography>)
                    }
                    if (editing.id === row.id && editing.field === 'plan_start' && editing.categoryUuid === category.uuid) {
                        return <EditableDateCell
                            id={row.id}
                            field="plan_start"
                            value={category.plan_start}
                            label="План. начало"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                        />
                    }
                    return (<Typography
                        sx={{
                            color: darkMode ? '#64b5f6' : '#1976d2',
                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            '&:hover': editMode ? {
                                transform: 'scale(1.02)',
                            } : {},
                        }}
                        onClick={(e) => {
                            e.stopPropagation()
                            editMode && setEditingField({ id: row.id, field: 'plan_start', categoryUuid: category.uuid })
                        }}
                    >
                        {formatDate(category.plan_start, true)}
                    </Typography>)
                case 'fact_start':
                    if (hasWorks) {
                        const filteredValues = works.map(w => w.fact_start ? new Date(w.fact_start) : null).filter(Boolean);
                        const value = filteredValues.length > 0 ? (sortDirection === 'desc' ? Math.max(...filteredValues) : Math.min(...filteredValues)) : null;
                        return (<Typography
                            sx={{
                                color: (darkMode ? '#4caf50' : '#2e7d32'),
                                bgcolor: darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(46, 125, 50, 0.1)',
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: '0.75rem'
                            }}
                        >
                            {value ? formatDate(new Date(value).toUTCString(), true) : ''}
                        </Typography>)
                    }
                    if (editing.id === row.id && editing.field === 'fact_start' && editing.categoryUuid === category.uuid) {
                        return <EditableDateCell
                            id={row.id}
                            field="fact_start"
                            value={category.fact_start}
                            label="Факт. начало"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#4caf50' : '#2e7d32',
                            bgcolor: darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(46, 125, 50, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {formatDate(category.fact_start, true)}
                    </Typography>
                case 'plan_end':
                    if (hasWorks) {
                        const filteredValues = works.map(w => w.plan_end ? new Date(w.plan_end) : null).filter(Boolean);
                        const value = filteredValues.length > 0 ? (sortDirection === 'desc' ? Math.max(...filteredValues) : Math.min(...filteredValues)) : null;
                        return (<Typography
                            sx={{
                                color: darkMode ? '#64b5f6' : '#1976d2',
                                bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.1)',
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: '0.75rem'
                            }}
                        >
                            {value ? formatDate(new Date(value).toUTCString(), true) : ''}
                        </Typography>)
                    }
                    if (editing.id === row.id && editing.field === 'plan_end' && editing.categoryUuid === category.uuid) {
                        return <EditableDateCell
                            id={row.id}
                            field="plan_end"
                            value={category.plan_end}
                            label="План. окончание"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#64b5f6' : '#1976d2',
                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {formatDate(category.plan_end, true)}
                    </Typography>
                case 'fact_end':
                    if (hasWorks) {
                        const filteredValues = works.map(w => w.fact_end ? new Date(w.fact_end) : null).filter(Boolean);
                        const value = filteredValues.length > 0 ? (sortDirection === 'desc' ?  Math.max(...filteredValues) : Math.min(...filteredValues)) : null;
                        return (<Typography
                            sx={{
                                color: (darkMode ? '#4caf50' : '#2e7d32'),
                                bgcolor: (darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(46, 125, 50, 0.1)'),
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: '0.75rem',
                            }}
                        >
                            {value ? formatDate(new Date(value).toUTCString(), true) : ''}
                        </Typography>)
                    }
                    if (editing.id === row.id && editing.field === 'fact_end' && editing.categoryUuid === category.uuid) {
                        return <EditableDateCell
                            id={row.id}
                            field="fact_end"
                            value={category.fact_end}
                            label="Факт. окончание"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#4caf50' : '#2e7d32',
                            bgcolor: darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(46, 125, 50, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {formatDate(category.fact_end, true)}
                    </Typography>
                case 'stage':
                    if (hasWorks) {
                        const filteredValues = works.map(w => parseFloat(w.stage)).filter(Boolean);
                        const value = filteredValues.length > 0 ? (sortDirection === 'desc' ?  Math.max(...filteredValues) : Math.min(...filteredValues)) : null;
                        return <Typography
                            sx={{
                                ...getStageColor(value, darkMode),
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: '0.8rem',
                            }}
                        >
                            {value || ''}
                        </Typography>
                    }
                    if (editing.id === row.id && editing.field === 'stage' && editing.categoryUuid === category.uuid) {
                        return <EditableNumberCell
                            id={row.id}
                            field="stage"
                            value={category.stage}
                            label="Этап"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                        />
                    }
                    return <Typography
                        sx={{
                            ...getStageColor(category.stage, darkMode),
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '0.8rem',
                        }}
                    >
                        {category.stage !== null && category.stage !== undefined
                            ? (category.stage % 1 === 0 ? String(category.stage) : parseFloat(category.stage).toFixed(1))
                            : ''}
                    </Typography>
                case 'responsible':
                    if (hasWorks) {
                        const value = [...new Set(works.map(w => w.responsible).filter(Boolean))]
                        return <Typography
                            sx={{
                                bgcolor: darkMode ? 'rgba(211, 47, 47, 0.2)' : 'rgba(211, 47, 47, 0.1)',
                                color: darkMode ? '#f44336' : '#d32f2f',
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: '0.75rem',
                            }}
                        >
                            {value.length > 0 ? value.map(v => users[v]).join(', ') : ''}
                        </Typography>
                    }
                    if (editing.id === row.id && editing.field === 'responsible' && editing.categoryUuid === category.uuid) {
                        const userOptions = Object.keys(users).map(id => ({ id: Number(id), name: users[id] }));
                        return <EditableSelectCell
                            id={row.id}
                            field="responsible"
                            value={category.responsible ? { id: category.responsible, name: users[category.responsible] } : null}
                            label="Ответственный"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            options={userOptions}
                            categoryUuid={category.uuid}
                        />
                    }
                    return <Typography
                        sx={{
                            bgcolor: darkMode ? 'rgba(211, 47, 47, 0.2)' : 'rgba(211, 47, 47, 0.1)',
                            color: darkMode ? '#f44336' : '#d32f2f',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {users[category.responsible]}
                    </Typography>
                case 'coexecutors':
                    if (hasWorks) {
                        const value = [...new Set(works.map(w => Array.isArray(w.coexecutors) ? w.coexecutors : [w.coexecutors]).flat().filter(Boolean))]
                        return <Typography
                            sx={{
                                bgcolor: darkMode ? 'rgba(245, 124, 0, 0.2)' : 'rgba(245, 124, 0, 0.1)',
                                color: darkMode ? '#ffb74d' : '#f57c00',
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: '0.75rem',
                            }}
                        >
                            {value.length > 0 ? value.map(v => users[v]).join(', ') : ''}
                        </Typography>
                    }
                    if (editing.id === row.id && editing.field === 'coexecutors' && editing.categoryUuid === category.uuid) {
                        const userOptions = Object.keys(users).map(id => ({ id: Number(id), name: users[id] }));
                        const currentValue = Array.isArray(category.coexecutors)
                            ? category.coexecutors.map(id => ({ id: Number(id), name: users[id] }))
                            : (category.coexecutors ? [{ id: Number(category.coexecutors), name: users[category.coexecutors] }] : []);
                        return <EditableSelectCell
                            id={row.id}
                            field="coexecutors"
                            value={currentValue}
                            label="Соисполнители"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            options={userOptions}
                            multiple={true}
                            categoryUuid={category.uuid}
                        />
                    }
                    return <Typography
                        sx={{
                            bgcolor: darkMode ? 'rgba(245, 124, 0, 0.2)' : 'rgba(245, 124, 0, 0.1)',
                            color: darkMode ? '#ffb74d' : '#f57c00',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {Array.isArray(category.coexecutors) ? category.coexecutors.map(i => users[i]).join(', ') : users[category.coexecutors] || ''}
                    </Typography>
                case 'comment':
                    if (editing.id === row.id && editing.field === 'comment' && editing.categoryUuid === category.uuid && !editing.workId) {
                        return <EditableTextAreaCell
                            id={row.id}
                            field="comment"
                            value={category.comment || ''}
                            label="Комментарий"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                        />
                    }
                    return <Box
                        sx={{
                            textAlign: 'left',
                            color: darkMode ? '#2196f3' : '#1565c0',
                            fontWeight: 500,
                            lineHeight: '1.1',
                            maxHeight: '120px',
                            overflow: 'auto',
                            padding: '2px',
                            borderRadius: '2px',
                        }}
                    >
                        <MarkdownContent content={category.comment || ''} darkMode={darkMode} />
                    </Box>
                case 'equipment':
                    // Для категории показываем название категории из equipmentMap
                    const categoryName = equipmentMap[category.id] || `Категория ${category.id}`;
                    // Проверяем, можно ли добавить работу к этой категории
                    const availableWorks = equipmentTree[String(category.id)] || [];
                    const canAddWork = availableWorks.length > 0;
                    const existingWorkIds = (category.works || []).map(w => w.id);
                    const worksToAdd = availableWorks.filter(w => !existingWorkIds.includes(w));

                    // Получаем индекс категории для определения, можно ли перемещать
                    const categories = row.data?.categories || [];
                    const categoryIndex = categories.findIndex(cat => cat.id === category.id);
                    const isSortBlocking = sortBy && !['fid'].includes(sortBy);
                    const isFilterBlocking = advancedFilters && advancedFilters.length > 0;
                    const canMoveUp = categoryIndex > 0 && !isSortBlocking && !isFilterBlocking;
                    const canMoveDown = categoryIndex < categories.length - 1 && !isSortBlocking && !isFilterBlocking;

                    return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: editMode ? 'space-between' : 'center', gap: 0.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                            {editMode && (
                                <>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleMoveCategoryUp(row.id, category.uuid);
                                        }}
                                        disabled={!canMoveUp}
                                        sx={{
                                            padding: '2px',
                                            color: canMoveUp ? (darkMode ? '#64b5f6' : '#1976d2') : (darkMode ? '#666' : '#999'),
                                            '&:hover': canMoveUp ? {
                                                backgroundColor: darkMode ? 'rgba(100, 181, 246, 0.15)' : 'rgba(25, 118, 210, 0.1)',
                                                color: darkMode ? '#90caf9' : '#1565c0'
                                            } : {},
                                            fontSize: '14px',
                                            opacity: canMoveUp ? 1 : 0.5,
                                        }}
                                        title="Переместить вверх"
                                    >
                                        <ArrowUpwardIcon sx={{ fontSize: '16px' }} />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleMoveCategoryDown(row.id, category.uuid);
                                        }}
                                        disabled={!canMoveDown}
                                        sx={{
                                            padding: '2px',
                                            color: canMoveDown ? (darkMode ? '#64b5f6' : '#1976d2') : (darkMode ? '#666' : '#999'),
                                            '&:hover': canMoveDown ? {
                                                backgroundColor: darkMode ? 'rgba(100, 181, 246, 0.15)' : 'rgba(25, 118, 210, 0.1)',
                                                color: darkMode ? '#90caf9' : '#1565c0'
                                            } : {},
                                            fontSize: '14px',
                                            opacity: canMoveDown ? 1 : 0.5,
                                        }}
                                        title="Переместить вниз"
                                    >
                                        <ArrowDownwardIcon sx={{ fontSize: '16px' }} />
                                    </IconButton>
                                </>
                            )}
                            {editMode && canAddWork && worksToAdd.length > 0 && (
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleAddWorkClick(e, row.id, category.uuid);
                                    }}
                                    sx={{
                                        padding: '2px',
                                        color: darkMode ? '#81c784' : '#4caf50',
                                        '&:hover': {
                                            backgroundColor: darkMode ? 'rgba(129, 199, 132, 0.15)' : 'rgba(76, 175, 80, 0.1)',
                                            color: darkMode ? '#a5d6a7' : '#388e3c'
                                        },
                                        fontSize: '14px',
                                    }}
                                    title="Добавить работу"
                                >
                                    <AddIcon sx={{ fontSize: '16px' }} />
                                </IconButton>
                            )}
                        </Box>
                        <Typography
                            sx={{
                                color: darkMode ? '#7486F0' : '#4154C4',
                                bgcolor: darkMode ? 'rgba(92, 107, 192, 0.2)' : 'rgba(57, 73, 171, 0.1)',
                                borderRadius: '8px',
                                px: 1,
                                fontWeight: 600,
                                fontSize: '0.75rem',
                            }}
                        >
                            {categoryName}{category.works?.length > 0 ? ` (${category.works.length})` : ''}
                        </Typography>
                        {editMode && (
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteCategory(row.id, category.uuid);
                                }}
                                sx={{
                                    padding: '2px',
                                    color: darkMode ? '#ef5350' : '#d32f2f',
                                    '&:hover': {
                                        backgroundColor: darkMode ? 'rgba(239, 83, 80, 0.15)' : 'rgba(211, 47, 47, 0.1)',
                                        color: darkMode ? '#ff6b6b' : '#c62828'
                                    },
                                    fontSize: '14px',
                                }}
                                title="Удалить категорию"
                            >
                                <DeleteIcon sx={{ fontSize: '16px' }} />
                            </IconButton>
                        )}
                    </Box>
                case 'closing':
                case 'cost':
                    // Если есть работы, показываем сумму из работ (нередактируемую)
                    if (hasWorks) {
                        const total = works.reduce((sum, work) => {
                            return sum + (Number(work[columnId] || 0));
                        }, 0);
                        return <Typography
                            sx={{
                                color: columnId === 'closing'
                                    ? (darkMode ? '#ff8f00' : '#e65100')
                                    : (darkMode ? '#e91e63' : '#c2185b'),
                                bgcolor: columnId === 'closing'
                                    ? (darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)')
                                    : (darkMode ? 'rgba(233, 30, 99, 0.2)' : 'rgba(194, 24, 91, 0.1)'),
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: '0.75rem',
                            }}
                        >
                            {new Intl.NumberFormat('ru-RU', {
                                style: 'currency',
                                currency: 'RUB',
                            }).format(total || 0)}
                        </Typography>
                    }

                    // Если работ нет, делаем поле редактируемым
                    if (editing.id === row.id && editing.field === columnId && editing.categoryUuid === category.uuid) {
                        return <EditableNumberCell
                            id={row.id}
                            field={columnId}
                            value={category[columnId] || 0}
                            label={columnId === 'closing' ? 'Закрытие' : 'Стоимость'}
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                        />
                    }

                    // Отображение значения категории, когда не редактируется
                    return <Typography
                        sx={{
                            color: columnId === 'closing'
                                ? (darkMode ? '#ff8f00' : '#e65100')
                                : (darkMode ? '#e91e63' : '#c2185b'),
                            bgcolor: columnId === 'closing'
                                ? (darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)')
                                : (darkMode ? 'rgba(233, 30, 99, 0.2)' : 'rgba(194, 24, 91, 0.1)'),
                            borderRadius: '8px',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            cursor: editMode ? 'pointer' : 'default',
                            '&:hover': editMode ? {
                                bgcolor: columnId === 'closing'
                                    ? (darkMode ? 'rgba(255, 143, 0, 0.3)' : 'rgba(230, 81, 0, 0.2)')
                                    : (darkMode ? 'rgba(233, 30, 99, 0.3)' : 'rgba(194, 24, 91, 0.2)'),
                            } : {},
                        }}
                    >
                        {new Intl.NumberFormat('ru-RU', {
                            style: 'currency',
                            currency: 'RUB',
                        }).format(category[columnId] || 0)}
                    </Typography>
                case 'created':
                    return <Box>
                        <Typography variant="body2" sx={{
                            color: darkMode ? '#f5f7fa' : '#333',
                            fontWeight: 500,
                            fontSize: '0.8rem',
                            mb: 0.2,
                        }}>
                            {String(users[row.creator] || '')}
                        </Typography>
                        <Typography variant="caption" sx={{
                            color: darkMode ? '#bbb' : '#666',
                            fontSize: '0.75rem',
                        }}>
                            {formatDate(row.created_at)}
                        </Typography>
                    </Box>
                case 'modified':
                    return <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 0 }}>
                            <Tooltip title="История изменений">
                                <IconButton
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openHistoryDialog(row);
                                    }}
                                    size="small"
                                    sx={{
                                        color: darkMode ? '#ff9800' : '#f57c00',
                                        '&:hover': {
                                            bgcolor: darkMode ? 'rgba(255, 152, 0, 0.1)' : 'rgba(245, 124, 0, 0.1)',
                                            transform: 'scale(1.1)',
                                        },
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    <HistoryIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                            <Typography variant="body2" sx={{
                                color: darkMode ? '#f5f7fa' : '#333',
                                fontWeight: 500,
                                fontSize: '0.8rem',
                                mb: 0.2,
                            }}>
                                {String(users[row.modifier] || '')}
                            </Typography>
                            <Typography variant="caption" sx={{
                                color: darkMode ? '#bbb' : '#666',
                                fontSize: '0.75rem',
                            }}>
                                {formatDate(row.modified_at)}
                            </Typography>
                        </Box>
                    </Box>
                default:
                    return '';
            }
        };

        // Функция для получения значения столбца для работы
        const getWorkColumnValue = (columnId, category, work, index) => {
            if (!work) return '';
            switch (columnId) {
                case 'fid':
                    return <Typography
                        sx={{
                            color: darkMode ? '#f5f7fa' : '#333',
                            fontSize: '0.75rem',
                            fontWeight: 500,
                        }}
                    >
                        {index}
                    </Typography>
                        ;
                case 'name_by_acts':
                    if (editing.id === row.id && editing.field === 'name_by_acts' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        return <EditableTextAreaCell
                            id={row.id}
                            field="name_by_acts"
                            value={work.name_by_acts || ''}
                            label="Наименование по актам"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#f5f7fa' : '#333',
                            fontSize: '0.75rem',
                            fontWeight: 500,
                        }}
                    >
                        {work.name_by_acts || ''}
                    </Typography>;
                case 'closing':
                    if (editing.id === row.id && editing.field === 'closing' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        return <EditableNumberCell
                            id={row.id}
                            field="closing"
                            value={work.closing || 0}
                            label="Закрытие"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#ff8f00' : '#e65100',
                            bgcolor: darkMode ? 'rgba(255, 143, 0, 0.2)' : 'rgba(230, 81, 0, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {new Intl.NumberFormat('ru-RU', {
                            style: 'currency',
                            currency: 'RUB',
                        }).format(work.closing || 0)}
                    </Typography>
                case 'cost':
                    if (editing.id === row.id && editing.field === 'cost' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        return <EditableNumberCell
                            id={row.id}
                            field="cost"
                            value={work.cost || 0}
                            label="Стоимость"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#e91e63' : '#c2185b',
                            bgcolor: darkMode ? 'rgba(233, 30, 99, 0.2)' : 'rgba(194, 24, 91, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {new Intl.NumberFormat('ru-RU', {
                            style: 'currency',
                            currency: 'RUB',
                        }).format(work.cost || 0)}
                    </Typography>

                case 'plan_start':
                    if (editing.id === row.id && editing.field === 'plan_start' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        return <EditableDateCell
                            id={row.id}
                            field="plan_start"
                            value={work.plan_start}
                            label="План. начало"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return (<Typography
                        sx={{
                            color: darkMode ? '#64b5f6' : '#1976d2',
                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                            '&:hover': editMode ? {
                                transform: 'scale(1.02)',
                            } : {},
                        }}
                    >
                        {formatDate(work.plan_start, true)}
                    </Typography>)
                case 'fact_start':
                    if (editing.id === row.id && editing.field === 'fact_start' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        return <EditableDateCell
                            id={row.id}
                            field="fact_start"
                            value={work.fact_start}
                            label="Факт. начало"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#4caf50' : '#2e7d32',
                            bgcolor: darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(46, 125, 50, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {formatDate(work.fact_start, true)}
                    </Typography>
                case 'plan_end':
                    if (editing.id === row.id && editing.field === 'plan_end' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        return <EditableDateCell
                            id={row.id}
                            field="plan_end"
                            value={work.plan_end}
                            label="План. окончание"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#64b5f6' : '#1976d2',
                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {formatDate(work.plan_end, true)}
                    </Typography>
                case 'fact_end':
                    if (editing.id === row.id && editing.field === 'fact_end' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        return <EditableDateCell
                            id={row.id}
                            field="fact_end"
                            value={work.fact_end}
                            label="Факт. окончание"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Typography
                        sx={{
                            color: darkMode ? '#4caf50' : '#2e7d32',
                            bgcolor: darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(46, 125, 50, 0.1)',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {formatDate(work.fact_end, true)}
                    </Typography>
                case 'stage':

                    if (editing.id === row.id && editing.field === 'stage' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        return <EditableNumberCell
                            id={row.id}
                            field="stage"
                            value={work.stage}
                            label="Этап"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Typography
                        sx={{
                            ...getStageColor(work.stage, darkMode),
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.8rem',
                        }}
                    >
                        {work.stage !== null && work.stage !== undefined
                            ? (work.stage % 1 === 0 ? String(work.stage) : parseFloat(work.stage).toFixed(1))
                            : ''}
                    </Typography>
                case 'comment':
                    if (editing.id === row.id && editing.field === 'comment' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        return <EditableTextAreaCell
                            id={row.id}
                            field="comment"
                            value={work.comment || ''}
                            label="Комментарий"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Box
                        sx={{
                            textAlign: 'left',
                            color: darkMode ? '#2196f3' : '#1565c0',
                            fontWeight: 500,
                            lineHeight: '1.1',
                            maxHeight: '120px',
                            overflow: 'auto',
                            padding: '2px',
                            borderRadius: '2px',
                        }}
                    >
                        <MarkdownContent content={work.comment || ''} darkMode={darkMode} />
                    </Box>
                case 'responsible':
                    if (editing.id === row.id && editing.field === 'responsible' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        const userOptions = Object.keys(users).map(id => ({ id: Number(id), name: users[id] }));
                        return <EditableSelectCell
                            id={row.id}
                            field="responsible"
                            value={work.responsible ? { id: work.responsible, name: users[work.responsible] } : null}
                            label="Ответственный"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            options={userOptions}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Typography
                        sx={{
                            bgcolor: darkMode ? 'rgba(211, 47, 47, 0.2)' : 'rgba(211, 47, 47, 0.1)',
                            color: darkMode ? '#f44336' : '#d32f2f',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {users[work.responsible]}
                    </Typography>
                case 'coexecutors':
                    if (editing.id === row.id && editing.field === 'coexecutors' && editing.categoryUuid === category.uuid && editing.workId === work.id) {
                        const userOptions = Object.keys(users).map(id => ({ id: Number(id), name: users[id] }));
                        const currentValue = Array.isArray(work.coexecutors)
                            ? work.coexecutors.map(id => ({ id: Number(id), name: users[id] }))
                            : (work.coexecutors ? [{ id: Number(work.coexecutors), name: users[work.coexecutors] }] : []);
                        return <EditableSelectCell
                            id={row.id}
                            field="coexecutors"
                            value={currentValue}
                            label="Соисполнители"
                            saveEditedField={saveEditedField}
                            darkMode={darkMode}
                            options={userOptions}
                            multiple={true}
                            categoryUuid={category.uuid}
                            workId={work.id}
                        />
                    }
                    return <Typography
                        sx={{
                            bgcolor: darkMode ? 'rgba(245, 124, 0, 0.2)' : 'rgba(245, 124, 0, 0.1)',
                            color: darkMode ? '#ffb74d' : '#f57c00',
                            borderRadius: '8px',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {Array.isArray(work.coexecutors) ? work.coexecutors.map(i => users[i]).join(', ') : users[work.coexecutors] || ''}
                    </Typography>

                case 'equipment':
                    // Для работы показываем название работы из equipmentMap
                    const workName = equipmentMap[work.id] || `Работа ${work.id}`;
                    // Получаем индекс работы для определения, можно ли перемещать
                    const works = category.works || [];
                    const workIndex = works.findIndex(w => w.id === work.id);
                    const isSortBlocking = sortBy && !['fid'].includes(sortBy);
                    const isFilterBlocking = advancedFilters && advancedFilters.length > 0;
                    const canMoveWorkUp = workIndex > 0 && !isSortBlocking && !isFilterBlocking;
                    const canMoveWorkDown = workIndex < works.length - 1 && !isSortBlocking && !isFilterBlocking;

                    return <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: editMode ? 'space-between' : 'center', gap: 0.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                            {editMode && (
                                <>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleMoveWorkUp(row.id, category.uuid, work.id);
                                        }}
                                        disabled={!canMoveWorkUp}
                                        sx={{
                                            padding: '2px',
                                            color: canMoveWorkUp ? (darkMode ? '#64b5f6' : '#1976d2') : (darkMode ? '#666' : '#999'),
                                            '&:hover': canMoveWorkUp ? {
                                                backgroundColor: darkMode ? 'rgba(100, 181, 246, 0.15)' : 'rgba(25, 118, 210, 0.1)',
                                                color: darkMode ? '#90caf9' : '#1565c0'
                                            } : {},
                                            fontSize: '14px',
                                            opacity: canMoveWorkUp ? 1 : 0.5,
                                        }}
                                        title="Переместить вверх"
                                    >
                                        <ArrowUpwardIcon sx={{ fontSize: '16px' }} />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleMoveWorkDown(row.id, category.uuid, work.id);
                                        }}
                                        disabled={!canMoveWorkDown}
                                        sx={{
                                            padding: '2px',
                                            color: canMoveWorkDown ? (darkMode ? '#64b5f6' : '#1976d2') : (darkMode ? '#666' : '#999'),
                                            '&:hover': canMoveWorkDown ? {
                                                backgroundColor: darkMode ? 'rgba(100, 181, 246, 0.15)' : 'rgba(25, 118, 210, 0.1)',
                                                color: darkMode ? '#90caf9' : '#1565c0'
                                            } : {},
                                            fontSize: '14px',
                                            opacity: canMoveWorkDown ? 1 : 0.5,
                                        }}
                                        title="Переместить вниз"
                                    >
                                        <ArrowDownwardIcon sx={{ fontSize: '16px' }} />
                                    </IconButton>
                                </>
                            )}
                        </Box>
                        <Typography
                            sx={{
                                color: darkMode ? '#7486F0' : '#4154C4',
                                bgcolor: darkMode ? 'rgba(92, 107, 192, 0.2)' : 'rgba(57, 73, 171, 0.1)',
                                borderRadius: '8px',
                                px: 1,
                                fontWeight: 500,
                                fontSize: '0.75rem',
                            }}
                        >
                            {workName}
                        </Typography>
                        {editMode && (
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteWork(row.id, category.uuid, work.id);
                                }}
                                sx={{
                                    padding: '2px',
                                    color: darkMode ? '#ef5350' : '#d32f2f',
                                    '&:hover': {
                                        backgroundColor: darkMode ? 'rgba(239, 83, 80, 0.15)' : 'rgba(211, 47, 47, 0.1)',
                                        color: darkMode ? '#ff6b6b' : '#c62828'
                                    },
                                    fontSize: '14px',
                                }}
                                title="Удалить работу"
                            >
                                <DeleteIcon sx={{ fontSize: '16px' }} />
                            </IconButton>
                        )}
                    </Box>
                default:
                    return '';
            }
        };



        // Получаем видимые колонки в правильном порядке из columns
        const visibleColumnsArray = columns.filter(col => visibleColumns[col.id]);

        // Подсчитываем общее количество ячеек с учетом colSpan
        const totalCellsCount = visibleColumnsArray.reduce((sum, column) => {
            return sum + (column.colSpan || 1);
        }, 0);

        // Создаем расширенный список колонок с учетом colSpan для строк работ
        const expandedColumns = [];
        visibleColumnsArray.forEach(column => {
            if (column.colSpan && column.colSpan > 1) {
                // Для столбцов с colSpan добавляем подстолбцы
                if (column.id === 'start') {
                    expandedColumns.push({ id: 'plan_start', parentId: 'start', width: getColumnWidth ? getColumnWidth('start') / 2 : column.width / 2, align: column.align, padding: '2px 4px' });
                    expandedColumns.push({ id: 'fact_start', parentId: 'start', width: getColumnWidth ? getColumnWidth('start') / 2 : column.width / 2, align: column.align, padding: '2px 4px' });
                } else if (column.id === 'end') {
                    expandedColumns.push({ id: 'plan_end', parentId: 'end', width: getColumnWidth ? getColumnWidth('end') / 2 : column.width / 2, align: column.align, padding: '2px 4px' });
                    expandedColumns.push({ id: 'fact_end', parentId: 'end', width: getColumnWidth ? getColumnWidth('end') / 2 : column.width / 2, align: column.align, padding: '2px 4px' });
                } else {
                    // Для других столбцов с colSpan просто добавляем основной столбец
                    expandedColumns.push({ id: column.id, width: getColumnWidth ? getColumnWidth(column.id) : column.width, align: column.align, padding: '2px 8px' });
                }
            } else {
                // Для обычных столбцов просто добавляем их
                expandedColumns.push({ id: column.id, width: getColumnWidth ? getColumnWidth(column.id) : column.width, align: column.align, padding: '2px 8px' });
            }
        });
        return <React.Fragment key={`${row.id}-2`}>
            <TableCell colSpan={totalCellsCount} align="start" sx={{
                padding: '0',
                color: darkMode ? '#f5f7fa' : '#333',
                borderBottom: darkMode
                    ? '1px solid rgba(255, 255, 255, 0.08)'
                    : '1px solid rgba(0, 0, 0, 0.08)',
                borderRight: darkMode
                    ? '1px solid rgba(255, 255, 255, 0.05)'
                    : '1px solid rgba(0, 0, 0, 0.05)',
                fontWeight: 600,
                fontSize: '0.875rem',
                position: 'relative',
                ...(isRowEdited && {
                    bgcolor: darkMode ? 'rgba(255, 152, 0, 0.1)' : 'rgba(255, 152, 0, 0.05)',
                    borderLeft: `3px solid ${darkMode ? '#ffb74d' : '#f57c00'}`,
                }),
                ...(editMode && {
                    '&:hover': {
                        bgcolor: darkMode ? 'rgba(25, 118, 210, 0.15)' : 'rgba(25, 118, 210, 0.1)',
                        cursor: 'pointer'
                    },
                })
            }}
            >
                <Table stickyHeader size='small' sx={{
                    tableLayout: 'fixed',
                    width: '100%',
                    borderCollapse: 'collapse',
                    '& .MuiTableCell-root': {
                        borderBottom: darkMode
                            ? '1px solid rgba(255, 255, 255, 0.05)'
                            : '1px solid rgba(0, 0, 0, 0.05)',
                    }
                }}>
                    <TableBody>
                        {categories.map((category) => {
                            const isExpanded = isCategoryExpanded(category.uuid);
                            // Получаем название категории из equipmentMap
                            const categoryName = equipmentMap[category.id] || `Категория ${category.id}`;
                            const works = category.works || [];

                            return (
                                <React.Fragment key={`${row.id}-${category.uuid || category.id}`}>
                                    {/* Строка категории */}
                                    <TableRow
                                        sx={{
                                            '&:hover': {
                                                bgcolor: darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                                            },
                                            // cursor: editMode ? 'default' : 'pointer'
                                        }}
                                    // onClick={editMode ? undefined : () => toggleCategory(row.id, category.id)}
                                    >
                                        {expandedColumns.map((column) => {
                                            if (column.id === 'fid') {
                                                return (
                                                    <TableCell
                                                        key={`${row.id}-${category.uuid || category.id}-header-${column.id}`}
                                                        sx={{
                                                            padding: column.padding,
                                                            fontWeight: 600,
                                                            color: darkMode ? '#f5f7fa' : '#333',
                                                            // bgcolor: darkMode ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
                                                            width: column.width,
                                                            minWidth: column.width,
                                                            maxWidth: column.width,
                                                            cursor: works.length > 0 ? 'pointer' : 'default',
                                                            borderBottom: darkMode
                                                                ? '1px solid rgba(255, 255, 255, 0.08)'
                                                                : '1px solid rgba(0, 0, 0, 0.08)',
                                                            borderRight: darkMode
                                                                ? '1px solid rgba(255, 255, 255, 0.05)'
                                                                : '1px solid rgba(0, 0, 0, 0.05)',
                                                        }}
                                                        align={column.align || 'left'}
                                                        onClick={works.length > 0 ? () => toggleCategory(row.id, category.uuid) : undefined}
                                                    >
                                                        {works.length > 0 && (

                                                            isExpanded ? (
                                                                <KeyboardArrowDownIcon sx={{ fontSize: 16, color: darkMode ? '#64b5f6' : '#1976d2' }} />
                                                            ) : (
                                                                <KeyboardArrowDownIcon sx={{ fontSize: 16, transform: 'rotate(-90deg)', color: darkMode ? '#64b5f6' : '#1976d2' }} />
                                                            )
                                                        )}
                                                    </TableCell>
                                                );
                                            }
                                            // if (column.id === 'equipment') {
                                            //     return (
                                            //         <TableCell
                                            //             key={`${row.id}-${category.id}-header-${column.id}`}
                                            //             sx={{
                                            //                 padding: column.padding,
                                            //                 fontWeight: 600,
                                            //                 bgcolor: darkMode ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
                                            //                 width: column.width,
                                            //                 minWidth: column.width,
                                            //                 maxWidth: column.width,
                                            //             }}
                                            //             align={column.align || 'left'}
                                            //         >
                                            //             <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                            //                 {categoryName} - {works.length}
                                            //             </Typography>
                                            //         </TableCell>
                                            //     );
                                            // }

                                            // Определяем, можно ли редактировать это поле
                                            const categoryWorks = category.works || [];
                                            const hasWorks = categoryWorks.length > 0;

                                            // Все поля кроме name_by_acts и comment редактируемы только если нет работ
                                            const canEditIfNotHasWorks = !hasWorks && !(column.id === 'name_by_acts' || column.id === 'comment');

                                            const isEditableField = editMode && (['comment', 'name_by_acts'].includes(column.id) || canEditIfNotHasWorks);

                                            // Для поля fid не делаем его редактируемым (там кнопка удаления)
                                            const isFidField = column.id === 'fid';

                                            return (
                                                <TableCell
                                                    key={`${row.id}-${category.id}-header-${column.id}`}
                                                    sx={{

                                                        padding: column.padding,
                                                        fontWeight: 700,
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                        // bgcolor: darkMode ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
                                                        width: column.width,
                                                        minWidth: column.width,
                                                        maxWidth: column.width,
                                                        borderBottom: darkMode
                                                            ? '1px solid rgba(255, 255, 255, 0.08)'
                                                            : '1px solid rgba(0, 0, 0, 0.08)',
                                                        borderRight: darkMode
                                                            ? '1px solid rgba(255, 255, 255, 0.05)'
                                                            : '1px solid rgba(0, 0, 0, 0.05)',
                                                        cursor: isEditableField ? 'pointer' : 'default',
                                                        '&:hover': isEditableField ? {
                                                            bgcolor: darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
                                                        } : {},
                                                    }}
                                                    align={column.align || 'left'}
                                                    onClick={isEditableField && column.id !== 'fid' ? (e) => {
                                                        e.stopPropagation();
                                                        setEditingField({ id: row.id, field: column.id, categoryUuid: category.uuid });
                                                    } : undefined}
                                                >
                                                    {getCategoryColumnValue(column.id, category)}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>

                                    {/* Строки работ (если категория раскрыта) */}
                                    {isExpanded && works.map((work, workIndex) => (
                                        <TableRow
                                            key={`${row.id}-${category.uuid || category.id}-${work.id}-${workIndex}`}
                                            sx={{
                                                '&:hover': {
                                                    bgcolor: darkMode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.01)',
                                                },
                                            }}
                                        >
                                            {expandedColumns.map((col) => {
                                                // Определяем, можно ли редактировать это поле
                                                const isEditableField = editMode // && !['name_by_acts', 'comment'].includes(col.id);

                                                return (
                                                    <TableCell
                                                        key={`${row.id}-${category.uuid || category.id}-${work.id}-${col.id}`}
                                                        sx={{
                                                            padding: col.padding,
                                                            fontSize: '0.75rem',
                                                            width: col.width,
                                                            minWidth: col.width,
                                                            maxWidth: col.width,
                                                            bgcolor: darkMode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.01)',
                                                            color: darkMode ? '#f5f7fa' : '#333',
                                                            borderBottom: darkMode
                                                                ? '1px solid rgba(255, 255, 255, 0.05)'
                                                                : '1px solid rgba(0, 0, 0, 0.05)',
                                                            borderRight: darkMode
                                                                ? '1px solid rgba(255, 255, 255, 0.05)'
                                                                : '1px solid rgba(0, 0, 0, 0.05)',
                                                            cursor: isEditableField ? 'pointer' : 'default',
                                                            '&:hover': isEditableField ? {
                                                                bgcolor: darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
                                                            } : {},
                                                        }}
                                                        align={col.align || 'left'}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setEditingField({ id: row.id, field: col.id, categoryUuid: category.uuid, workId: work.id });
                                                        }}
                                                    >
                                                        {getWorkColumnValue(col.id, category, work, workIndex + 1)}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </Table>

            </TableCell>
        </React.Fragment >
    }
    return null

}

// Утилиты для работы с localStorage
const STORAGE_KEYS = {
    OBJECTS_REESTR_SETTINGS: 'objects_reestr_settings'
};

const getStoredSettings = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEYS.OBJECTS_REESTR_SETTINGS);
        return stored ? JSON.parse(stored) : {};
    } catch {
        return {};
    }
};

const storeSettings = (settings) => {
    try {
        const current = getStoredSettings();
        const updated = { ...current, ...settings };
        localStorage.setItem(STORAGE_KEYS.OBJECTS_REESTR_SETTINGS, JSON.stringify(updated));
    } catch (error) {
        console.warn('Failed to save objects reestr settings:', error);
    }
};

const ObjectsReestrView = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const user = useSelector(state => state.state.user);
    const darkMode = useSelector(state => state.state.darkMode);
    const dispatch = useDispatch();

    // Получаем сохраненные настройки
    const storedSettings = getStoredSettings();

    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [groupedData, setGroupedData] = useState({ groupCounts: [], groupCountsRows: [], groupedData: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { transformers } = useSelector(selectMappedElectricity)
    const [equipment, setEquipment] = useState([]);
    const [equipmentTree, setEquipmentTree] = useState({});
    const [projects, setProjects] = useState([]);
    const [responsible, setResponsible] = useState([]);

    const [stages, setStages] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
    const [objectDialogOpen, setObjectDialogOpen] = useState(false);
    const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
    const [commentDialogOpen, setCommentDialogOpen] = useState(false);
    const [nameByActsDialogOpen, setNameByActsDialogOpen] = useState(false);
    const [selectedObject, setSelectedObject] = useState(null);
    const [commentEditObject, setCommentEditObject] = useState(null);
    const [nameByActsEditObject, setNameByActsEditObject] = useState(null);
    const [editMode, setEditMode] = useState(false)
    const [editing, setEditing] = useState({ id: null, field: null, categoryUuid: null, workId: null })
    const [editedRows, setEditedRows] = useState({})

    // Состояния для меню добавления категорий и работ
    const [categoryMenuAnchor, setCategoryMenuAnchor] = useState(null);
    const [workMenuAnchor, setWorkMenuAnchor] = useState(null);
    const [selectedRowForCategory, setSelectedRowForCategory] = useState(null);
    const [selectedCategoryForWork, setSelectedCategoryForWork] = useState(null);

    // Состояния для поиска и фильтрации
    const [searchQuery, setSearchQuery] = useState('');
    // 'all', 'my', 'stage'
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [selectedProjects, setSelectedProjects] = useState(storedSettings.selectedProjects ?? []);

    // Состояния для продвинутой фильтрации
    const [advancedFilters, setAdvancedFilters] = useState(storedSettings.advancedFilters ?? []);
    const availableFilters = useMemo(() => ([
        { id: 'plan_start', label: 'Начало строительства (плановое)', type: 'date' },
        { id: 'fact_start', label: 'Начало строительства (фактическое)', type: 'date' },
        { id: 'plan_end', label: 'Завершение строительства (плановое)', type: 'date' },
        { id: 'fact_end', label: 'Завершение строительства (фактическое)', type: 'date' },
        { id: 'stage', label: 'Этап', type: 'number' },
        { id: 'closing', label: 'Закрытие без НДС', type: 'number' },
        { id: 'cost', label: 'Стоимость без НДС', type: 'number' },
        { id: 'comment', label: 'Комментарий', type: 'text' },
        { id: 'name_by_acts', label: 'Наименование по актам', type: 'text' },
        { id: 'responsible', label: 'Ответственный', type: 'multi-select', options: Object.entries(responsible).map(([id, name]) => ({ id, name, label: name })) },
        { id: 'coexecutors', label: 'Соисполнители', type: 'multi-select', options: Object.entries(responsible).map(([id, name]) => ({ id, name, label: name })) },
        { id: 'equipment', label: 'Оснащение - категория', type: 'multi-select', options: Object.entries(equipment).map(([id, name]) => ({ id, name, label: name })) },
        { id: 'equipment', label: 'Оснащение - работа', type: 'multi-select', options: Object.entries(equipment).map(([id, name]) => ({ id, name, label: name })) },
        { id: 'created_at', label: 'Создано', type: 'date' },
        { id: 'creator', label: 'Создатель', type: 'multi-select', options: Object.entries(responsible).map(([id, name]) => ({ id, name, label: name })) },
        { id: 'modified_at', label: 'Изменено', type: 'date' },
        { id: 'modifier', label: 'Редактор', type: 'multi-select', options: Object.entries(responsible).map(([id, name]) => ({ id, name, label: name })) }
    ]), [responsible, equipment]);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

    // Состояние для управления видимостью второй строки с кнопками управления
    const [showControlMenu, setShowControlMenu] = useState(storedSettings.showControlMenu !== false);

    // Состояние для меню экспорта
    const [exportMenuAnchor, setExportMenuAnchor] = useState(null);

    // Состояние для выбранных строк
    const [selectedRows, setSelectedRows] = useState(new Set());

    // Состояние для раскрытых категорий equipment (Map: rowId -> Set категорий)
    const [expandedCategories, setExpandedCategories] = useState(new Map());

    // Функция для переключения раскрытия категории
    const toggleCategory = useCallback((rowId, category) => {
        setExpandedCategories(prev => {
            const newMap = new Map(prev);
            const categories = newMap.get(rowId) || new Set();
            if (categories.has(category)) {
                categories.delete(category);
            } else {
                categories.add(category);
            }
            newMap.set(rowId, categories);
            return newMap;
        });
    }, []);

    // Функция для фильтрации и сортировки данных
    const filterAndSortData = useCallback((rawData, editedRows, search, projectsFilter, advancedFilters, sortBy, sortDirection, equipmentMap) => {
        let filtered = [...rawData];

        filtered = filtered.map(f => ({
            ...f,
            ...editedRows[f.id]?.changes
        }))

        // Поиск
        if (search && search.trim()) {
            // Разбиваем поисковый запрос на отдельные слова и фильтруем пустые
            const searchTerms = search.toLowerCase().split(/\s+/).filter(term => term.length > 0);

            filtered = filtered.filter(item => {
                // Получаем объект трансформера
                const transformer = transformers.get(item.object_id);

                // Получаем данные из нового формата
                const data = item.data || { categories: [] };

                let searchableText = '';

                // Базовые поля объекта
                const objectName = String(transformer?.name || '').toLowerCase();
                const objectTown = String(transformer?.town || '').toLowerCase();
                const itemId = String(item.id || '').toLowerCase();
                const itemFid = String(item.fid || '').toLowerCase();
                const creatorName = String(
                    item.creator?.name ||
                    (responsible && typeof responsible === 'object' && !Array.isArray(responsible) ? responsible[item.creator] : '') ||
                    ''
                ).toLowerCase();
                const modifierName = String(
                    item.modifier?.name ||
                    (responsible && typeof responsible === 'object' && !Array.isArray(responsible) ? responsible[item.modifier] : '') ||
                    ''
                ).toLowerCase();

                searchableText += ` ${objectName} ${objectTown} ${itemId} ${itemFid} ${creatorName} ${modifierName} `;

                // Извлекаем данные из categories и works
                if (data.categories && Array.isArray(data.categories)) {
                    data.categories.forEach(category => {
                        // Название категории
                        const categoryName = (equipment && typeof equipment === 'object' && !Array.isArray(equipment))
                            ? (equipment[category.id] || '')
                            : '';
                        searchableText += ` ${categoryName.toLowerCase()} `;

                        // Поля категории
                        if (category.name_by_acts) {
                            searchableText += ` ${String(category.name_by_acts).toLowerCase()} `;
                        }
                        if (category.comment) {
                            searchableText += ` ${String(category.comment).toLowerCase()} `;
                        }
                        if (category.stage) {
                            searchableText += ` ${String(category.stage).toLowerCase()} `;
                        }
                        if (category.plan_start) {
                            const dateStr = formatDate(category.plan_start, true);
                            if (dateStr) searchableText += ` ${dateStr.toLowerCase()} `;
                        }
                        if (category.plan_end) {
                            const dateStr = formatDate(category.plan_end, true);
                            if (dateStr) searchableText += ` ${dateStr.toLowerCase()} `;
                        }
                        if (category.fact_start) {
                            const dateStr = formatDate(category.fact_start, true);
                            if (dateStr) searchableText += ` ${dateStr.toLowerCase()} `;
                        }
                        if (category.fact_end) {
                            const dateStr = formatDate(category.fact_end, true);
                            if (dateStr) searchableText += ` ${dateStr.toLowerCase()} `;
                        }
                        if (category.responsible) {
                            const responsibleName = (responsible && typeof responsible === 'object' && !Array.isArray(responsible))
                                ? (responsible[category.responsible] || '')
                                : '';
                            searchableText += ` ${responsibleName.toLowerCase()} `;
                        }
                        if (category.coexecutors) {
                            const coexecutorsNames = (responsible && typeof responsible === 'object' && !Array.isArray(responsible))
                                ? (Array.isArray(category.coexecutors)
                                    ? category.coexecutors.map(id => responsible[id] || '').join(' ')
                                    : (responsible[category.coexecutors] || ''))
                                : '';
                            searchableText += ` ${coexecutorsNames.toLowerCase()} `;
                        }

                        // Поля работ
                        if (category.works && Array.isArray(category.works)) {
                            category.works.forEach(work => {
                                const workName = (equipment && typeof equipment === 'object' && !Array.isArray(equipment))
                                    ? (equipment[work.id] || '')
                                    : '';
                                searchableText += ` ${workName.toLowerCase()} `;
                                if (work.cost) {
                                    searchableText += ` ${String(work.cost).toLowerCase()} `;
                                }
                                if (work.closing) {
                                    searchableText += ` ${String(work.closing).toLowerCase()} `;
                                }
                            });
                        }
                    });
                }

                // Проверяем, что каждое слово из поискового запроса содержится в тексте
                return searchTerms.every(term => searchableText.includes(term));
            });
        }

        // Фильтрация по проектам
        if (projectsFilter && projectsFilter.length > 0) {
            filtered = filtered.filter(item => {
                return projectsFilter.includes(item.project_id);
            });
        }

        // Продвинутая фильтрация
        if (advancedFilters && advancedFilters.length > 0) {
            // Определяем поля, которые относятся к категориям и работам
            const categoryFields = ['comment', 'name_by_acts'];
            const workFields = ['plan_start', 'fact_start', 'plan_end', 'fact_end', 'stage', 'responsible', 'coexecutors', 'closing', 'cost'];
            const equipmentField = 'equipment';

            advancedFilters.forEach(filter => {
                const filterType = filter.originalId || filter.id;

                // Пропускаем фильтры без значения
                if (!filter.value || (Array.isArray(filter.value) && filter.value.length === 0)) {
                    return;
                }

                filtered = filtered.filter(item => {
                    const data = item.data || { categories: [] };
                    const categories = data.categories || [];

                    // Если это поле уровня объекта (created_at, modified_at, fid и т.д.)
                    if (!categoryFields.includes(filterType) && !workFields.includes(filterType) && filterType !== equipmentField) {
                        // Фильтруем по полям объекта
                        switch (filterType) {
                            case 'created_at':
                            case 'modified_at':
                                if (filter.value) {
                                    const filterDate = new Date(filter.value);
                                    const itemDate = new Date(item[filterType]);
                                    if (!itemDate || isNaN(itemDate.getTime())) return false;

                                    switch (filter.operator) {
                                        case 'equals':
                                            return itemDate.getTime() === filterDate.getTime();
                                        case 'greater':
                                            return itemDate > filterDate;
                                        case 'less':
                                            return itemDate < filterDate;
                                        case 'between':
                                            if (!filter.value2) return true;
                                            const filterDate2 = new Date(filter.value2);
                                            return itemDate >= filterDate && itemDate <= filterDate2;
                                        default:
                                            return true;
                                    }
                                }
                                return true;
                            default:
                                return true;
                        }
                    }

                    // Если это поле категории, проверяем наличие соответствующих данных
                    if (categoryFields.includes(filterType)) {
                        // Фильтруем по полям категорий (только comment и name_by_acts)
                        const matchingCategories = categories.filter(category => {
                            const categoryValue = category[filterType];

                            switch (filterType) {
                                case 'comment':
                                case 'name_by_acts':
                                    const searchTerm = String(filter.value || '').toLowerCase().trim();
                                    const textValue = String(categoryValue || '').toLowerCase();

                                    switch (filter.operator) {
                                        case 'contains':
                                            return textValue.includes(searchTerm);
                                        case 'not_contains':
                                            return !textValue.includes(searchTerm);
                                        case 'equals':
                                            return textValue === searchTerm;
                                        case 'not_equals':
                                            return textValue !== searchTerm;
                                        default:
                                            return true;
                                    }

                                default:
                                    return true;
                            }
                        });

                        // Если нет совпадающих категорий, исключаем объект
                        return matchingCategories.length > 0;
                    }

                    if (workFields.includes(filterType)) {
                        // Фильтруем по полям работ
                        const hasMatchingWork = categories.some(category => {
                            const works = category.works || [];
                            return works.some(work => {
                                const workValue = work[filterType];

                                switch (filterType) {
                                    case 'plan_start':
                                    case 'fact_start':
                                    case 'plan_end':
                                    case 'fact_end':
                                        if (!workValue) return false;
                                        const filterDate = new Date(filter.value);
                                        const workDate = new Date(workValue);
                                        if (!workDate || isNaN(workDate.getTime())) return false;

                                        switch (filter.operator) {
                                            case 'equals':
                                                return workDate.getDate() === filterDate.getDate() &&
                                                    workDate.getMonth() === filterDate.getMonth() &&
                                                    workDate.getFullYear() === filterDate.getFullYear();
                                            case 'greater':
                                                return workDate > filterDate;
                                            case 'less':
                                                return workDate < filterDate;
                                            case 'between':
                                                if (!filter.value2) return true;
                                                const filterDate2 = new Date(filter.value2);
                                                return workDate >= filterDate && workDate <= filterDate2;
                                            default:
                                                return true;
                                        }

                                    case 'stage':
                                        const filterStage = Number(filter.value);
                                        const workStage = Number(workValue);
                                        if (isNaN(workStage)) return false;

                                        switch (filter.operator) {
                                            case 'equals':
                                                return workStage === filterStage;
                                            case 'greater':
                                                return workStage > filterStage;
                                            case 'less':
                                                return workStage < filterStage;
                                            default:
                                                return true;
                                        }

                                    case 'responsible':
                                        const responsibleIds = filter.value.map(r => Number(r.id));
                                        const workResponsible = Number(workValue);
                                        if (isNaN(workResponsible)) return false;

                                        if (filter.logic === 'and') {
                                            return responsibleIds.includes(workResponsible);
                                        } else {
                                            return responsibleIds.includes(workResponsible);
                                        }

                                    case 'coexecutors':
                                        const coexecutorIds = filter.value.map(c => Number(c.id));
                                        const workCoexecutors = Array.isArray(workValue) ? workValue : (workValue ? [workValue] : []);
                                        if (workCoexecutors.length === 0) return false;

                                        if (filter.logic === 'and') {
                                            return coexecutorIds.every(id => workCoexecutors.includes(id));
                                        } else {
                                            return coexecutorIds.some(id => workCoexecutors.includes(id));
                                        }

                                    case 'closing':
                                    case 'cost':
                                        const workNumericValue = Number(workValue || 0);
                                        const filterNumericValue = Number(filter.value);

                                        switch (filter.operator) {
                                            case 'equals':
                                                return workNumericValue === filterNumericValue;
                                            case 'greater':
                                                return workNumericValue > filterNumericValue;
                                            case 'less':
                                                return workNumericValue < filterNumericValue;
                                            default:
                                                return true;
                                        }

                                    default:
                                        return true;
                                }
                            });
                        });

                        return hasMatchingWork;
                    }

                    if (filterType === equipmentField) {
                        // Фильтруем по оснащению (категориям и работам)
                        const equipmentIds = filter.value.map(e => Number(e.id));

                        const hasMatchingEquipment = categories.some(category => {
                            // Проверяем категорию
                            if (equipmentIds.includes(Number(category.id))) {
                                if (filter.logic === 'and') {
                                    // Для AND нужно проверить, что все выбранные ID присутствуют
                                    return equipmentIds.every(id => {
                                        if (id === Number(category.id)) return true;
                                        return (category.works || []).some(work => Number(work.id) === id);
                                    });
                                } else {
                                    return true; // Для OR достаточно одного совпадения
                                }
                            }

                            // Проверяем работы
                            const works = category.works || [];
                            const hasMatchingWork = works.some(work => equipmentIds.includes(Number(work.id)));

                            if (hasMatchingWork) {
                                if (filter.logic === 'and') {
                                    // Для AND нужно проверить, что все выбранные ID присутствуют
                                    return equipmentIds.every(id => {
                                        if (id === Number(category.id)) return true;
                                        return works.some(work => Number(work.id) === id);
                                    });
                                } else {
                                    return true;
                                }
                            }

                            return false;
                        });

                        return hasMatchingEquipment;
                    }

                    return true;
                });
            });
        }

        // Сортировка
        //         if (Array.isArray(value)) {
        //             const validDates = value
        //                 .map(d => {
        //                     try {
        //                         return new Date(d).getTime();
        //                     } catch {
        //                         return null;
        //                     }
        //                 })
        //                 .filter(time => time !== null);
        //             return validDates.length > 0 ? Math.max(...validDates) : null;
        //         }
        //         try {
        //             const time = new Date(value).getTime();
        //             return isNaN(time) ? null : time;
        //         } catch {
        //             return null;
        //         }
        //     };

        //     const getNumericValue = (field) => {
        //         if (!field) return null;
        //         const value = getValue(field);
        //         if (!value) return null;
        //         if (Array.isArray(value)) {
        //             const validNumbers = value
        //                 .map(v => parseFloat(v))
        //                 .filter(num => !isNaN(num));
        //             return validNumbers.length > 0 ? validNumbers.reduce((acc, num) => acc + num, 0) : null;
        //         }
        //         const num = parseFloat(value);
        //         return isNaN(num) ? null : num;
        //     };

        //     const getTextValue = (field) => {
        //         if (!field) return '';
        //         const value = getValue(field);
        //         if (!value) return '';
        //         if (Array.isArray(value)) {
        //             return value.map(v => String(v || '')).join(' ');
        //         }
        //         return String(value || '');
        //     };

        //     const getArrayValue = (field) => {
        //         if (!field) return [];
        //         const value = getValue(field);
        //         if (!value) return [];
        //         if (Array.isArray(value)) {
        //             return value;
        //         }
        //         return [value];
        //     };

        //     // advancedFilters.forEach(filter => {
        //     //     const filterType = filter.originalId || filter.id;
        //     //     console.log(filterType, filter)
        //     //     switch (filterType) {
        //     //         case 'plan_start':
        //     //         case 'fact_start':
        //     //         case 'plan_end':
        //     //         case 'fact_end':
        //     //             if (filter.value) {
        //     //                 const filterDate = new Date(filter.value);
        //     //                 filtered = filtered.map(item => {

        //     //                     const itemTime = getDateValue(item[filterType]);
        //     //                     console.log(itemTime)
        //     //                     if (itemTime === null) return null;
        //     //                     if (Array.isArray(itemTime) && itemTime.length === 0) return null;
        //     //                     // Определяем какие элементы plan_start соответствуют фильтру
        //     //                     let matchingIndices = (Array.isArray(itemTime) ? itemTime : [itemTime]).map((date, index) => {
        //     //                         if (!date) return -1;
        //     //                         const itemDate = new Date(date);
        //     //                         let matches = false;

        //     //                         switch (filter.operator) {
        //     //                             case 'equals':
        //     //                                 matches = itemDate.getDate() === filterDate.getDate();
        //     //                                 break;
        //     //                             case 'greater':
        //     //                                 matches = itemDate > filterDate;
        //     //                                 break;
        //     //                             case 'less':
        //     //                                 matches = itemDate < filterDate;
        //     //                                 break;
        //     //                             case 'between':
        //     //                                 if (!filter.value2) matches = true;
        //     //                                 else {
        //     //                                     const filterDate2 = new Date(filter.value2);
        //     //                                     matches = itemDate >= filterDate && itemDate <= filterDate2;
        //     //                                 }
        //     //                                 break;
        //     //                             default:
        //     //                                 matches = true;
        //     //                         }
        //     //                         return matches ? index : -1;
        //     //                     }).filter(index => index !== -1);

        //     //                     // Если нет совпадающих элементов, исключаем элемент из результата
        //     //                     if (matchingIndices.length === 0) {
        //     //                         return null;
        //     //                     }

        //     //                     // Создаем копию элемента с отфильтрованными массивами
        //     //                     const filteredItem = { ...item };

        //     //                     // Фильтруем plan_start
        //     //                     if (Array.isArray(itemTime)) {
        //     //                         filteredItem.plan_start = {
        //     //                             ...item.plan_start,
        //     //                             v: itemTime.filter((_, index) => matchingIndices.includes(index))
        //     //                         };

        //     //                         // Фильтруем связанные поля
        //     //                         const relatedFields = ['plan_end', 'fact_start', 'fact_end', 'stage', 'closing', 'cost', 'comment', 'name_by_acts', 'responsible', 'equipment', 'coexecutors'];
        //     //                         relatedFields.forEach(fieldName => {
        //     //                             if (item[fieldName] && Array.isArray(item[fieldName].v)) {
        //     //                                 if (fieldName === 'coexecutors' && !Array.isArray(item[fieldName].v[0])) return
        //     //                                 filteredItem[fieldName] = {
        //     //                                     ...item[fieldName],
        //     //                                     v: item[fieldName].v.filter((_, index) => matchingIndices.includes(index))
        //     //                                 };
        //     //                             }
        //     //                         });
        //     //                     } else {
        //     //                         if (matchingIndices.length === 0) return null
        //     //                     }



        //     //                     return filteredItem;
        //     //                 }).filter(item => item !== null);
        //     //             }
        //     //             break;







        //     //         case 'created_at':
        //     //             if (filter.value) {
        //     //                 const filterDate = new Date(filter.value);
        //     //                 filtered = filtered.filter(item => {
        //     //                     if (!item.created_at) return false;
        //     //                     const itemDate = new Date(item.created_at);

        //     //                     switch (filter.operator) {
        //     //                         case 'equals':
        //     //                             return itemDate.getTime() === filterDate.getTime();
        //     //                         case 'greater':
        //     //                             return itemDate > filterDate;
        //     //                         case 'less':
        //     //                             return itemDate < filterDate;
        //     //                         case 'between':
        //     //                             if (!filter.value2) return true;
        //     //                             const filterDate2 = new Date(filter.value2);
        //     //                             return itemDate >= filterDate && itemDate <= filterDate2;
        //     //                         default:
        //     //                             return true;
        //     //                     }
        //     //                 });
        //     //             }
        //     //             break;

        //     //         case 'modified_at':
        //     //             if (filter.value) {
        //     //                 const filterDate = new Date(filter.value);
        //     //                 filtered = filtered.filter(item => {
        //     //                     if (!item.modified_at) return false;
        //     //                     const itemDate = new Date(item.modified_at);

        //     //                     switch (filter.operator) {
        //     //                         case 'equals':
        //     //                             return itemDate.getTime() === filterDate.getTime();
        //     //                         case 'greater':
        //     //                             return itemDate > filterDate;
        //     //                         case 'less':
        //     //                             return itemDate < filterDate;
        //     //                         case 'between':
        //     //                             if (!filter.value2) return true;
        //     //                             const filterDate2 = new Date(filter.value2);
        //     //                             return itemDate >= filterDate && itemDate <= filterDate2;
        //     //                         default:
        //     //                             return true;
        //     //                     }
        //     //                 });
        //     //             }
        //     //             break;

        //     //         case 'stage':
        //     //             if (filter.value && filter.value !== '') {
        //     //                 const filterStage = Number(filter.value);
        //     //                 if (!isNaN(filterStage)) {
        //     //                     filtered = filtered.map(item => {
        //     //                         const itemStage = getValue(item.stage);
        //     //                         if (itemStage === null) return null;
        //     //                         if (Array.isArray(itemStage) && itemStage.length === 0) return null;
        //     //                         // Определяем какие элементы stage соответствуют фильтру
        //     //                         let matchingIndices = (Array.isArray(itemStage) ? itemStage : [itemStage]).map((stage, index) => {
        //     //                             const numStage = parseFloat(stage);
        //     //                             if (isNaN(numStage)) return -1;
        //     //                             let matches = false;

        //     //                             switch (filter.operator) {
        //     //                                 case 'equals':
        //     //                                     matches = numStage === filterStage;
        //     //                                     break;
        //     //                                 case 'greater':
        //     //                                     matches = numStage > filterStage;
        //     //                                     break;
        //     //                                 case 'less':
        //     //                                     matches = numStage < filterStage;
        //     //                                     break;
        //     //                                 default:
        //     //                                     matches = true;
        //     //                             }
        //     //                             return matches ? index : -1;
        //     //                         })
        //     //                             .filter(index => index !== -1);

        //     //                         // Если нет совпадающих элементов, исключаем элемент из результата
        //     //                         if (matchingIndices.length === 0) {
        //     //                             return null;
        //     //                         }

        //     //                         // Создаем копию элемента с отфильтрованными массивами
        //     //                         const filteredItem = { ...item };

        //     //                         // Фильтруем stage
        //     //                         if (Array.isArray(itemStage)) {
        //     //                             filteredItem.stage = {
        //     //                                 ...item.stage,
        //     //                                 v: itemStage.filter((_, index) => matchingIndices.includes(index))
        //     //                             };

        //     //                             // Фильтруем связанные поля
        //     //                             const relatedFields = ['plan_start', 'plan_end', 'fact_start', 'fact_end', 'closing', 'cost', 'comment', 'name_by_acts', 'responsible', 'equipment', 'coexecutors'];
        //     //                             relatedFields.forEach(fieldName => {
        //     //                                 if (item[fieldName] && Array.isArray(item[fieldName].v)) {
        //     //                                     if (fieldName === 'coexecutors' && !Array.isArray(item[fieldName].v[0])) return
        //     //                                     filteredItem[fieldName] = {
        //     //                                         ...item[fieldName],
        //     //                                         v: item[fieldName].v.filter((_, index) => matchingIndices.includes(index))
        //     //                                     };
        //     //                                 }
        //     //                             });
        //     //                         } else {
        //     //                             if (matchingIndices.length === 0) return null
        //     //                         }



        //     //                         return filteredItem;
        //     //                     }).filter(item => item !== null);
        //     //                 }
        //     //             }
        //     //             break;

        //     //         case 'closing':
        //     //             if (filter.value && filter.value !== '') {
        //     //                 const filterClosing = Number(filter.value);
        //     //                 if (!isNaN(filterClosing)) {
        //     //                     filtered = filtered.map(item => {
        //     //                         const itemClosing = getValue(item.closing) || 0;
        //     //                         if (itemClosing === null) return item;

        //     //                         // Определяем какие элементы closing соответствуют фильтру
        //     //                         let matchingIndices = (Array.isArray(itemClosing) ? itemClosing : [itemClosing]).map((closing, index) => {
        //     //                             const numClosing = parseFloat(closing);
        //     //                             if (isNaN(numClosing)) return -1;
        //     //                             let matches = false;

        //     //                             switch (filter.operator) {
        //     //                                 case 'equals':
        //     //                                     matches = numClosing === filterClosing;
        //     //                                     break;
        //     //                                 case 'greater':
        //     //                                     matches = numClosing > filterClosing;
        //     //                                     break;
        //     //                                 case 'less':
        //     //                                     matches = numClosing < filterClosing;
        //     //                                     break;
        //     //                                 default:
        //     //                                     matches = true;
        //     //                             }
        //     //                             return matches ? index : -1;
        //     //                         })
        //     //                             .filter(index => index !== -1);


        //     //                         // Если нет совпадающих элементов, исключаем элемент из результата
        //     //                         if (matchingIndices.length === 0) {
        //     //                             return null;
        //     //                         }

        //     //                         // Создаем копию элемента с отфильтрованными массивами
        //     //                         const filteredItem = { ...item };

        //     //                         // Фильтруем closing
        //     //                         if (Array.isArray(itemClosing)) {
        //     //                             filteredItem.closing = {
        //     //                                 ...item.closing,
        //     //                                 v: itemClosing.filter((_, index) => matchingIndices.includes(index))
        //     //                             };

        //     //                             // Фильтруем связанные поля
        //     //                             const relatedFields = ['plan_start', 'plan_end', 'fact_start', 'fact_end', 'stage', 'cost', 'comment', 'name_by_acts', 'responsible', 'equipment', 'coexecutors'];
        //     //                             relatedFields.forEach(fieldName => {
        //     //                                 if (item[fieldName] && Array.isArray(item[fieldName].v)) {
        //     //                                     if (fieldName === 'coexecutors' && !Array.isArray(item[fieldName].v[0])) return
        //     //                                     filteredItem[fieldName] = {
        //     //                                         ...item[fieldName],
        //     //                                         v: item[fieldName].v.filter((_, index) => matchingIndices.includes(index))
        //     //                                     };
        //     //                                 }
        //     //                             });
        //     //                         } else {
        //     //                             if (matchingIndices.length === 0) return null
        //     //                         }



        //     //                         return filteredItem;
        //     //                     }).filter(item => item !== null);
        //     //                 }
        //     //             }
        //     //             break;

        //     //         case 'cost':
        //     //             if (filter.value && filter.value !== '') {
        //     //                 const filterCost = Number(filter.value);
        //     //                 if (!isNaN(filterCost)) {
        //     //                     filtered = filtered.map(item => {
        //     //                         const itemCost = getValue(item.cost) || 0;
        //     //                         // if (itemCost === null) return item;

        //     //                         // Определяем какие элементы cost соответствуют фильтру
        //     //                         let matchingIndices = (Array.isArray(itemCost) ? itemCost : [itemCost]).map((cost, index) => {
        //     //                             const numCost = parseFloat(cost);
        //     //                             if (isNaN(numCost)) return -1;
        //     //                             let matches = false;

        //     //                             switch (filter.operator) {
        //     //                                 case 'equals':
        //     //                                     matches = numCost === filterCost;
        //     //                                     break;
        //     //                                 case 'greater':
        //     //                                     matches = numCost > filterCost;
        //     //                                     break;
        //     //                                 case 'less':
        //     //                                     matches = numCost < filterCost;
        //     //                                     break;
        //     //                                 default:
        //     //                                     matches = true;
        //     //                             }
        //     //                             return matches ? index : -1;
        //     //                         })
        //     //                             .filter(index => index !== -1);

        //     //                         console.log(item.fid, matchingIndices)
        //     //                         // Если нет совпадающих элементов, исключаем элемент из результата
        //     //                         if (matchingIndices.length === 0) {
        //     //                             return null;
        //     //                         }

        //     //                         // Создаем копию элемента с отфильтрованными массивами
        //     //                         const filteredItem = { ...item };

        //     //                         // Фильтруем cost
        //     //                         if (Array.isArray(itemCost)) {
        //     //                             filteredItem.cost = {
        //     //                                 ...item.cost,
        //     //                                 v: itemCost.filter((_, index) => matchingIndices.includes(index))
        //     //                             };

        //     //                             // Фильтруем связанные поля
        //     //                             const relatedFields = ['plan_start', 'plan_end', 'fact_start', 'fact_end', 'stage', 'closing', 'comment', 'name_by_acts', 'responsible', 'equipment', 'coexecutors'];
        //     //                             relatedFields.forEach(fieldName => {
        //     //                                 if (item[fieldName] && Array.isArray(item[fieldName].v)) {
        //     //                                     if (fieldName === 'coexecutors' && !Array.isArray(item[fieldName].v[0])) return
        //     //                                     filteredItem[fieldName] = {
        //     //                                         ...item[fieldName],
        //     //                                         v: item[fieldName].v.filter((_, index) => matchingIndices.includes(index))
        //     //                                     };
        //     //                                 }
        //     //                             });
        //     //                         } else {
        //     //                             if (matchingIndices.length === 0) return null
        //     //                         }


        //     //                         console.log(filteredItem)
        //     //                         return filteredItem;
        //     //                     }).filter(item => item !== null);
        //     //                 }
        //     //             }
        //     //             break;

        //     //         case 'comment':
        //     //             if (filter.value && filter.value.trim() !== '') {
        //     //                 const searchTerm = filter.value.toLowerCase().trim();
        //     //                 filtered = filtered.map(item => {
        //     //                     const itemComment = getValue(item.comment);
        //     //                     if (itemComment === null) return item;

        //     //                     // Определяем какие элементы comment соответствуют фильтру
        //     //                     let matchingIndices = (Array.isArray(itemComment) ? itemComment : [itemComment]).map((comment, index) => {
        //     //                         const commentStr = String(comment || '').toLowerCase();
        //     //                         let matches = false;

        //     //                         switch (filter.operator) {
        //     //                             case 'contains':
        //     //                                 matches = commentStr.includes(searchTerm);
        //     //                                 break;
        //     //                             case 'not_contains':
        //     //                                 matches = !commentStr.includes(searchTerm);
        //     //                                 break;
        //     //                             case 'equals':
        //     //                                 matches = commentStr === searchTerm;
        //     //                                 break;
        //     //                             case 'not_equals':
        //     //                                 matches = commentStr !== searchTerm;
        //     //                                 break;
        //     //                             default:
        //     //                                 matches = true;
        //     //                         }
        //     //                         return matches ? index : -1;
        //     //                     })
        //     //                         .filter(index => index !== -1);


        //     //                     // Если нет совпадающих элементов, исключаем элемент из результата
        //     //                     if (matchingIndices.length === 0) {
        //     //                         return null;
        //     //                     }

        //     //                     // Создаем копию элемента с отфильтрованными массивами
        //     //                     const filteredItem = { ...item };

        //     //                     // Фильтруем comment
        //     //                     if (Array.isArray(itemComment)) {
        //     //                         filteredItem.comment = {
        //     //                             ...item.comment,
        //     //                             v: itemComment.filter((_, index) => matchingIndices.includes(index))
        //     //                         };
        //     //                         // Фильтруем связанные поля
        //     //                         const relatedFields = ['plan_start', 'plan_end', 'fact_start', 'fact_end', 'stage', 'closing', 'cost', 'comment', 'name_by_acts', 'responsible', 'equipment', 'coexecutors'];
        //     //                         relatedFields.forEach(fieldName => {
        //     //                             if (item[fieldName] && Array.isArray(item[fieldName].v)) {
        //     //                                 if (fieldName === 'coexecutors' && !Array.isArray(item[fieldName].v[0])) return
        //     //                                 filteredItem[fieldName] = {
        //     //                                     ...item[fieldName],
        //     //                                     v: item[fieldName].v.filter((_, index) => matchingIndices.includes(index))
        //     //                                 };
        //     //                             }
        //     //                         });
        //     //                     } else {
        //     //                         if (matchingIndices.length === 0) return null
        //     //                     }



        //     //                     return filteredItem;
        //     //                 }).filter(item => item !== null);
        //     //             }
        //     //             break;

        //     //         case 'name_by_acts':
        //     //             if (filter.value && filter.value.trim() !== '') {
        //     //                 const searchTerm = filter.value.toLowerCase().trim();
        //     //                 filtered = filtered.map(item => {
        //     //                     const itemNameByActs = getValue(item.name_by_acts);
        //     //                     if (itemNameByActs === null) return item;

        //     //                     // Определяем какие элементы name_by_acts соответствуют фильтру
        //     //                     let matchingIndices = (Array.isArray(itemNameByActs) ? itemNameByActs : [itemNameByActs]).map((nameByActs, index) => {
        //     //                         const nameByActsStr = String(nameByActs || '').toLowerCase();
        //     //                         let matches = false;

        //     //                         switch (filter.operator) {
        //     //                             case 'contains':
        //     //                                 matches = nameByActsStr.includes(searchTerm);
        //     //                                 break;
        //     //                             case 'not_contains':
        //     //                                 matches = !nameByActsStr.includes(searchTerm);
        //     //                                 break;
        //     //                             case 'equals':
        //     //                                 matches = nameByActsStr === searchTerm;
        //     //                                 break;
        //     //                             case 'not_equals':
        //     //                                 matches = nameByActsStr !== searchTerm;
        //     //                                 break;
        //     //                             default:
        //     //                                 matches = true;
        //     //                         }
        //     //                         return matches ? index : -1;
        //     //                     })
        //     //                         .filter(index => index !== -1);


        //     //                     // Если нет совпадающих элементов, исключаем элемент из результата
        //     //                     if (matchingIndices.length === 0) {
        //     //                         return null;
        //     //                     }

        //     //                     // Создаем копию элемента с отфильтрованными массивами
        //     //                     const filteredItem = { ...item };

        //     //                     // Фильтруем name_by_acts
        //     //                     if (Array.isArray(itemNameByActs)) {
        //     //                         filteredItem.name_by_acts = {
        //     //                             ...item.name_by_acts,
        //     //                             v: itemNameByActs.filter((_, index) => matchingIndices.includes(index))
        //     //                         };
        //     //                         // Фильтруем связанные поля
        //     //                         const relatedFields = ['plan_start', 'plan_end', 'fact_start', 'fact_end', 'stage', 'closing', 'cost', 'comment', 'responsible', 'equipment', 'coexecutors'];
        //     //                         relatedFields.forEach(fieldName => {
        //     //                             if (item[fieldName] && Array.isArray(item[fieldName].v)) {
        //     //                                 if (fieldName === 'coexecutors' && !Array.isArray(item[fieldName].v[0])) return
        //     //                                 filteredItem[fieldName] = {
        //     //                                     ...item[fieldName],
        //     //                                     v: item[fieldName].v.filter((_, index) => matchingIndices.includes(index))
        //     //                                 };
        //     //                             }
        //     //                         });
        //     //                     } else {
        //     //                         if (matchingIndices.length === 0) return null
        //     //                     }



        //     //                     return filteredItem;
        //     //                 }).filter(item => item !== null);
        //     //             }
        //     //             break;

        //     //         case 'responsible':
        //     //             if (filter.value && filter.value.length > 0) {
        //     //                 const responsibleIds = filter.value.map(c => c.id);
        //     //                 filtered = filtered.map(item => {
        //     //                     const itemResponsible = getValue(item.responsible);
        //     //                     if (itemResponsible === null) return null;
        //     //                     if (Array.isArray(itemResponsible) && itemResponsible.length === 0) return null;
        //     //                     // Определяем какие элементы coexecutors соответствуют фильтру
        //     //                     let matchingIndices = (Array.isArray(itemResponsible) ? itemResponsible : [itemResponsible]).map((item, index) => {
        //     //                         let hasMatch = false;
        //     //                         if (filter.logic === 'and') {
        //     //                             // И - все выбранные значения должны присутствовать в подмассиве
        //     //                             hasMatch = responsibleIds.every(id => item.includes(id));
        //     //                         } else {
        //     //                             // ИЛИ - любое из выбранных значений в подмассиве
        //     //                             hasMatch = item.some(id => responsibleIds.includes(id));
        //     //                         }

        //     //                         return hasMatch ? index : -1;
        //     //                     })
        //     //                         .filter(index => index !== -1);


        //     //                     // Если нет совпадающих элементов, исключаем элемент из результата
        //     //                     if (matchingIndices.length === 0) {
        //     //                         return null;
        //     //                     }

        //     //                     // Создаем копию элемента с отфильтрованными массивами
        //     //                     const filteredItem = { ...item };

        //     //                     // Фильтруем coexecutors
        //     //                     if (Array.isArray(itemResponsible)) {
        //     //                         // Для вложенных массивов фильтруем подмассивы
        //     //                         filteredItem.responsible = {
        //     //                             ...item.responsible,
        //     //                             v: itemResponsible.filter((_, index) => matchingIndices.includes(index))
        //     //                         };

        //     //                         // Фильтруем связанные поля
        //     //                         const relatedFields = ['plan_start', 'plan_end', 'fact_start', 'fact_end', 'stage', 'closing', 'cost', 'comment', 'name_by_acts', 'coexecutors', 'equipment'];
        //     //                         relatedFields.forEach(fieldName => {
        //     //                             if (item[fieldName] && Array.isArray(item[fieldName].v)) {
        //     //                                 if (fieldName === 'coexecutors' && !Array.isArray(item[fieldName].v[0])) return
        //     //                                 filteredItem[fieldName] = {
        //     //                                     ...item[fieldName],
        //     //                                     v: item[fieldName].v.filter((_, index) => matchingIndices.includes(index))
        //     //                                 };
        //     //                             }
        //     //                         });


        //     //                     } else {
        //     //                         if (matchingIndices.length === 0) return null
        //     //                     }



        //     //                     return filteredItem;
        //     //                 }).filter(item => item !== null);
        //     //             }
        //     //             break;

        //     //         case 'coexecutors':
        //     //             if (filter.value && filter.value.length > 0) {
        //     //                 const coexecutorIds = filter.value.map(c => c.id);
        //     //                 filtered = filtered.map(item => {
        //     //                     const itemCoexecutors = getArrayValue(item.coexecutors);
        //     //                     if (itemCoexecutors.length === 0) return item;

        //     //                     // Определяем какие элементы coexecutors соответствуют фильтру
        //     //                     let matchingIndices = (Array.isArray(itemCoexecutors[0]) ? itemCoexecutors : [itemCoexecutors]).map((subArray, index) => {
        //     //                         if (!Array.isArray(subArray)) return -1;

        //     //                         let hasMatch = false;
        //     //                         if (filter.logic === 'and') {
        //     //                             // И - все выбранные значения должны присутствовать в подмассиве
        //     //                             hasMatch = coexecutorIds.every(id => subArray.includes(id));
        //     //                         } else {
        //     //                             // ИЛИ - любое из выбранных значений в подмассиве
        //     //                             hasMatch = subArray.some(id => coexecutorIds.includes(id));
        //     //                         }

        //     //                         return hasMatch ? index : -1;
        //     //                     })
        //     //                         .filter(index => index !== -1);


        //     //                     // Если нет совпадающих элементов, исключаем элемент из результата
        //     //                     if (matchingIndices.length === 0) {
        //     //                         return null;
        //     //                     }

        //     //                     // Создаем копию элемента с отфильтрованными массивами
        //     //                     const filteredItem = { ...item };

        //     //                     // Фильтруем coexecutors
        //     //                     if (Array.isArray(itemCoexecutors[0])) {
        //     //                         // Для вложенных массивов фильтруем подмассивы
        //     //                         filteredItem.coexecutors = {
        //     //                             ...item.coexecutors,
        //     //                             v: itemCoexecutors.filter((_, index) => matchingIndices.includes(index))
        //     //                         };

        //     //                         // Фильтруем связанные поля
        //     //                         const relatedFields = ['plan_start', 'plan_end', 'fact_start', 'fact_end', 'stage', 'closing', 'cost', 'comment', 'name_by_acts', 'responsible', 'equipment'];
        //     //                         relatedFields.forEach(fieldName => {
        //     //                             if (item[fieldName] && Array.isArray(item[fieldName].v)) {
        //     //                                 if (fieldName === 'coexecutors' && !Array.isArray(item[fieldName].v[0])) return
        //     //                                 filteredItem[fieldName] = {
        //     //                                     ...item[fieldName],
        //     //                                     v: item[fieldName].v.filter((_, index) => matchingIndices.includes(index))
        //     //                                 };
        //     //                             }
        //     //                         });
        //     //                     } else {
        //     //                         if (matchingIndices.length === 0) return null
        //     //                     }



        //     //                     return filteredItem;
        //     //                 }).filter(item => item !== null);
        //     //             }
        //     //             break;

        //     //         case 'equipment':
        //     //             if (filter.value && filter.value.length > 0) {
        //     //                 const equipmentIds = filter.value.map(e => Number(e.id));
        //     //                 filtered = filtered.map(item => {
        //     //                     const itemEquipment = getArrayValue(item.equipment);
        //     //                     if (itemEquipment.length === 0) return null;

        //     //                     // Определяем какие элементы equipment соответствуют фильтру
        //     //                     let matchingEquipmentIndices = [];
        //     //                     if (filter.logic === 'and') {
        //     //                         // И - все выбранные значения должны присутствовать
        //     //                         matchingEquipmentIndices = itemEquipment
        //     //                             .map((id, index) => equipmentIds.includes(Number(id)) ? index : -1)
        //     //                             .filter(index => index !== -1);
        //     //                     } else {
        //     //                         // ИЛИ - любое из выбранных значений
        //     //                         matchingEquipmentIndices = itemEquipment
        //     //                             .map((id, index) => equipmentIds.includes(Number(id)) ? index : -1)
        //     //                             .filter(index => index !== -1);
        //     //                     }

        //     //                     // Если нет совпадающих элементов, исключаем элемент из результата
        //     //                     console.log(item.id, matchingEquipmentIndices)
        //     //                     if (matchingEquipmentIndices.length === 0) {
        //     //                         return null;
        //     //                     }

        //     //                     // Создаем копию элемента с отфильтрованными массивами
        //     //                     const filteredItem = { ...item };

        //     //                     // Фильтруем equipment
        //     //                     filteredItem.equipment = {
        //     //                         ...item.equipment,
        //     //                         v: itemEquipment.filter((_, index) => matchingEquipmentIndices.includes(index))
        //     //                     };



        //     //                     // Фильтруем связанные поля
        //     //                     const relatedFields = ['plan_start', 'plan_end', 'fact_start', 'fact_end', 'stage', 'closing', 'cost', 'comment', 'name_by_acts', 'responsible', 'coexecutors'];
        //     //                     relatedFields.forEach(fieldName => {
        //     //                         if (item[fieldName] && Array.isArray(item[fieldName].v)) {
        //     //                             if (fieldName === 'coexecutors' && !Array.isArray(item[fieldName].v[0])) return
        //     //                             filteredItem[fieldName] = {
        //     //                                 ...item[fieldName],
        //     //                                 v: item[fieldName].v.filter((_, index) => matchingEquipmentIndices.includes(index))
        //     //                             };
        //     //                         }
        //     //                     });

        //     //                     return filteredItem;
        //     //                 }).filter(item => item);
        //     //                 console.log(filtered)
        //     //             }
        //     //             break;

        //     //         case 'creator':
        //     //             if (filter.value && filter.value.length > 0) {
        //     //                 const creatorIds = filter.value.map(c => c.id);
        //     //                 filtered = filtered.filter(item => {
        //     //                     if (!item.creator) return false;

        //     //                     if (filter.logic === 'and') {
        //     //                         // И - все выбранные значения должны присутствовать
        //     //                         return creatorIds.includes(item.creator);
        //     //                     } else {
        //     //                         // ИЛИ - любое из выбранных значений
        //     //                         return creatorIds.includes(item.creator);
        //     //                     }
        //     //                 });
        //     //             }
        //     //             break;

        //     //         case 'modifier':
        //     //             if (filter.value && filter.value.length > 0) {
        //     //                 const modifierIds = filter.value.map(m => m.id);
        //     //                 filtered = filtered.filter(item => {
        //     //                     if (!item.modifier) return false;

        //     //                     if (filter.logic === 'and') {
        //     //                         // И - все выбранные значения должны присутствовать
        //     //                         return modifierIds.includes(item.modifier);
        //     //                     } else {
        //     //                         // ИЛИ - любое из выбранных значений
        //     //                         return modifierIds.includes(item.modifier);
        //     //                     }
        //     //                 });
        //     //             }
        //     //             break;
        //     //     }
        // Сортировка
        if (sortBy) {
            // Определяем, нужно ли сортировать категории и работы
            const shouldSortCategories = true;
            const shouldSortWorks = !['fid', 'name_by_acts', 'comment', 'created', 'modified'].includes(sortBy);

            // Функция для получения значения для сортировки объекта
            const getObjectSortValue = (item, field) => {
                const data = item.data || { categories: [] };
                const categories = data.categories || [];
                const works = categories.flatMap(cat => cat.works || []);
                switch (field) {
                    case 'fid':
                        return item.fid || 0;
                    case 'name_by_acts':
                        return categories.map(c => c.name_by_acts).join(', ').length
                    case 'start':
                    case 'end':
                        const filteredValues = works.map(w => [w[`plan_${field}`], w[`fact_${field}`]].filter(Boolean)).flat().map(d => new Date(d));
                        return filteredValues.length > 0 ? (sortDirection === 'desc' ?  Math.max(...filteredValues) : Math.min(...filteredValues)) : null;
                    case 'stage':
                        const stageValues = works.map(w => w[field]).filter(Boolean);
                        return stageValues.length > 0 ? (sortDirection === 'desc' ?  Math.max(...stageValues) : Math.min(...stageValues)) : null;
                    case 'closing':
                    case 'cost':
                        // Суммируем значения по всем категориям
                        // Если у категории есть работы - суммируем из работ, иначе берем значение категории
                        return categories.reduce((sum, cat) => {
                            const catWorks = cat.works || [];
                            if (catWorks.length > 0) {
                                return sum + catWorks.reduce((workSum, work) => {
                                    return workSum + (Number(work[field] || 0));
                                }, 0);
                            } else {
                                return sum + (Number(cat[field] || 0));
                            }
                        }, 0);
                    case 'comment':
                        return categories.map(c => c.comment).join(', ').length
                    case 'responsible':
                    case 'coexecutors':
                        return works.map(w => w[field] ? (Array.isArray(w[field]) ? w[field] : [w.field]).length : 0)
                    case 'created':
                    case 'modified':
                        // const dateValues = categories.map(w => w[`${field}_at`] ? new Date(w[`${field}_at`]).getTime() : null).filter(Boolean)
                        return new Date(item[`${field}_at`]).getTime() 
                    case 'equipment':
                        // Для equipment возвращаем количество категорий (для сортировки объектов)
                        return categories.length;
                    default:
                        return 0;
                }
            };

            // Функция для получения значения для сортировки категории
            const getCategorySortValue = (category, field) => {
                const works = category.works || [];
                switch (field) {
                    case 'name_by_acts':
                        return category.name_by_acts
                    case 'start':
                    case 'end':
                        const filteredValues = works.map(w => [w[`plan_${field}`], w[`fact_${field}`]].filter(Boolean)).flat().map(d => new Date(d));
                        return filteredValues.length > 0 ? (sortDirection === 'desc' ?  Math.max(...filteredValues) : Math.min(...filteredValues)) : null;
                    case 'stage':
                        const stageValues = works.map(w => w[field]).filter(Boolean);
                        return stageValues.length > 0 ? (sortDirection === 'desc' ?  Math.max(...stageValues) : Math.min(...stageValues)) : null;
                    case 'closing':
                    case 'cost':
                        // Если есть работы, суммируем значения по всем работам в категории
                        // Если работ нет, используем значение из категории
                        const categoryWorks = category.works || [];
                        if (categoryWorks.length > 0) {
                            return categoryWorks.reduce((sum, work) => {
                                return sum + (Number(work[field] || 0));
                            }, 0);
                        } else {
                            return Number(category[field] || 0);
                        }
                    case 'comment':
                        return category.comment
                    case 'responsible':
                    case 'coexecutors':
                        return works.map(w => w[field] ? (Array.isArray(w[field]) ? w[field] : [w.field]).map(f => responsible[f] || '').join(', ') : null)
                    case 'equipment':
                        // Для equipment возвращаем название категории для сортировки
                        return (equipmentMap && equipmentMap[category.id]) ? equipmentMap[category.id].toLowerCase() : (category.id || '');
                    // case 'created':
                    // case 'edited':
                    //     return new Date(category[field])
                    default:
                        return 0;
                }
            };

            // Функция для получения значения для сортировки работы
            const getWorkSortValue = (work, field) => {
                switch (field) {
                    case 'start':
                    case 'end':
                        const dateArray = [work[`plan_${field}`], work[`fact_${field}`]].filter(Boolean).map(d => new Date(d))
                        return sortDirection === 'desc' ?  Math.max(...dateArray) : Math.min(...dateArray)
                    case 'stage':
                        return work[field] ? parseFloat(work[field]) : null
                    case 'closing':
                    case 'cost':
                        return Number(work[field] || 0);
                    case 'responsible':
                        return work[field] ? responsible[work[field]] : ''
                    case 'coexecutors':
                        return work[field] ? (Array.isArray(work[field]) ? work[field].map(f => responsible[f]).join(', ') : responsible[work[field]]) : ''
                    case 'equipment':
                        // Для equipment возвращаем название работы для сортировки
                        return (equipmentMap && equipmentMap[work.id]) ? equipmentMap[work.id].toLowerCase() : (work.id || '');
                    default:
                        return 0;
                }
            };

            // Сортируем объекты
            filtered.sort((a, b) => {
                const aValue = getObjectSortValue(a, sortBy);
                const bValue = getObjectSortValue(b, sortBy);

                let comparison = 0;
                if (typeof aValue === 'number' && typeof bValue === 'number') {
                    comparison = aValue - bValue;
                } else {
                    comparison = String(aValue || '').localeCompare(String(bValue || ''), 'ru');
                }

                return sortDirection === 'desc' ? -comparison : comparison;
            });

            // Если нужно сортировать категории и работы, создаем отсортированные копии данных
            if (shouldSortCategories) {
                filtered = filtered.map(item => {
                    const itemData = item.data || { categories: [] };
                    const sortedCategories = [...(itemData.categories || [])].map(category => {
                        const sortedCategory = { ...category };

                        if (shouldSortWorks && category.works) {
                            sortedCategory.works = [...category.works].sort((workA, workB) => {
                                const workAValue = getWorkSortValue(workA, sortBy);
                                const workBValue = getWorkSortValue(workB, sortBy);

                                let workComparison = 0;
                                if (typeof workAValue === 'number' && typeof workBValue === 'number') {
                                    workComparison = workAValue - workBValue;
                                } else {
                                    workComparison = String(workAValue || '').localeCompare(String(workBValue || ''), 'ru');
                                }

                                return sortDirection === 'desc' ? -workComparison : workComparison;
                            });
                        }

                        return sortedCategory;
                    }).sort((catA, catB) => {
                        const catAValue = getCategorySortValue(catA, sortBy);
                        const catBValue = getCategorySortValue(catB, sortBy);

                        let catComparison = 0;
                        if (typeof catAValue === 'number' && typeof catBValue === 'number') {
                            catComparison = catAValue - catBValue;
                        } else {
                            catComparison = String(catAValue || '').localeCompare(String(catBValue || ''), 'ru');
                        }

                        return sortDirection === 'desc' ? -catComparison : catComparison;
                    });

                    return {
                        ...item,
                        data: {
                            ...itemData,
                            categories: sortedCategories
                        }
                    };
                });
            }
        }
        //             case 'name':
        //                 aValue = transformers.get(a.object_id)?.name || '';
        //                 bValue = transformers.get(b.object_id)?.name || '';
        //                 break;
        //             case 'start':
        //                 // Сортируем по плановому началу, если нет - по фактическому
        //                 const getDateValue = (dateField) => {
        //                     if (!dateField) return 0;
        //                     const value = dateField.v !== undefined ? dateField.v : dateField;
        //                     if (!value) return 0;
        //                     if (Array.isArray(value)) {
        //                         const validDates = value
        //                             .map(d => {
        //                                 try {
        //                                     return new Date(d).getTime();
        //                                 } catch {
        //                                     return 0;
        //                                 }
        //                             })
        //                             .filter(time => !isNaN(time) && time > 0);
        //                         return validDates.length > 0 ? Math.max(...validDates) : 0;
        //                     }
        //                     try {
        //                         const time = new Date(value).getTime();
        //                         return isNaN(time) ? 0 : time;
        //                     } catch {
        //                         return 0;
        //                     }
        //                 };

        //                 aValue = a.plan_start ? getDateValue(a.plan_start) : getDateValue(a.fact_start);
        //                 bValue = b.plan_start ? getDateValue(b.plan_start) : getDateValue(b.fact_start);
        //                 break;
        //             case 'end':
        //                 // Сортируем по плановому завершению, если нет - по фактическому
        //                 const getDateValueEnd = (dateField) => {
        //                     if (!dateField) return 0;
        //                     const value = dateField.v !== undefined ? dateField.v : dateField;
        //                     if (!value) return 0;
        //                     if (Array.isArray(value)) {
        //                         const validDates = value
        //                             .map(d => {
        //                                 try {
        //                                     return new Date(d).getTime();
        //                                 } catch {
        //                                     return 0;
        //                                 }
        //                             })
        //                             .filter(time => !isNaN(time) && time > 0);
        //                         return validDates.length > 0 ? Math.max(...validDates) : 0;
        //                     }
        //                     try {
        //                         const time = new Date(value).getTime();
        //                         return isNaN(time) ? 0 : time;
        //                     } catch {
        //                         return 0;
        //                     }
        //                 };

        //                 aValue = a.plan_end ? getDateValueEnd(a.plan_end) : getDateValueEnd(a.fact_end);
        //                 bValue = b.plan_end ? getDateValueEnd(b.plan_end) : getDateValueEnd(b.fact_end);
        //                 break;
        //             case 'stage':
        //                 const getStageValue = (stageField) => {
        //                     if (!stageField) return 0;
        //                     const value = stageField.v !== undefined ? stageField.v : stageField;
        //                     if (!value) return 0;
        //                     const stages = Array.isArray(value) ? value : [value];
        //                     const validStages = stages.filter(s => typeof s === 'number' && !isNaN(s));
        //                     return validStages.length > 0 ? Math.min(...validStages) : 0;
        //                 };
        //                 aValue = getStageValue(a.stage);
        //                 bValue = getStageValue(b.stage);
        //                 break;
        //             case 'closing':
        //                 const getNumericValue = (field) => {
        //                     if (!field) return 0;
        //                     const value = field.v !== undefined ? field.v : field;
        //                     if (!value) return 0;
        //                     const values = Array.isArray(value) ? value : [value];
        //                     return values.reduce((acc, item) => {
        //                         const num = parseFloat(item);
        //                         return acc + (isNaN(num) ? 0 : num);
        //                     }, 0);
        //                 };
        //                 aValue = getNumericValue(a.closing);
        //                 bValue = getNumericValue(b.closing);
        //                 break;
        //             case 'cost':
        //                 const getCostValue = (field) => {
        //                     if (!field) return 0;
        //                     const value = field.v !== undefined ? field.v : field;
        //                     if (!value) return 0;
        //                     const values = Array.isArray(value) ? value : [value];
        //                     return values.reduce((acc, item) => {
        //                         const num = parseFloat(item);
        //                         return acc + (isNaN(num) ? 0 : num);
        //                     }, 0);
        //                 };
        //                 aValue = getCostValue(a.cost);
        //                 bValue = getCostValue(b.cost);
        //                 break;
        //             case 'comment':
        //                 const getCommentLength = (commentField) => {
        //                     if (!commentField) return 0;
        //                     const value = commentField.v !== undefined ? commentField.v : commentField;
        //                     if (!value) return 0;
        //                     if (Array.isArray(value)) {
        //                         return value.reduce((acc, item) => {
        //                             return acc + (typeof item === 'string' ? item.length : 0);
        //                         }, 0);
        //                     }
        //                     return typeof value === 'string' ? value.length : 0;
        //                 };
        //                 aValue = getCommentLength(a.comment);
        //                 bValue = getCommentLength(b.comment);
        //                 break;
        //             case 'responsible':
        //                 const getResponsibleValue = (responsibleField) => {
        //                     if (!responsibleField) return '';
        //                     const value = responsibleField.v !== undefined ? responsibleField.v : responsibleField;
        //                     if (!value) return '';
        //                     const responsibles = Array.isArray(value) ? value : [value];
        //                     return responsibles.map(r => responsible[r] || '').join(',').toLowerCase();
        //                 };
        //                 aValue = getResponsibleValue(a.responsible);
        //                 bValue = getResponsibleValue(b.responsible);
        //                 break;
        //             case 'coexecutors':
        //                 const getCoexecutorsValue = (coexecutorsField) => {
        //                     if (!coexecutorsField) return '';
        //                     const value = coexecutorsField.v !== undefined ? coexecutorsField.v : coexecutorsField;
        //                     if (!value) return '';

        //                     // Если это не массив, возвращаем пустую строку
        //                     if (!Array.isArray(value)) return '';

        //                     // Если массив пустой
        //                     if (value.length === 0) return '';

        //                     // Проверяем, является ли первый элемент массивом (вложенная структура)
        //                     if (Array.isArray(value[0])) {
        //                         // Вложенный массив - обрабатываем каждый подмассив
        //                         return value.map(subArray => {
        //                             if (!Array.isArray(subArray)) return '';
        //                             return subArray.map(item => responsible[item]).filter(name => name).join(', ');
        //                         }).filter(group => group).join('; ');
        //                     } else {
        //                         // Простой массив
        //                         return value.map(item => responsible[item]).filter(name => name).join(', ');
        //                     }
        //                 };
        //                 aValue = getCoexecutorsValue(a.coexecutors).toLowerCase();
        //                 bValue = getCoexecutorsValue(b.coexecutors).toLowerCase();
        //                 break;
        //             case 'equipment':
        //                 const getEquipmentValue = (equipmentField) => {
        //                     if (!equipmentField) return '';
        //                     const value = equipmentField.v !== undefined ? equipmentField.v : equipmentField;
        //                     if (!value || !Array.isArray(value)) return '';
        //                     return value.map(e => equipment[e] || '').join(', ').toLowerCase();
        //                 };
        //                 aValue = getEquipmentValue(a.equipment);
        //                 bValue = getEquipmentValue(b.equipment);
        //                 break;
        //             case 'created':
        //                 const getCreatedValue = (createdField) => {
        //                     if (!createdField) return 0;
        //                     try {
        //                         const time = new Date(createdField).getTime();
        //                         return isNaN(time) ? 0 : time;
        //                     } catch {
        //                         return 0;
        //                     }
        //                 };
        //                 aValue = getCreatedValue(a.created_at);
        //                 bValue = getCreatedValue(b.created_at);
        //                 break;
        //             case 'modified':
        //                 const getModifiedValue = (modifiedField) => {
        //                     if (!modifiedField) return 0;
        //                     try {
        //                         const time = new Date(modifiedField).getTime();
        //                         return isNaN(time) ? 0 : time;
        //                     } catch {
        //                         return 0;
        //                     }
        //                 };
        //                 aValue = getModifiedValue(a.modified_at);
        //                 bValue = getModifiedValue(b.modified_at);
        //                 break;
        //             default:
        //                 return 0;
        //         }

        //         // Обработка значений null/undefined
        //         if (aValue === null || aValue === undefined) aValue = sortBy === 'stage' || sortBy === 'fid' ? 0 : '';
        //         if (bValue === null || bValue === undefined) bValue = sortBy === 'stage' || sortBy === 'fid' ? 0 : '';

        //         // Для числовых значений
        //         if (typeof aValue === 'number' && typeof bValue === 'number') {
        //             const comparison = aValue - bValue;
        //             return sortDirection === 'desc' ? -comparison : comparison;
        //         }

        //         // Для строковых значений
        //         if (typeof aValue === 'string' && typeof bValue === 'string') {
        //             const comparison = aValue.localeCompare(bValue, 'ru');
        //             return sortDirection === 'desc' ? -comparison : comparison;
        //         }

        //         return 0;
        //     });
        // }


        console.log(filtered)
        return filtered.map(item => ({
            ...item,
            object: transformers.get(item.object_id),
            // rowSpan: { ...item, ...editedRows[item.id]?.changes }?.equipment.v?.length === 0 ? 1 : { ...item, ...editedRows[item.id]?.changes }?.equipment.v?.length + 1,
            // equipment: item.equipment.v?.map(id => equipment[id]) || [],
            // responsible: Array.isArray(item.responsible.v) ? item.responsible.v.map(r => responsible[r]) : item.responsible.v ? responsible[item.responsible.v] : null,
            // coexecutors: item.coexecutors.v?.map(c => Array.isArray(c) ? c.map(id => responsible[id]) : c ? responsible[c] : null) || [],
            // creator: item.creator ? responsible[item.creator] : null,
            // modifier: item.modifier ? responsible[item.modifier] : null
            row1: { ...item, object: transformers.get(item.object_id) },
            row2: {
                ...item,
                data: item.data || { categories: [] },
                object: transformers.get(item.object_id)
            }
        }));
    }, [user.id, equipment, responsible, transformers]);

    // Состояния для сортировки (объявляем здесь, чтобы они были доступны в useEffect ниже)
    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' | 'desc'

    // Обновляем отфильтрованные данные при изменении исходных данных или параметров
    useEffect(() => {
        const filtered = filterAndSortData(data, editedRows, searchQuery, selectedProjects, advancedFilters, sortBy, sortDirection, equipment);
        setFilteredData(filtered);
    }, [data, searchQuery, selectedProjects, advancedFilters, sortBy, sortDirection, filterAndSortData, transformers, editedRows]);


    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            let response;
            if (user.roles.some(role => ['admin', 'project_manager'].includes(role))) {
                response = await $authHost.get('/apig/reestr-v3', {
                    params: {
                        is_active: true
                    }
                });
            } else {
                response = await $authHost.get('/apig/reestr-v3/by-responsible/' + user.id);
            }
            const { success, data } = response.data;
            // Генерируем uuid для категорий, у которых его нет (обратная совместимость)
            const processedData = success ? data.map(item => {
                if (item.data && item.data.categories) {
                    const categories = item.data.categories.map(cat => {
                        if (!cat.uuid) {
                            return { ...cat, uuid: crypto.randomUUID() };
                        }
                        
                        return cat;
                    });
                    return { ...item, data: { ...item.data, categories } };
                }
                return item;
            }) : [];
            setData(processedData);
        } catch (error) {
            console.error('Error fetching data:', error);
            setData([]);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        fetchData()
    }, [user]);


    useEffect(() => {
        const fetchResponsible = async () => {
            try {
                const response = await $authHost.get('/apig/users');
                const { success, data } = response.data;

                const users = {}

                if (success) {
                    data.forEach(item => {
                        users[item.id] = item.display_name
                    })
                }

                setResponsible(users)
            } catch (e) {
                setResponsible({})
                console.log(e)
                setError(e.message);
            }
        };
        fetchResponsible();
    }, []);




    useEffect(() => {
        const fetchEquipment = async () => {
            try {
                const response = await $authHost.get('/apig/reestr-v3/equipment');
                const { success, data } = response.data;
                const equipment = {}

                if (success) {
                    data.forEach(item => {
                        equipment[item.id] = item.name
                    })
                }
                setEquipment(equipment)

                const treeIds = [...new Set(data.map(eq => eq.tree).flat())]
                const tree = {}
                treeIds.forEach(id => {
                    tree[id] = data.filter(e => e.tree.includes(id)).map(e => e.id)
                })
                setEquipmentTree(tree)
                console.log(requirementsTree, tree)
            } catch (e) {
                setEquipment({})
                console.log(e)
                setError(e.message);
            }
        };
        fetchEquipment();
    }, []);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await $authHost.get('/apig/reestr-v3/projects');
                const { success, data } = response.data;
                setProjects(success ? data : []);
            } catch (e) {
                setProjects([])
                console.log(e)
                setError(e.message);
            }
        };
        fetchProjects();
    }, []);

    useEffect(() => {
        dispatch(fetchState())
    }, []);

    const activeProjects = useMemo(() => {
        return (projects || []).filter(project => data.some(item => item.project_id === project.id));
    }, [projects, data]);


    // Функция для подготовки данных для группировки
    const prepareGroupedData = useCallback((filteredData, editedRows, selectedProjects, projectsList) => {
        // Если не выбран ни один КДП, показываем все данные без группировки
        if (!selectedProjects || selectedProjects.length === 0) {
            return {
                groupCounts: [],
                groupCountsRows: [],
                groupedData: [],
            };
        }
        // Группируем по КДП
        const groupedByKdp = {};
        console.log(filteredData, editedRows)
        filteredData.forEach(item => {
            const itemProjectId = item.project_id;
            const projectName = projectsList.find(p => p.id === itemProjectId)?.name || 'Без проекта';

            if (!groupedByKdp[projectName]) {
                groupedByKdp[projectName] = [];
            }
            groupedByKdp[projectName].push(item);
        });

        // Сортируем группы по названию КДП
        const sortedGroups = Object.keys(groupedByKdp).sort();



        // Создаем плоский массив данных с информацией о группе
        const groupedData = [];
        const groupCounts = [];
        const groupCountsRows = [];

        sortedGroups.forEach((groupName, groupIndex) => {
            const groupItems = groupedByKdp[groupName];

            // Правильный подсчет: сумма всех rowSpan в группе
            const counts = groupItems.length * 2

            groupCounts.push(counts);
            groupCountsRows.push(groupItems.length)

            groupItems.forEach(item => {
                groupedData.push({
                    ...item.row1,
                    group: groupIndex,
                    groupName: groupName,
                    purpose: 'object',
                    // equipmentIndex: index
                });
                groupedData.push({
                    ...item.row2,
                    group: groupIndex,
                    groupName: groupName,
                    purpose: 'table',
                    // equipmentIndex: index
                });
                // const itemRowSpan = item.rowSpan || 1;
                // Создаем нужное количество строк для каждого элемента оборудования
                // for (let index = 0; index < itemRowSpan; index++) {
                //     groupedData.push({
                //         ...item,
                //         group: groupIndex,
                //         groupName: groupName,
                //         equipmentIndex: index
                //     });
                // }
            });
        });
        console.log(groupedData, groupCounts, groupCountsRows)


        // Добавляем пустые элементы в конец для принудительного рендеринга
        const paddingItems = Array.from({ length: sortedGroups.length }, (_, index) => ({
            id: `padding-${index}`,
            fid: groupedData.length + index + 1,
            group: groupedData.length > 0 ? groupedData[groupedData.length - 1].group : 0,
            groupName: groupedData.length > 0 ? groupedData[groupedData.length - 1].groupName : 'Все объекты',
            isPadding: true
        }));

        return { groupCounts, groupCountsRows, groupedData: [...groupedData, ...paddingItems] };
    }, []);

    // Обновляем группированные данные при изменении отфильтрованных данных
    useEffect(() => {
        const grouped = prepareGroupedData(filteredData, editedRows, selectedProjects, activeProjects);

        setGroupedData(grouped);
    }, [filteredData, selectedProjects, activeProjects, prepareGroupedData, editedRows]);



    // Обработчик клика вне области редактирования
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         // Если мы находимся в режиме редактирования
    //         if (editing.id && editing.field) {
    //             // Проверяем, что клик не по элементу редактирования
    //             const editingElement = event.target.closest('[data-editing="true"]');
    //             if (!editingElement) {
    //                 // Выходим из режима редактирования
    //                 setEditing({ id: null, field: null });
    //             }
    //         }
    //     };

    //     // Добавляем обработчик только если мы в режиме редактирования
    //     if (editing.id && editing.field) {
    //         document.addEventListener('mousedown', handleClickOutside);
    //     }

    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside);
    //     };
    // }, [editing]);



    // Состояние для управления видимостью столбцов
    const [visibleColumns, setVisibleColumns] = useState(() => {
        const stored = storedSettings.visibleColumns;
        if (stored) {
            // Проверяем, что все текущие столбцы присутствуют в сохраненных настройках
            const validStoredColumns = {};
            columns.forEach(col => {
                validStoredColumns[col.id] = stored[col.id] !== undefined ? stored[col.id] : true;
            });
            return validStoredColumns;
        }
        // Если нет сохраненных настроек, показываем все столбцы
        return columns.reduce((acc, col) => ({ ...acc, [col.id]: true }), {});
    });
    const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
    const [columnWidths, setColumnWidths] = useState(storedSettings.columnWidths || {});
    const [resizingColumn, setResizingColumn] = useState(null);
    const [resizeStartX, setResizeStartX] = useState(0);
    const [resizeStartWidth, setResizeStartWidth] = useState(0);

    // Сохранение настроек в localStorage при изменении
    useEffect(() => {
        storeSettings({ darkMode });
    }, [darkMode]);

    useEffect(() => {
        storeSettings({ selectedProjects });
    }, [selectedProjects]);

    useEffect(() => {
        storeSettings({ visibleColumns });
    }, [visibleColumns]);

    useEffect(() => {
        storeSettings({ showControlMenu });
    }, [showControlMenu]);

    // Функция для получения ширины столбца
    const getColumnWidth = (columnId) => {
        if (columnWidths[columnId]) {
            return columnWidths[columnId];
        }
        const column = columns.find(col => col.id === columnId);
        return column ? column.width : 150;
    };

    // Обработчики для изменения размера столбцов
    const handleResizeStart = (e, columnId) => {
        e.preventDefault();
        e.stopPropagation();
        const startX = e.clientX;
        const startWidth = getColumnWidth(columnId);
        setResizingColumn(columnId);
        setResizeStartX(startX);
        setResizeStartWidth(startWidth);
    };

    useEffect(() => {
        if (!resizingColumn) return;

        const handleMouseMove = (e) => {
            const diff = e.clientX - resizeStartX;
            const newWidth = Math.max(30, resizeStartWidth + diff); // Минимальная ширина 30px
            setColumnWidths(prev => ({
                ...prev,
                [resizingColumn]: newWidth
            }));
        };

        const handleMouseUp = () => {
            setResizingColumn(null);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [resizingColumn, resizeStartX, resizeStartWidth]);

    // Сохранение ширины столбцов в localStorage
    useEffect(() => {
        storeSettings({ columnWidths });
    }, [columnWidths]);

    const handleEditedField = ({ rowId, field, value, action = 'change', isValueChanged, shouldExitEditMode = true, deleted = null, equipment = null, relatedFields: providedRelatedFields = null, categoryUuid = null, workId = null }) => {
        console.log(rowId, field, value, isValueChanged, deleted, equipment, categoryUuid, workId)
        if (isValueChanged) {

            // Обновляем данные
            // setData(prev =>
            //     prev.map(p => (
            //         p.id === rowId ? { ...p, [field]: value } : p
            //     ))
            // )

            let clearValue;
            let relatedFields = providedRelatedFields || {}
            let existingRow = data.find(row => row.id === rowId)
            existingRow = {
                ...existingRow,
                ...editedRows[rowId]?.changes
            }
            console.log(existingRow)

            // Если переданы categoryUuid или workId, работаем с новым форматом данных
            if (categoryUuid !== null || workId !== null) {
                const currentData = existingRow.data || { categories: [] };
                const existingCategories = currentData.categories || [];

                if (workId !== null && categoryUuid !== null) {
                    // Редактирование поля работы
                    const categoryIndex = existingCategories.findIndex(cat => cat.uuid === categoryUuid);
                    if (categoryIndex === -1) return;

                    const category = existingCategories[categoryIndex];
                    const works = category.works || [];
                    const workIndex = works.findIndex(w => w.id === workId);
                    if (workIndex === -1) return;

                    const updatedWorks = [...works];
                    updatedWorks[workIndex] = {
                        ...updatedWorks[workIndex],
                        [field]: value
                    };

                    const updatedCategory = {
                        ...category,
                        works: updatedWorks
                    };

                    const updatedCategories = [...existingCategories];
                    updatedCategories[categoryIndex] = updatedCategory;

                    const updatedData = {
                        ...currentData,
                        categories: updatedCategories
                    };

                    clearValue = updatedData;
                } else if (categoryUuid !== null) {
                    // Редактирование поля категории
                    const categoryIndex = existingCategories.findIndex(cat => cat.uuid === categoryUuid);
                    if (categoryIndex === -1) return;

                    const category = existingCategories[categoryIndex];
                    const updatedCategory = {
                        ...category,
                        [field]: value
                    };

                    const updatedCategories = [...existingCategories];
                    updatedCategories[categoryIndex] = updatedCategory;

                    const updatedData = {
                        ...currentData,
                        categories: updatedCategories
                    };

                    clearValue = updatedData;
                }
            } else {
                // Редактирование полей верхнего уровня объекта (не категории/работы)
                // Для нового формата все данные в data, поэтому просто сохраняем значение
                clearValue = value;
            }

            // Если clearValue не установлен, выходим
            if (clearValue === undefined) {
                return;
            }

            // Записываем изменение в editedRows
            setEditedRows(prev => {
                if (prev[rowId]) {
                    // Если редактируем поле категории или работы, обновляем data
                    if (categoryUuid !== null || workId !== null) {
                        return {
                            ...prev,
                            [rowId]: { ...prev[rowId], changes: { ...prev[rowId].changes, data: clearValue, ...relatedFields } }
                        }
                    } else {
                        return {
                            ...prev,
                            [rowId]: { ...prev[rowId], changes: { ...prev[rowId].changes, [field]: clearValue, ...relatedFields } }
                        }
                    }
                } else {
                    // Если редактируем поле категории или работы, обновляем data
                    if (categoryUuid !== null || workId !== null) {
                        return { ...prev, [rowId]: { id: rowId, changes: { data: clearValue, ...relatedFields }, originalData: data.find(item => item.id === rowId) } }
                    } else {
                        return { ...prev, [rowId]: { id: rowId, changes: { [field]: clearValue, ...relatedFields }, originalData: data.find(item => item.id === rowId) } }
                    }
                }
                // const existingRow = prev.find(row => row.id === rowId);
                // if (existingRow) {
                //     // Если строка уже есть, обновляем поле
                //     return prev.map(row =>
                //         row.id === rowId
                //             ? { ...row, changes: { ...row.changes, [field]: clearValue } }
                //             : row
                //     );
                // } else {
                //     // Если строки нет, добавляем новую
                //     return [...prev, {
                //         id: rowId,
                //         changes: { [field]: clearValue },
                //         originalData: data.find(item => item.id === rowId)
                //     }];
                // }
            });
        }

        // Сбрасываем состояние редактирования только если это явно запрошено
        if (shouldExitEditMode) {
            setEditing({ id: null, field: null, categoryUuid: null, workId: null })
        }
    }

    useEffect(() => { console.log(editedRows) }, [editedRows])

    // Очистка editing при клике вне области редактирования
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Если нет активного редактирования, ничего не делаем
            if (!editing.id) return;

            const target = event.target;
            
            // Проверяем, был ли клик на редактируемом элементе или его дочерних элементах
            const isClickOnEditable = target.closest('[data-editing-cell]') !== null;
            
            // Проверяем, не был ли клик на элементах DatePicker (который рендерится в портале)
            const isClickOnDatePicker = target.closest('.react-datepicker') !== null ||
                                        target.closest('.react-datepicker__portal') !== null ||
                                        target.closest('.react-datepicker-popper') !== null ||
                                        target.closest('[class*="react-datepicker"]') !== null;
            
            // Проверяем, не был ли клик на выпадающих списках Autocomplete
            const isClickOnAutocomplete = target.closest('.MuiAutocomplete-popper') !== null ||
                                         target.closest('.MuiAutocomplete-paper') !== null ||
                                         target.closest('[role="listbox"]') !== null;

            // Если клик был вне редактируемого элемента и не на вспомогательных элементах
            if (!isClickOnEditable && !isClickOnDatePicker && !isClickOnAutocomplete) {
                // Находим активный элемент с фокусом (input, textarea и т.д.)
                const activeElement = document.activeElement;
                
                // Проверяем, находится ли активный элемент внутри редактируемого элемента
                const activeEditingElement = activeElement?.closest('[data-editing-cell]');
                
                if (activeEditingElement && activeElement) {
                    // Вызываем blur на активном элементе, чтобы сохранить значение
                    if (typeof activeElement.blur === 'function') {
                        activeElement.blur();
                    }
                    
                    // Также вызываем blur на самом редактируемом элементе, если он поддерживает
                    if (activeEditingElement !== activeElement && typeof activeEditingElement.blur === 'function') {
                        activeEditingElement.blur();
                    }
                    
                    // Даем время на обработку blur события перед очисткой editing
                    // Это позволяет handleBlur в компонентах сохранить значение
                    setTimeout(() => {
                        setEditing({ id: null, field: null, categoryUuid: null, workId: null });
                    }, 150);
                } else {
                    // Если не нашли активный элемент, просто очищаем editing
                    setEditing({ id: null, field: null, categoryUuid: null, workId: null });
                }
            }
        };

        // Добавляем обработчик только если есть активное редактирование
        if (editing.id) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [editing]);

    const handleChangeEdititng = ({ id, field, index, categoryUuid, workId }) => {
        setEditing({ id, field, index, categoryUuid, workId })
    }

    // Функция для перемещения equipment и связанных полей
    const handleMoveEquipment = (rowId, currentIndex, direction) => {
        // direction: 'up' или 'down'
        const newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;

        // Получаем актуальные данные строки
        let existingRow = data.find(row => row.id === rowId);
        existingRow = {
            ...existingRow,
            ...editedRows[rowId]?.changes
        };

        const equipmentArray = existingRow.equipment?.v || [];

        // Проверяем границы массива
        if (newIndex < 0 || newIndex >= equipmentArray.length) {
            return;
        }

        // Связанные поля, которые нужно перемещать вместе с equipment
        const relatedFieldsNames = ['plan_start', 'plan_end', 'fact_start', 'fact_end', 'stage', 'closing', 'cost', 'comment', 'name_by_acts', 'responsible', 'coexecutors'];

        // Создаем новые массивы с перемещенными элементами
        const newEquipment = [...equipmentArray];
        [newEquipment[currentIndex], newEquipment[newIndex]] = [newEquipment[newIndex], newEquipment[currentIndex]];

        const relatedFieldsUpdates = {};

        relatedFieldsNames.forEach(fieldName => {
            const fieldValue = existingRow[fieldName]?.v;
            if (Array.isArray(fieldValue)) {
                // Проверяем специальный случай для coexecutors
                if (fieldName === 'coexecutors' && !Array.isArray(fieldValue[0])) {
                    return;
                }

                const newFieldValue = [...fieldValue];
                // Убеждаемся, что массив достаточно длинный для обоих индексов
                const maxIndex = Math.max(currentIndex, newIndex);
                while (newFieldValue.length <= maxIndex) {
                    newFieldValue.push(null);
                }

                // Перемещаем элементы только если оба индекса валидны
                if (currentIndex >= 0 && newIndex >= 0 && currentIndex < newFieldValue.length && newIndex < newFieldValue.length) {
                    [newFieldValue[currentIndex], newFieldValue[newIndex]] = [newFieldValue[newIndex], newFieldValue[currentIndex]];
                    relatedFieldsUpdates[fieldName] = { 'v': newFieldValue };
                }
            }
        });

        // Сохраняем изменения
        handleEditedField({
            rowId: rowId,
            field: 'equipment',
            value: newEquipment,
            isValueChanged: true,
            shouldExitEditMode: false,
            relatedFields: relatedFieldsUpdates
        });
    }

    // Обработчики для работы с категориями и работами
    const handleAddCategoryClick = (event, rowId) => {
        event.stopPropagation();
        setCategoryMenuAnchor(event.currentTarget);
        setSelectedRowForCategory(rowId);
    };

    const handleCategoryMenuClose = () => {
        setCategoryMenuAnchor(null);
        setSelectedRowForCategory(null);
    };

    const handleAddCategory = (categoryId) => {
        if (!selectedRowForCategory) return;

        let row = data.find(r => r.id === selectedRowForCategory);
        if (!row) return;

        // Учитываем изменения из editedRows
        row = {
            ...row,
            ...editedRows[selectedRowForCategory]?.changes
        };

        const currentData = row.data || { categories: [] };
        const existingCategories = currentData.categories || [];

        // Убираем проверку на дубликаты - теперь можно добавлять несколько одинаковых категорий
        // Генерируем уникальный UUID для каждого экземпляра категории
        const newCategory = {
            id: Number(categoryId),
            uuid: crypto.randomUUID(),
            plan_start: '',
            fact_start: '',
            plan_end: '',
            fact_end: '',
            stage: '',
            responsible: '',
            coexecutors: '',
            name_by_acts: '',
            comment: '',
            works: []
        };

        const updatedData = {
            ...currentData,
            categories: [...existingCategories, newCategory]
        };

        handleEditedField({
            rowId: selectedRowForCategory,
            field: 'data',
            value: updatedData,
            isValueChanged: true
        });

        handleCategoryMenuClose();
    };

    const handleDeleteCategory = (rowId, categoryUuid) => {
        let row = data.find(r => r.id === rowId);
        if (!row) return;

        // Учитываем изменения из editedRows
        row = {
            ...row,
            ...editedRows[rowId]?.changes
        };

        const currentData = row.data || { categories: [] };
        const existingCategories = currentData.categories || [];

        const updatedData = {
            ...currentData,
            categories: existingCategories.filter(cat => cat.uuid !== categoryUuid)
        };

        handleEditedField({
            rowId: rowId,
            field: 'data',
            value: updatedData,
            isValueChanged: true
        });
    };

    const handleAddWorkClick = (event, rowId, categoryUuid) => {
        event.stopPropagation();
        setWorkMenuAnchor(event.currentTarget);
        setSelectedRowForCategory(rowId);
        setSelectedCategoryForWork(categoryUuid);
    };

    const handleWorkMenuClose = () => {
        setWorkMenuAnchor(null);
        setSelectedRowForCategory(null);
        setSelectedCategoryForWork(null);
    };

    const handleAddWork = (workId) => {
        if (!selectedRowForCategory || !selectedCategoryForWork) return;

        let row = data.find(r => r.id === selectedRowForCategory);
        if (!row) return;

        // Учитываем изменения из editedRows
        row = {
            ...row,
            ...editedRows[selectedRowForCategory]?.changes
        };

        const currentData = row.data || { categories: [] };
        const existingCategories = currentData.categories || [];

        const categoryIndex = existingCategories.findIndex(cat => cat.uuid === selectedCategoryForWork);
        if (categoryIndex === -1) return;

        const category = existingCategories[categoryIndex];
        const existingWorks = category.works || [];

        // Проверяем, что работа еще не добавлена
        if (existingWorks.some(work => work.id === Number(workId))) {
            handleWorkMenuClose();
            return;
        }

        // Добавляем новую работу
        const newWork = {
            id: Number(workId),
            cost: 0,
            closing: 0
        };

        const updatedCategory = {
            ...category,
            works: [...existingWorks, newWork]
        };

        const updatedCategories = [...existingCategories];
        updatedCategories[categoryIndex] = updatedCategory;

        const updatedData = {
            ...currentData,
            categories: updatedCategories
        };

        handleEditedField({
            rowId: selectedRowForCategory,
            field: 'data',
            value: updatedData,
            isValueChanged: true
        });

        handleWorkMenuClose();
    };

    const handleDeleteWork = (rowId, categoryUuid, workId) => {
        let row = data.find(r => r.id === rowId);
        if (!row) return;

        // Учитываем изменения из editedRows
        row = {
            ...row,
            ...editedRows[rowId]?.changes
        };

        const currentData = row.data || { categories: [] };
        const existingCategories = currentData.categories || [];

        const categoryIndex = existingCategories.findIndex(cat => cat.uuid === categoryUuid);
        if (categoryIndex === -1) return;

        const category = existingCategories[categoryIndex];
        const existingWorks = category.works || [];

        const updatedCategory = {
            ...category,
            works: existingWorks.filter(work => work.id !== workId)
        };

        const updatedCategories = [...existingCategories];
        updatedCategories[categoryIndex] = updatedCategory;

        const updatedData = {
            ...currentData,
            categories: updatedCategories
        };

        handleEditedField({
            rowId: rowId,
            field: 'data',
            value: updatedData,
            isValueChanged: true
        });
    };

    const handleMoveCategoryUp = (rowId, categoryUuid) => {
        

        let row = data.find(r => r.id === rowId);
        if (!row) return;

        // Учитываем изменения из editedRows
        row = {
            ...row,
            ...editedRows[rowId]?.changes
        };

        const currentData = row.data || { categories: [] };
        const existingCategories = [...(currentData.categories || [])];

        const categoryIndex = existingCategories.findIndex(cat => cat.uuid === categoryUuid);
        if (categoryIndex === -1 || categoryIndex === 0) return; // Уже наверху или не найдена

        // Перемещаем категорию вверх
        [existingCategories[categoryIndex - 1], existingCategories[categoryIndex]] =
            [existingCategories[categoryIndex], existingCategories[categoryIndex - 1]];

        const updatedData = {
            ...currentData,
            categories: existingCategories
        };

        handleEditedField({
            rowId: rowId,
            field: 'data',
            value: updatedData,
            isValueChanged: true
        });
    };

    const handleMoveCategoryDown = (rowId, categoryUuid) => {
        

        let row = data.find(r => r.id === rowId);
        if (!row) return;

        // Учитываем изменения из editedRows
        row = {
            ...row,
            ...editedRows[rowId]?.changes
        };

        const currentData = row.data || { categories: [] };
        const existingCategories = [...(currentData.categories || [])];

        const categoryIndex = existingCategories.findIndex(cat => cat.uuid === categoryUuid);
        if (categoryIndex === -1 || categoryIndex === existingCategories.length - 1) return; // Уже внизу или не найдена

        // Перемещаем категорию вниз
        [existingCategories[categoryIndex], existingCategories[categoryIndex + 1]] =
            [existingCategories[categoryIndex + 1], existingCategories[categoryIndex]];

        const updatedData = {
            ...currentData,
            categories: existingCategories
        };

        handleEditedField({
            rowId: rowId,
            field: 'data',
            value: updatedData,
            isValueChanged: true
        });
    };

    const handleMoveWorkUp = (rowId, categoryUuid, workId) => {
        

        let row = data.find(r => r.id === rowId);
        if (!row) return;

        // Учитываем изменения из editedRows
        row = {
            ...row,
            ...editedRows[rowId]?.changes
        };

        const currentData = row.data || { categories: [] };
        const existingCategories = [...(currentData.categories || [])];

        const categoryIndex = existingCategories.findIndex(cat => cat.uuid === categoryUuid);
        if (categoryIndex === -1) return;

        const category = existingCategories[categoryIndex];
        const existingWorks = [...(category.works || [])];

        const workIndex = existingWorks.findIndex(w => w.id === workId);
        if (workIndex === -1 || workIndex === 0) return; // Уже наверху или не найдена

        // Перемещаем работу вверх
        [existingWorks[workIndex - 1], existingWorks[workIndex]] =
            [existingWorks[workIndex], existingWorks[workIndex - 1]];

        const updatedCategory = {
            ...category,
            works: existingWorks
        };

        const updatedCategories = [...existingCategories];
        updatedCategories[categoryIndex] = updatedCategory;

        const updatedData = {
            ...currentData,
            categories: updatedCategories
        };

        handleEditedField({
            rowId: rowId,
            field: 'data',
            value: updatedData,
            isValueChanged: true
        });
    };

    const handleMoveWorkDown = (rowId, categoryUuid, workId) => {
     

        let row = data.find(r => r.id === rowId);
        if (!row) return;

        // Учитываем изменения из editedRows
        row = {
            ...row,
            ...editedRows[rowId]?.changes
        };

        const currentData = row.data || { categories: [] };
        const existingCategories = [...(currentData.categories || [])];

        const categoryIndex = existingCategories.findIndex(cat => cat.uuid === categoryUuid);
        if (categoryIndex === -1) return;

        const category = existingCategories[categoryIndex];
        const existingWorks = [...(category.works || [])];

        const workIndex = existingWorks.findIndex(w => w.id === workId);
        if (workIndex === -1 || workIndex === existingWorks.length - 1) return; // Уже внизу или не найдена

        // Перемещаем работу вниз
        [existingWorks[workIndex], existingWorks[workIndex + 1]] =
            [existingWorks[workIndex + 1], existingWorks[workIndex]];

        const updatedCategory = {
            ...category,
            works: existingWorks
        };

        const updatedCategories = [...existingCategories];
        updatedCategories[categoryIndex] = updatedCategory;

        const updatedData = {
            ...currentData,
            categories: updatedCategories
        };

        handleEditedField({
            rowId: rowId,
            field: 'data',
            value: updatedData,
            isValueChanged: true
        });
    };

    const handleOpenCreateDialog = (projectId = null) => {
        setSelectedObject(null);
        setSelectedProjectId(projectId)
        setObjectDialogOpen(true);
        // // Передаем выбранный KDP ID в диалог
        // if (selectedKdpId) {
        //     // Сохраняем выбранный KDP ID для передачи в диалог
        //     setSelectedKdp([selectedKdpId]);
        // } else {
        //     // Очищаем выбранный KDP если не передан
        //     setSelectedKdp([]);
        // }
    };

    const handleOpenEditDialog = (object) => {
        setSelectedObject(object);
        setSelectedProjectId(object.project?.id)
        setObjectDialogOpen(true);
    };

    const handleCloseObjectDialog = (update = false) => {
        if (update) {
            fetchData()
        }
        setSelectedProjectId(null)
        setObjectDialogOpen(false);
        setSelectedObject(null);
        // // Очищаем выбранный KDP при закрытии диалога
        // setSelectedKdp([]);
    };

    const handleOpenHistoryDialog = (object) => {
        setSelectedObject(object);
        setHistoryDialogOpen(true);
    };

    const handleCloseHistoryDialog = () => {
        setHistoryDialogOpen(false);
        setSelectedObject(null);
    };

    // Словарь переводов названий полей
    const fieldTranslates = {
        'fid': '№',
        'responsible': 'Ответственный',
        'coexecutors': 'Соисполнители',
        'equipment': 'Оснащение',
        'stage': 'Этап',
        'project_id': 'Проект',
        'plan_start': 'Плановое начало',
        'plan_end': 'Плановое завершение',
        'fact_start': 'Фактическое начало',
        'fact_end': 'Фактическое завершение',
        'closing': 'Закрытие без НДС',
        'cost': 'Стоимость без НДС',
        'comment': 'Комментарий',
        'name_by_acts': 'Наименование по актам'
    };

    // Функция для обработки путей измененных полей (data.categories[uuid].field и т.д.)
    const handleFieldPath = (fieldPath, oldValues, newValues, formatting) => {
        console.log(fieldPath)
        
        // Обработка изменения всего массива категорий: data.categories
        if (fieldPath === 'data.categories') {
            const oldData = oldValues?.data || {};
            const newData = newValues?.data || {};
            const oldCategories = oldData.categories || [];
            const newCategories = newData.categories || [];
            
            // Находим добавленные, удаленные и измененные категории
            const oldCategoryUuids = new Set(oldCategories.map(cat => cat.uuid).filter(Boolean));
            const newCategoryUuids = new Set(newCategories.map(cat => cat.uuid).filter(Boolean));
            
            const addedCategories = newCategories.filter(cat => !cat.uuid || !oldCategoryUuids.has(cat.uuid));
            const removedCategories = oldCategories.filter(cat => cat.uuid && !newCategoryUuids.has(cat.uuid));
            
            // Формируем описание изменений
            const changes = [];
            if (addedCategories.length > 0) {
                const addedNames = addedCategories.map(cat => equipment[cat.id] || `Категория ${cat.id || '?'}`).join(', ');
                changes.push(`Добавлено: ${addedNames}`);
            }
            if (removedCategories.length > 0) {
                const removedNames = removedCategories.map(cat => equipment[cat.id] || `Категория ${cat.id || '?'}`).join(', ');
                changes.push(`Удалено: ${removedNames}`);
            }
            if (oldCategories.length !== newCategories.length || 
                oldCategories.some((cat, idx) => cat.uuid !== newCategories[idx]?.uuid)) {
                if (changes.length === 0) {
                    changes.push('Изменен порядок категорий');
                }
            }
            
            return {
                fieldLabel: 'Категории',
                oldValue: oldCategories.length > 0 
                    ? oldCategories.map(cat => equipment[cat.id] || `Категория ${cat.id || '?'}`).join(', ')
                    : 'Пусто',
                newValue: newCategories.length > 0
                    ? newCategories.map(cat => equipment[cat.id] || `Категория ${cat.id || '?'}`).join(', ')
                    : 'Пусто',
                rawOldValue: oldCategories,
                rawNewValue: newCategories,
                changes: changes.length > 0 ? changes.join('; ') : null
            };
        }
        
        // Обработка изменения массива работ: data.categories[uuid].works
        const worksMatch = fieldPath.match(/^data\.categories\[([^\]]+)\]\.works$/);
        if (worksMatch) {
            const [, categoryUuid] = worksMatch;
            
            const oldData = oldValues?.data || {};
            const newData = newValues?.data || {};
            const oldCategories = oldData.categories || [];
            const newCategories = newData.categories || [];
            
            const oldCategory = oldCategories.find(cat => cat.uuid === categoryUuid);
            const newCategory = newCategories.find(cat => cat.uuid === categoryUuid);
            
            if (oldCategory || newCategory) {
                const category = newCategory || oldCategory;
                const categoryName = equipment[category?.id] || `Категория ${category?.id || '?'}`;
                
                const oldWorks = oldCategory?.works || [];
                const newWorks = newCategory?.works || [];
                
                // Находим добавленные и удаленные работы
                const oldWorkIds = new Set(oldWorks.map(w => w.id).filter(id => id !== null && id !== undefined));
                const newWorkIds = new Set(newWorks.map(w => w.id).filter(id => id !== null && id !== undefined));
                
                const addedWorks = newWorks.filter(w => !w.id || !oldWorkIds.has(w.id));
                const removedWorks = oldWorks.filter(w => w.id && !newWorkIds.has(w.id));
                
                // Формируем описание изменений
                const changes = [];
                if (addedWorks.length > 0) {
                    const addedNames = addedWorks.map(w => equipment[w.id] || `Работа ${w.id || '?'}`).join(', ');
                    changes.push(`Добавлено: ${addedNames}`);
                }
                if (removedWorks.length > 0) {
                    const removedNames = removedWorks.map(w => equipment[w.id] || `Работа ${w.id || '?'}`).join(', ');
                    changes.push(`Удалено: ${removedNames}`);
                }
                if (oldWorks.length !== newWorks.length || 
                    oldWorks.some((w, idx) => w.id !== newWorks[idx]?.id)) {
                    if (changes.length === 0) {
                        changes.push('Изменен порядок работ');
                    }
                }
                
                return {
                    fieldLabel: `${categoryName} • Работы`,
                    oldValue: oldWorks.length > 0
                        ? oldWorks.map(w => equipment[w.id] || `Работа ${w.id || '?'}`).join(', ')
                        : 'Пусто',
                    newValue: newWorks.length > 0
                        ? newWorks.map(w => equipment[w.id] || `Работа ${w.id || '?'}`).join(', ')
                        : 'Пусто',
                    rawOldValue: oldWorks,
                    rawNewValue: newWorks,
                    changes: changes.length > 0 ? changes.join('; ') : null
                };
            }
        }
        
        // Парсим путь типа "data.categories[uuid].plan_start" или "data.categories[uuid].works[id].cost"
        const pathMatch = fieldPath.match(/^data\.categories\[([^\]]+)\](?:\.works\[([^\]]+)\])?\.(.+)$/);
        
        if (!pathMatch) {
            // Если путь не соответствует формату, возвращаем null для стандартной обработки
            return null;
        }

        const [, categoryUuid, workId, fieldName] = pathMatch;
        
        // Извлекаем значения из old_values и new_values
        let oldValue = null;
        let newValue = null;
        let fieldLabel = '';
        let categoryName = '';
        let workName = '';

        // Получаем категорию из old_values или new_values
        const oldData = oldValues?.data || {};
        const newData = newValues?.data || {};
        const oldCategories = oldData.categories || [];
        const newCategories = newData.categories || [];
        
        const oldCategory = oldCategories.find(cat => cat.uuid === categoryUuid);
        const newCategory = newCategories.find(cat => cat.uuid === categoryUuid);
        console.log(oldCategory, newCategory)
        if (oldCategory || newCategory) {
            const category = newCategory || oldCategory;
            categoryName = equipment[category?.id] || `Категория ${category?.id || '?'}`;
        }

        if (workId) {
            // Обработка пути для работы: data.categories[uuid].works[id].field
            const oldWorks = oldCategory?.works || [];
            const newWorks = newCategory?.works || [];
            
            const oldWork = oldWorks.find(w => String(w.id) === String(workId));
            const newWork = newWorks.find(w => String(w.id) === String(workId));
            
            if (oldWork || newWork) {
                const work = newWork || oldWork;
                workName = equipment[work?.id] || `Работа ${work?.id || '?'}`;
                
                oldValue = oldWork?.[fieldName];
                newValue = newWork?.[fieldName];
                
            // Формируем читаемое название поля
            const fieldTranslation = fieldTranslates[fieldName] || fieldName;
            fieldLabel = `${categoryName} • ${workName} • ${fieldTranslation}`;
            }
        } else {
            // Обработка пути для категории: data.categories[uuid].field
            oldValue = oldCategory?.[fieldName];
            newValue = newCategory?.[fieldName];
            
            // Формируем читаемое название поля
            const fieldTranslation = fieldTranslates[fieldName] || fieldName;
            fieldLabel = `${categoryName} • ${fieldTranslation}`;
        }

        // Форматируем значения используя существующие formatting функции
        let formattedOldValue = oldValue;
        let formattedNewValue = newValue;

        if (formatting[fieldName] && typeof formatting[fieldName] === 'function') {
            try {
                // Создаем объект-заглушку для передачи в formatting функцию
                const mockItem = {
                    equipment: { v: workId ? [workId] : (oldCategory || newCategory)?.id ? [(oldCategory || newCategory).id] : [] }
                };
                
                if (oldValue !== null && oldValue !== undefined) {
                    formattedOldValue = formatting[fieldName](oldValue, mockItem);
                }
                if (newValue !== null && newValue !== undefined) {
                    formattedNewValue = formatting[fieldName](newValue, mockItem);
                }
            } catch (error) {
                console.warn(`Ошибка форматирования поля ${fieldName}:`, error);
            }
        }

        return {
            fieldLabel,
            oldValue: formattedOldValue,
            newValue: formattedNewValue,
            rawOldValue: oldValue,
            rawNewValue: newValue
        };
    };

    const handleOpenCommentDialog = (object) => {
        // Получаем исходный объект из data, а не из filteredData
        // чтобы избежать потери комментариев при применении фильтров
        const originalObject = data.find(item => item.id === object.id);
        if (!originalObject) {
            console.error('Object not found in data:', object.id);
            return;
        }

        // Применяем изменения из editedRows к исходному объекту
        const objectWithChanges = {
            ...originalObject,
            ...editedRows[originalObject.id]?.changes
        };

        setCommentEditObject(objectWithChanges);
        setCommentDialogOpen(true);
    };

    const handleCloseCommentDialog = () => {
        setCommentDialogOpen(false);
        setCommentEditObject(null);
    };

    const handleSaveComments = (newComments) => {
        if (commentEditObject) {
            // Получаем исходный объект из data для правильного обновления массива комментариев
            const originalObject = data.find(item => item.id === commentEditObject.id);
            if (!originalObject) {
                console.error('Object not found in data:', commentEditObject.id);
                return;
            }

            // Получаем текущее состояние объекта с учетом изменений из editedRows
            const existingRow = {
                ...originalObject,
                ...editedRows[commentEditObject.id]?.changes
            };

            // Определяем, нужно ли обновлять массив комментариев или это единичное значение
            const equipmentArray = existingRow.equipment?.v || [];
            let clearValue;

            if (equipmentArray.length > 0) {
                // Если есть оснащение, обновляем массив комментариев
                // newComments - это массив комментариев для каждого элемента оснащения
                clearValue = { 'v': newComments };
            } else {
                // Если нет оснащения, это единичный комментарий
                clearValue = { 'v': Array.isArray(newComments) ? newComments : [newComments] };
            }

            // Обновляем комментарии в editedRows
            setEditedRows(prev => ({
                ...prev,
                [commentEditObject.id]: {
                    ...prev[commentEditObject.id],
                    changes: {
                        ...prev[commentEditObject.id]?.changes,
                        comment: clearValue
                    }
                }
            }));
        }
    };

    const handleOpenNameByActsDialog = (object) => {
        // Получаем исходный объект из data, а не из filteredData
        // чтобы избежать потери данных при применении фильтров
        const originalObject = data.find(item => item.id === object.id);
        if (!originalObject) {
            console.error('Object not found in data:', object.id);
            return;
        }

        // Применяем изменения из editedRows к исходному объекту
        const objectWithChanges = {
            ...originalObject,
            ...editedRows[originalObject.id]?.changes
        };

        setNameByActsEditObject(objectWithChanges);
        setNameByActsDialogOpen(true);
    };

    const handleCloseNameByActsDialog = () => {
        setNameByActsDialogOpen(false);
        setNameByActsEditObject(null);
    };

    const handleSaveNameByActs = (newNameByActs) => {
        if (nameByActsEditObject) {
            // Получаем исходный объект из data для правильного обновления массива
            const originalObject = data.find(item => item.id === nameByActsEditObject.id);
            if (!originalObject) {
                console.error('Object not found in data:', nameByActsEditObject.id);
                return;
            }

            // Получаем текущее состояние объекта с учетом изменений из editedRows
            const existingRow = {
                ...originalObject,
                ...editedRows[nameByActsEditObject.id]?.changes
            };

            // Определяем, нужно ли обновлять массив или это единичное значение
            const equipmentArray = existingRow.equipment?.v || [];
            let clearValue;

            if (equipmentArray.length > 0) {
                // Если есть оснащение, обновляем массив
                // newNameByActs - это массив для каждого элемента оснащения
                clearValue = { 'v': newNameByActs };
            } else {
                // Если нет оснащения, это единичное значение
                clearValue = { 'v': Array.isArray(newNameByActs) ? newNameByActs : [newNameByActs] };
            }

            // Обновляем name_by_acts в editedRows
            setEditedRows(prev => ({
                ...prev,
                [nameByActsEditObject.id]: {
                    ...prev[nameByActsEditObject.id],
                    changes: {
                        ...prev[nameByActsEditObject.id]?.changes,
                        name_by_acts: clearValue
                    }
                }
            }));
        }
    };

    const handleDeleteObject = async (object) => {
        if (window.confirm(`Вы уверены, что хотите удалить объект "${object.id}"?`)) {
            try {
                const response = await $authHost.delete(`/apig/reestr-v3/${object.id}`, {
                    data: {
                        modifier: user.id
                    }
                });
                const { success } = response.data;

                if (success) {
                    // Обновить данные - убираем удаленный объект из состояния
                    setData(prevData => prevData.filter(item => item.id !== object.id));
                    // alert('Объект успешно удален');
                } else {
                    throw new Error(response.error || 'Неизвестная ошибка');
                }
            } catch (error) {
                console.error('Error deleting object:', error);
                alert(`Ошибка при удалении: ${error.message}`);
            }
        }
    };

    // Функции для работы с выбранными строками
    const handleRowSelection = (rowId, checked) => {
        setSelectedRows(prev => {
            const newSet = new Set(prev);
            if (checked) {
                newSet.add(rowId);
            } else {
                newSet.delete(rowId);
            }
            return newSet;
        });
    };

    const handleSelectAll = (checked) => {
        if (checked) {
            setSelectedRows(new Set(filteredData.map(row => row.id)));
        } else {
            setSelectedRows(new Set());
        }
    };
    const handleBulkDelete = async () => {
        if (selectedRows.size === 0) return;

        const selectedObjects = filteredData.filter(row => selectedRows.has(row.id));
        const objectNames = selectedObjects.map(obj => obj.id).join(', ');

        if (window.confirm(`Вы уверены, что хотите удалить ${selectedRows.size} объектов (${objectNames})?`)) {
            try {
                setLoading(true);

                // Удаляем объекты по одному
                const deletePromises = selectedObjects.map(async (object) => {
                    const response = await $authHost.delete(`/apig/reestr-v3/${object.id}`, {
                        data: {
                            modifier: user.id
                        }
                    });
                    return { id: object.id, success: response.data.success };
                });

                const results = await Promise.all(deletePromises);
                const failedDeletes = results.filter(result => !result.success);

                if (failedDeletes.length === 0) {
                    // Обновляем данные - убираем удаленные объекты
                    setData(prevData => prevData.filter(item => !selectedRows.has(item.id)));
                    setSelectedRows(new Set());
                    alert(`Успешно удалено ${selectedRows.size} объектов`);
                } else {
                    alert(`Ошибка при удалении ${failedDeletes.length} объектов`);
                }
            } catch (error) {
                console.error('Error bulk deleting objects:', error);
                alert(`Ошибка при массовом удалении: ${error.message}`);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleCancelChanges = () => {
        // Восстанавливаем оригинальные данные
        // setData(prev => {
        //     let newData = [...prev];
        //     editedRows.forEach(editedRow => {
        //         const index = newData.findIndex(item => item.id === editedRow.id);
        //         if (index !== -1) {
        //             newData[index] = { ...newData[index], ...editedRow.originalData };
        //         }
        //     });
        //     return newData;
        // });

        // Очищаем editedRows
        setEditedRows({});
    };

    const handleSaveChanges = async () => {
        console.log('Save changes:', editedRows)
        try {
            // Отправляем изменения на сервер
            const response = await $authHost.put('/apig/reestr-v3/batch', {
                updates: Object.entries(editedRows).map(([id, row]) => ({
                    id: id,
                    changes: row.changes,
                    modifier: user.id
                }))
            });

            if (response.data.success) {
                // Очищаем editedRows после успешного сохранения
                setEditedRows({});
                // Обновляем данные с сервера
                fetchData();
            } else {
                throw new Error(response.data.error || 'Ошибка при сохранении');
            }
        } catch (error) {
            console.error('Error saving changes:', error);
            alert(`Ошибка при сохранении: ${error.message}`);
        }
    };


    // Обработчик сортировки
    const handleSort = (columnId) => {
        if (sortBy === columnId) {
            // Переключаем направление сортировки
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            // Устанавливаем новый столбец для сортировки
            setSortBy(columnId);
            setSortDirection('asc');
        }

        // Добавляем небольшую задержку для лучшего UX
        setTimeout(() => {
            // Принудительно обновляем отфильтрованные данные
            const filtered = filterAndSortData(data, editedRows, searchQuery, selectedProjects, advancedFilters, columnId, sortBy === columnId ? (sortDirection === 'asc' ? 'desc' : 'asc') : 'asc', equipment);
            setFilteredData(filtered);
        }, 0);
    };

    // Обработчики для управления видимостью столбцов
    const handleColumnMenuOpen = (event) => {
        setColumnMenuAnchor(event.currentTarget);
    };

    const handleColumnMenuClose = () => {
        setColumnMenuAnchor(null);
    };

    const handleColumnVisibilityChange = (columnId, visible) => {
        try {
            setVisibleColumns(prev => ({
                ...prev,
                [columnId]: visible
            }));
        } catch (error) {
            console.warn('Failed to change column visibility:', error);
        }
    };

    const handleShowAllColumns = () => {
        try {
            setVisibleColumns(columns.reduce((acc, col) => ({ ...acc, [col.id]: true }), {}));
        } catch (error) {
            console.warn('Failed to show all columns:', error);
        }
    };

    const handleHideAllColumns = () => {
        try {
            // Оставляем хотя бы первый столбец видимым
            const newVisibility = columns.reduce((acc, col, index) => ({
                ...acc,
                [col.id]: index === 0
            }), {});
            setVisibleColumns(newVisibility);
        } catch (error) {
            console.warn('Failed to hide all columns:', error);
        }
    };

    // Получаем только видимые столбцы
    const getVisibleColumns = useCallback(() => {
        return columns.filter(col => visibleColumns[col.id]);
    }, [visibleColumns]);

    // Функция для вычисления динамической ширины столбцов
    // const getColumnWidths = useCallback(() => {
    //     const visibleCols = columns.filter(col => visibleColumns[col.id]);
    //     if (visibleCols.length === 0) return {};

    //     // Получаем ширину экрана
    //     const screenWidth = window.innerWidth;
    //     const containerPadding = 32; // Отступы контейнера
    //     const availableWidth = screenWidth - containerPadding;

    //     // Вычисляем сумму минимальных ширин
    //     const totalMinWidth = visibleCols.reduce((sum, col) => sum + col.minWidth, 0);

    //     // Если доступная ширина больше суммы минимальных ширин, распределяем оставшееся место
    //     if (availableWidth > totalMinWidth) {
    //         const extraWidth = availableWidth - totalMinWidth;
    //         const flexibleCols = visibleCols.filter(col => !col.maxWidth); // Не растягиваем узкие столбцы
    //         const extraPerCol = flexibleCols.length > 0 ? extraWidth / flexibleCols.length : 0;

    //         return visibleCols.reduce((acc, col) => {
    //             const isFlexible = flexibleCols.includes(col);
    //             acc[col.id] = isFlexible ? col.minWidth + extraPerCol : col.minWidth;
    //             return acc;
    //         }, {});
    //     }

    //     // Если места мало, используем минимальные ширины
    //     return visibleCols.reduce((acc, col) => {
    //         acc[col.id] = col.minWidth;
    //         return acc;
    //     }, {});
    // }, [visibleColumns]);

    // Пересчитываем ширины столбцов при изменении видимости
    // useEffect(() => {
    //     setColumnWidths(getColumnWidths());
    // }, [getColumnWidths]);

    // Пересчитываем ширины при изменении размера окна
    // useEffect(() => {
    //     const handleResize = () => {
    //         setColumnWidths(getColumnWidths());
    //     };

    //     window.addEventListener('resize', handleResize);
    //     // Начальный расчет
    //     setColumnWidths(getColumnWidths());

    //     return () => {
    //         window.removeEventListener('resize', handleResize);
    //     };
    // }, [getColumnWidths]);

    // Функции для управления продвинутыми фильтрами
    const handleApplyAdvancedFilters = () => {
        // Фильтры применяются автоматически через useEffect
        setShowAdvancedFilters(false);
    };

    const handleClearAdvancedFilters = () => {
        setAdvancedFilters([]);
        storeSettings({ advancedFilters: [] });
    };

    const getActiveAdvancedFiltersCount = () => {
        return advancedFilters.length;
    };

    const addFilter = (filterId) => {
        const filter = availableFilters.find(f => f.id === filterId);
        if (filter) {
            // Создаем уникальный идентификатор для фильтра
            const uniqueId = `${filterId}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            const newFilter = {
                id: uniqueId, // Используем уникальный ID
                originalId: filterId, // Сохраняем оригинальный ID для логики фильтрации
                label: filter.label,
                type: filter.type,
                options: filter.options,
                operator: filter.type === 'date' || filter.type === 'number' ? 'equals' :
                    filter.type === 'text' ? 'contains' : null,
                value: filter.type === 'date' || filter.type === 'number' ? null :
                    filter.type === 'boolean' ? '' :
                        filter.type === 'text' ? '' :
                            filter.type === 'multi-select' ? [] : [],
                value2: filter.type === 'date' ? null : null, // Для фильтра "между"
                logic: filter.type === 'multi-select' ? 'or' : null,
                enabled: true
            };
            const newFilters = [...advancedFilters, newFilter];
            setAdvancedFilters(newFilters);
            storeSettings({ advancedFilters: newFilters });
        }
    };

    const removeFilter = (filterId) => {
        const newFilters = advancedFilters.filter(f => f.id !== filterId);
        setAdvancedFilters(newFilters);
        storeSettings({ advancedFilters: newFilters });
    };

    const updateFilter = (filterId, updates) => {
        const newFilters = advancedFilters.map(f =>
            f.id === filterId ? { ...f, ...updates } : f
        );
        setAdvancedFilters(newFilters);
        storeSettings({ advancedFilters: newFilters });
    };

    const getAvailableFiltersForSelect = () => {
        // Разрешаем добавлять несколько одинаковых фильтров
        return availableFilters;
    };

    // Функции для управления меню экспорта
    const handleExportMenuOpen = (event) => {
        setExportMenuAnchor(event.currentTarget);
    };

    const handleExportMenuClose = () => {
        setExportMenuAnchor(null);
    };

    const handleExportFormatSelect = (format) => {
        handleExportMenuClose();
        if (format === 'excel') {
            exportToExcel();
        } else if (format === 'pdf') {
            exportToPDF();
        }
    };
    // Функция экспорта в Excel с использованием ExcelJS
    const exportToExcel = async () => {
        try {
            // Группируем данные по проектам
            const groupedByProjects = {};
            filteredData.forEach(item => {
                const projectId = item.project_id;
                const project = projects.find(p => p.id === projectId);
                const projectName = project?.name || 'Без проекта';

                if (!groupedByProjects[projectName]) {
                    groupedByProjects[projectName] = [];
                }
                groupedByProjects[projectName].push(item);
            });

            // Сортируем группы по названию проекта
            const sortedGroups = Object.keys(groupedByProjects).sort();

            // Создаем новую рабочую книгу ExcelJS
            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'GIS система';
            workbook.lastModifiedBy = 'GIS система';
            workbook.created = new Date();
            workbook.modified = new Date();
            workbook.title = 'Реестр объектов строительства';
            workbook.subject = 'Экспорт данных реестра объектов';
            workbook.keywords = 'реестр, объекты, строительство, экспорт';

            // Создаем лист
            const worksheet = workbook.addWorksheet('Реестр объектов');

            // Закрепляем первую строку (общие заголовки)
            worksheet.views = [
                { state: 'frozen', ySplit: 1 }
            ];


            // Определяем заголовки
            const headers = [
                '№', 'Наименование', 'Наименование по актам', 'Населённый пункт', 'Этап', 'Закрытие без НДС', 'Стоимость без НДС', 'Комментарий', 'Ответственный',
                'Соисполнители', 'Оснащение', 'Плановое начало', 'Плановое завершение',
                'Фактическое начало', 'Фактическое завершение', 'Создатель', 'Дата создания',
                'Редактор', 'Дата изменения'
            ];

            // Собираем все данные в один массив
            let allRows = [];
            let projectRows = []

            // Добавляем данные всех проектов
            sortedGroups.forEach((projectName, projectIndex) => {
                const projectData = groupedByProjects[projectName];

                // Добавляем строку проекта
                const projectRow = [projectName];
                allRows.push(projectRow);
                projectRows.push(allRows.length + 1)

                const tableRows = []

                // Добавляем данные объектов проекта
                projectData.forEach(item => {
                    const categories = item.data?.categories || [];

                    // Если категорий нет, создаем одну строку с пустыми данными
                    if (categories.length === 0) {
                        tableRows.push([
                            item.fid || '',
                            transformers.get(item.object_id)?.name || '',
                            '',
                            transformers.get(item.object_id)?.town || '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            responsible[item.creator] || '',
                            item.created_at ? formatDate(item.created_at, true) : '',
                            responsible[item.modifier] || '',
                            item.modified_at ? formatDate(item.modified_at, true) : ''
                        ]);
                    } else {
                        // Проходим по каждой категории
                        categories.forEach(category => {
                            const works = category.works || [];
                            const categoryEquipmentName = equipment[category.id] || '';

                            // Обрабатываем соисполнителей (общая функция для категории и работ)
                            let coexecutorsStr = '';
                            if (category.coexecutors) {
                                const coexecIds = Array.isArray(category.coexecutors)
                                    ? category.coexecutors
                                    : (category.coexecutors ? [category.coexecutors] : []);
                                coexecutorsStr = coexecIds
                                    .filter(id => id)
                                    .map(id => responsible[id])
                                    .filter(name => name)
                                    .join(', ');
                            }

                            // Сначала всегда добавляем строку категории
                            if (works.length > 0) {
                                // Если есть работы, вычисляем сумму closing и cost из работ
                                const totalClosing = works.reduce((sum, work) => {
                                    return sum + (Number(work.closing || 0));
                                }, 0);
                                const totalCost = works.reduce((sum, work) => {
                                    return sum + (Number(work.cost || 0));
                                }, 0);

                                tableRows.push([
                                    item.fid || '',
                                    transformers.get(item.object_id)?.name || '',
                                    category.name_by_acts || '',
                                    transformers.get(item.object_id)?.town || '',
                                    Math.min(...works.map(work => parseInt(work.stage))),
                                    totalClosing,
                                    totalCost,
                                    category.comment || '',
                                    responsible[category.responsible] || '',
                                    coexecutorsStr,
                                    categoryEquipmentName,
                                    formatDate(category.plan_start, true),
                                    formatDate(category.plan_end, true),
                                    formatDate(category.fact_start, true),
                                    formatDate(category.fact_end, true),
                                    responsible[item.creator] || '',
                                    item.created_at ? formatDate(item.created_at, true) : '',
                                    responsible[item.modifier] || '',
                                    item.modified_at ? formatDate(item.modified_at, true) : ''
                                ]);

                                // Затем добавляем строки для каждой работы
                                works.forEach(work => {
                                    // Получаем название работы
                                    const workName = equipment[work.id] || `Работа ${work.id}`;
                                    // Формируем строку оснащения: категория -> работа
                                    const equipmentDisplay = categoryEquipmentName
                                        ? `${categoryEquipmentName} → ${workName}`
                                        : workName;

                                    tableRows.push([
                                        item.fid || '',
                                        transformers.get(item.object_id)?.name || '',
                                        category.name_by_acts || '',
                                        transformers.get(item.object_id)?.town || '',
                                        work.stage !== null && work.stage !== undefined ? Number(work.stage) : '',
                                        work.closing !== null && work.closing !== undefined ? Number(work.closing) : '',
                                        work.cost !== null && work.cost !== undefined ? Number(work.cost) : '',
                                        category.comment || '',
                                        responsible[category.responsible] || '',
                                        coexecutorsStr,
                                        equipmentDisplay,
                                        formatDate(category.plan_start, true),
                                        formatDate(category.plan_end, true),
                                        formatDate(category.fact_start, true),
                                        formatDate(category.fact_end, true),
                                        responsible[item.creator] || '',
                                        item.created_at ? formatDate(item.created_at, true) : '',
                                        responsible[item.modifier] || '',
                                        item.modified_at ? formatDate(item.modified_at, true) : ''
                                    ]);
                                });
                            } else {
                                // Если работ нет, создаем одну строку для категории
                                tableRows.push([
                                    item.fid || '',
                                    transformers.get(item.object_id)?.name || '',
                                    category.name_by_acts || '',
                                    transformers.get(item.object_id)?.town || '',
                                    category.stage !== null && category.stage !== undefined ? Number(category.stage) : '',
                                    category.closing !== null && category.closing !== undefined ? Number(category.closing) : '',
                                    category.cost !== null && category.cost !== undefined ? Number(category.cost) : '',
                                    category.comment || '',
                                    responsible[category.responsible] || '',
                                    coexecutorsStr,
                                    categoryEquipmentName,
                                    formatDate(category.plan_start, true),
                                    formatDate(category.plan_end, true),
                                    formatDate(category.fact_start, true),
                                    formatDate(category.fact_end, true),
                                    responsible[item.creator] || '',
                                    item.created_at ? formatDate(item.created_at, true) : '',
                                    responsible[item.modifier] || '',
                                    item.modified_at ? formatDate(item.modified_at, true) : ''
                                ]);
                            }
                        });
                    }
                });

                allRows.push(...tableRows);
            });

            // Добавляем одну большую таблицу со всеми данными
            const endRow = allRows.length + 1; // +1 для заголовков
            worksheet.addTable({
                name: 'ObjectsReestrTable',
                ref: `A1:S${endRow}`,
                headerRow: true,
                totalsRow: false,
                style: { theme: 'TableStyleLight2', showRowStripes: true },
                columns: headers.map(h => ({ name: h, filterButton: true })),
                rows: allRows
            });
            const colWidths = [8, 20, 25, 15, 12, 12, 12, 25, 25, 25, 25, 18, 18, 18, 18, 18, 20, 18, 20]
            const centerCols = [1, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]


            // Устанавливаем ширину столбцов
            colWidths.forEach((width, index) => {
                const column = worksheet.getColumn(index + 1);
                column.width = width;
            });

            const dateCols = [12, 13, 14, 15, 17]
            dateCols.forEach(colNumber => {
                const column = worksheet.getColumn(colNumber);
                column.numFmt = 'dd/mm/yyyy'
            })

            const numberCols = [1, 5]
            numberCols.forEach(colNumber => {
                const column = worksheet.getColumn(colNumber);
                column.numFmt = '0'
            })

            const currencyCols = [6, 7]
            currencyCols.forEach(colNumber => {
                const column = worksheet.getColumn(colNumber);
                column.numFmt = '# ##0.00'
            })

            const textCols = [2, 3, 4, 8, 9, 10, 11, 16, 18]
            textCols.forEach(colNumber => {
                const column = worksheet.getColumn(colNumber);
                column.numFmt = ''
            })

            // Устанавливаем черный цвет текста для всех ячеек таблицы
            for (let rowNumber = 1; rowNumber <= endRow; rowNumber++) {
                const row = worksheet.getRow(rowNumber);
                // row.height = undefined

                row.eachCell((cell, colNumber) => {
                    cell.font = {
                        ...cell.font,
                        name: 'Arial',
                        size: projectRows.includes(rowNumber) || rowNumber === 1 ? 11 : 10,
                        bold: projectRows.includes(rowNumber) || rowNumber === 1,
                        color: { argb: 'FF000000' } // Черный цвет

                    };
                    cell.alignment = {
                        horizontal: !projectRows.includes(rowNumber) && (rowNumber === 1 || centerCols.includes(colNumber)) ? 'center' : 'left',
                        vertical: 'middle',
                        wrapText: !projectRows.includes(rowNumber) || rowNumber == 1 ? true : false
                    }
                    // cell.numFmt = dateCols.includes(colNumber) ? 'dd.mm.yyyy' : ''

                    // cell.effectiveType = dateCols.includes(colNumber) ? 4 : 0


                });
                row.height = undefined; // Это включает автоподбор

                if (typeof row.commit === 'function') row.commit();
            }





            // });

            // Настраиваем ширину столбцов
            // worksheet.columns = [
            //     { key: '№', width: 8, alignment: { horizontal: 'center' } },
            //     { key: 'Наименование', width: 20 },
            //     { key: 'Населённый пункт', width: 18 },
            //     { key: 'Этап', width: 12, alignment: { horizontal: 'center' } },
            //     { key: 'Ответственный', width: 25 },
            //     { key: 'Соисполнители', width: 25 },
            //     { key: 'Оснащение', width: 25 },
            //     { key: 'Плановое начало', width: 15, alignment: { horizontal: 'center' } },
            //     { key: 'Плановое завершение', width: 18, alignment: { horizontal: 'center' } },
            //     { key: 'Фактическое начало', width: 15, alignment: { horizontal: 'center' } },
            //     { key: 'Фактическое завершение', width: 18, alignment: { horizontal: 'center' } },
            //     { key: 'Создатель', width: 20 },
            //     { key: 'Дата создания', width: 15, alignment: { horizontal: 'center' } },
            //     { key: 'Редактор', width: 20 },
            //     { key: 'Дата изменения', width: 15, alignment: { horizontal: 'center' } }
            // ];

            // Автофильтр теперь встроен в таблицу

            // Включаем автоподбор высоты строк
            // worksheet.properties.defaultRowHeight = 15;
            // worksheet.properties.defaultColWidth = 10;

            // Применяем автоподбор высоты для всех строк с данными
            // const totalRows = allRows.length + 1; // +1 для заголовков
            // for (let rowNumber = 1; rowNumber <= totalRows; rowNumber++) {
            //     const row = worksheet.getRow(rowNumber);
            //     // Устанавливаем автоподбор высоты для каждой строки
            //     row.height = undefined; // Это включает автоподбор
            //     if (typeof row.commit === 'function') row.commit();
            // }

            // Генерируем имя файла с текущей датой
            const now = new Date();
            const dateStr = now.toISOString().split('T')[0];
            const fileName = `Реестр_объектов_${dateStr}.xlsx`;

            // Экспортируем файл
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);

            console.log('Excel файл успешно создан с примененными стилями (ExcelJS)');
        } catch (error) {
            console.error('Ошибка при экспорте в Excel:', error);
            alert('Произошла ошибка при экспорте файла');
        }
    };

    // Функция экспорта в PDF
    const exportToPDF = () => {
        try {
            // Группируем данные по проектам
            const groupedByProjects = {};
            filteredData.forEach(item => {
                const projectId = item.project_id;
                const project = projects.find(p => p.id === projectId);
                const projectName = project?.name || 'Без проекта';

                if (!groupedByProjects[projectName]) {
                    groupedByProjects[projectName] = [];
                }
                groupedByProjects[projectName].push(item);
            });

            // Сортируем группы по названию проекта
            const sortedGroups = Object.keys(groupedByProjects).sort();

            // Создаем PDF документ
            const pdf = new jsPDF('landscape', 'mm', 'a4');
            pdf.setFont("arial", "normal");
            pdf.setLanguage('ru')

            // Настройки страницы
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const margin = 10;
            const contentWidth = pageWidth - 2 * margin;
            const contentHeight = pageHeight - 2 * margin;

            // Заголовок документа
            pdf.setFontSize(16);
            pdf.setFont("arial", "normal");
            pdf.setTextColor(25, 118, 210);
            pdf.text('Реестр объектов строительства', pageWidth / 2, 10, { align: 'center' });

            // Информация о документе
            pdf.setFontSize(10);
            pdf.setFont("arial", "normal");
            pdf.setTextColor(100, 100, 100);
            const currentDate = new Date().toLocaleDateString('ru-RU');
            pdf.text(`Дата экспорта: ${currentDate}`, pageWidth - margin, 15, { align: 'right' });
            pdf.text(`Всего объектов: ${filteredData.length}`, margin, 15);

            let currentY = 20;
            let pageNumber = 1;
            let totalPages = 1; // Будет обновлено после создания всех страниц

            // Определяем заголовки таблицы (как в Excel)
            const headers = [
                '№', 'Наименование', 'Наименование по актам', 'Населённый пункт', 'Этап', 'Закрытие без НДС', 'Стоимость без НДС', 'Комментарий', 'Ответственный',
                'Соисполнители', 'Оснащение', 'Плановое начало', 'Плановое завершение',
                'Фактическое начало', 'Фактическое завершение', 'Создатель', 'Дата создания',
                'Редактор', 'Дата изменения'
            ];

            // Добавляем данные по группам
            sortedGroups.forEach((projectName, projectIndex) => {
                const projectData = groupedByProjects[projectName];

                // Проверяем, нужно ли добавить новую страницу
                if (currentY > pageHeight - 80) {
                    pdf.addPage();
                    pageNumber++;
                    currentY = 10;

                    // Начинаем с верхней части новой страницы
                    currentY = 10;
                }

                // Заголовок проекта (как в Excel - с заливкой)
                pdf.setFontSize(11);
                pdf.setFont("arial", "bold");
                pdf.setTextColor(0, 0, 0);

                // Рисуем фон для заголовка проекта (светло-голубой как в Excel)
                pdf.setFillColor(230, 243, 255); // E6F3FF
                pdf.rect(margin, currentY - 3, pageWidth - 2 * margin, 8, 'F');

                // Рисуем границы
                pdf.setDrawColor(208, 215, 224); // D0D7E0
                pdf.setLineWidth(0.1);
                pdf.rect(margin, currentY - 3, pageWidth - 2 * margin, 8);

                pdf.text(projectName, pageWidth / 2, currentY + 2, { align: 'center' });
                currentY += 12;

                // Подготавливаем данные для таблицы (как в Excel)
                // const tableData = projectData.map((item, index) => [
                //     item.fid || '',
                //     item.object?.name || '',
                //     item.object?.town || '',
                //     item.stage || '',
                //     item.closing || '',
                //     item.cost || '',
                //     item.comment || '',
                //     Array.isArray(item.responsible)
                //         ? item.responsible.map(r => r.name).join('\n')
                //         : item.responsible?.name || '',
                //     Array.isArray(item.coexecutors)
                //         ? item.coexecutors.map(c => c.name).join('\n')
                //         : '',
                //     Array.isArray(item.equipment)
                //         ? item.equipment.map(e => e.name).join('\n')
                //         : '',
                //     item.plan_start ? formatDate(item.plan_start, true) : '',
                //     item.plan_end ? formatDate(item.plan_end, true) : '',
                //     item.fact_start ? formatDate(item.fact_start, true) : '',
                //     item.fact_end ? formatDate(item.fact_end, true) : '',
                //     item.creator?.name || '',
                //     item.created_at ? formatDate(item.created_at, true) : '',
                //     item.modifier?.name || '',
                //     item.modified_at ? formatDate(item.modified_at, true) : ''
                // ]);

                const tableData = []

                // Добавляем данные объектов проекта
                projectData.forEach(item => {
                    const categories = item.data?.categories || [];

                    // Если категорий нет, создаем одну строку с пустыми данными
                    if (categories.length === 0) {
                        tableData.push([
                            item.fid || '',
                            transformers.get(item.object_id)?.name || '',
                            '',
                            transformers.get(item.object_id)?.town || '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            '',
                            responsible[item.creator] || '',
                            item.created_at ? formatDate(item.created_at, true) : '',
                            responsible[item.modifier] || '',
                            item.modified_at ? formatDate(item.modified_at, true) : ''
                        ]);
                    } else {
                        // Проходим по каждой категории
                        categories.forEach(category => {
                            const works = category.works || [];
                            const categoryEquipmentName = equipment[category.id] || '';

                            // Обрабатываем соисполнителей (общая функция для категории и работ)
                            let coexecutorsStr = '';
                            if (category.coexecutors) {
                                const coexecIds = Array.isArray(category.coexecutors)
                                    ? category.coexecutors
                                    : (category.coexecutors ? [category.coexecutors] : []);
                                coexecutorsStr = coexecIds
                                    .filter(id => id)
                                    .map(id => responsible[id])
                                    .filter(name => name)
                                    .join(', ');
                            }

                            // Сначала всегда добавляем строку категории
                            if (works.length > 0) {
                                // Если есть работы, вычисляем сумму closing и cost из работ
                                const totalClosing = works.reduce((sum, work) => {
                                    return sum + (Number(work.closing || 0));
                                }, 0);
                                const totalCost = works.reduce((sum, work) => {
                                    return sum + (Number(work.cost || 0));
                                }, 0);

                                tableData.push([
                                    item.fid || '',
                                    transformers.get(item.object_id)?.name || '',
                                    category.name_by_acts || '',
                                    transformers.get(item.object_id)?.town || '',
                                    Math.min(...works.map(work => parseInt(work.stage))),
                                    totalClosing,
                                    totalCost,
                                    category.comment || '',
                                    responsible[category.responsible] || '',
                                    coexecutorsStr,
                                    categoryEquipmentName,
                                    formatDate(category.plan_start, true),
                                    formatDate(category.plan_end, true),
                                    formatDate(category.fact_start, true),
                                    formatDate(category.fact_end, true),
                                    responsible[item.creator] || '',
                                    item.created_at ? formatDate(item.created_at, true) : '',
                                    responsible[item.modifier] || '',
                                    item.modified_at ? formatDate(item.modified_at, true) : ''
                                ]);

                                // Затем добавляем строки для каждой работы
                                works.forEach(work => {
                                    // Получаем название работы
                                    const workName = equipment[work.id] || `Работа ${work.id}`;
                                    // Формируем строку оснащения: категория -> работа
                                    const equipmentDisplay = categoryEquipmentName
                                        ? `${categoryEquipmentName} → ${workName}`
                                        : workName;

                                    tableData.push([
                                        item.fid || '',
                                        transformers.get(item.object_id)?.name || '',
                                        category.name_by_acts || '',
                                        transformers.get(item.object_id)?.town || '',
                                        work.stage !== null && work.stage !== undefined ? Number(work.stage) : '',
                                        work.closing !== null && work.closing !== undefined ? Number(work.closing) : '',
                                        work.cost !== null && work.cost !== undefined ? Number(work.cost) : '',
                                        category.comment || '',
                                        responsible[category.responsible] || '',
                                        coexecutorsStr,
                                        equipmentDisplay,
                                        formatDate(category.plan_start, true),
                                        formatDate(category.plan_end, true),
                                        formatDate(category.fact_start, true),
                                        formatDate(category.fact_end, true),
                                        responsible[item.creator] || '',
                                        item.created_at ? formatDate(item.created_at, true) : '',
                                        responsible[item.modifier] || '',
                                        item.modified_at ? formatDate(item.modified_at, true) : ''
                                    ]);
                                });
                            } else {
                                // Если работ нет, создаем одну строку для категории
                                tableData.push([
                                    item.fid || '',
                                    transformers.get(item.object_id)?.name || '',
                                    category.name_by_acts || '',
                                    transformers.get(item.object_id)?.town || '',
                                    category.stage !== null && category.stage !== undefined ? Number(category.stage) : '',
                                    category.closing !== null && category.closing !== undefined ? Number(category.closing) : '',
                                    category.cost !== null && category.cost !== undefined ? Number(category.cost) : '',
                                    category.comment || '',
                                    responsible[category.responsible] || '',
                                    coexecutorsStr,
                                    categoryEquipmentName,
                                    formatDate(category.plan_start, true),
                                    formatDate(category.plan_end, true),
                                    formatDate(category.fact_start, true),
                                    formatDate(category.fact_end, true),
                                    responsible[item.creator] || '',
                                    item.created_at ? formatDate(item.created_at, true) : '',
                                    responsible[item.modifier] || '',
                                    item.modified_at ? formatDate(item.modified_at, true) : ''
                                ]);
                            }
                        });
                    }
                });

                // Добавляем таблицу с улучшенным форматированием
                autoTable(pdf, {
                    head: [headers],
                    body: tableData,
                    startY: currentY,
                    margin: { left: margin, right: margin },
                    pageBreak: 'auto',
                    rowPageBreak: 'avoid',
                    styles: {
                        fontSize: 7,
                        cellPadding: 0.5,
                        lineColor: [208, 215, 224], // D0D7E0 - как в Excel
                        lineWidth: 0.1,
                        textColor: [0, 0, 0],
                        font: 'arial',
                        fontStyle: 'normal',
                        overflow: 'linebreak',
                        cellWidth: 'wrap'
                    },
                    headStyles: {
                        fillColor: [25, 118, 210], // Синий заголовок как в Excel
                        textColor: [255, 255, 255],
                        font: 'arial',
                        fontStyle: 'bold',
                        fontSize: 8,
                        cellPadding: 1,
                        halign: 'center',
                        valign: 'middle'
                    },
                    alternateRowStyles: {
                        fillColor: [230, 243, 255] // E6F3FF - светло-голубой для четных строк
                    },
                    columnStyles: {
                        0: { cellWidth: 7, halign: 'center' },   // №
                        1: { cellWidth: 22 },  // Наименование
                        2: { cellWidth: 17 },  // Наименование по актам
                        3: { cellWidth: 13, halign: 'center' },  // Населённый пункт
                        4: { cellWidth: 9, halign: 'center' },  // Этап
                        5: { cellWidth: 11, halign: 'center' },  // Закрытие
                        6: { cellWidth: 11, halign: 'center' },  // Стоимость
                        7: { cellWidth: 22 },  // Комментарий
                        8: { cellWidth: 16 },  // Ответственный
                        9: { cellWidth: 18 },  // Соисполнители
                        10: { cellWidth: 20 },  // Оснащение
                        11: { cellWidth: 14, halign: 'center' }, // Плановое начало
                        12: { cellWidth: 14, halign: 'center' }, // Плановое завершение
                        13: { cellWidth: 14, halign: 'center' }, // Фактическое начало
                        14: { cellWidth: 14, halign: 'center' }, // Фактическое завершение
                        15: { cellWidth: 14 }, // Создатель
                        16: { cellWidth: 14, halign: 'center' }, // Дата создания
                        17: { cellWidth: 14 }, // Редактор
                        18: { cellWidth: 14, halign: 'center' }, // Дата изменения
                    },
                    didDrawPage: function (data) {
                        // Функция будет вызвана для каждой страницы, но номера добавим позже
                    }
                });

                // Получаем позицию после таблицы
                const tableEndY = pdf.lastAutoTable ? pdf.lastAutoTable.finalY : currentY + 50;
                currentY = tableEndY + 5;

                // Не добавляем разделитель между проектами (как в Excel)
            });

            // Получаем общее количество страниц
            totalPages = pdf.getNumberOfPages();

            // Добавляем номера страниц на все страницы
            for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
                pdf.setPage(pageNum);

                // Добавляем номер страницы внизу
                pdf.setFontSize(8);
                pdf.setFont("arial", "normal");
                pdf.setTextColor(100, 100, 100);
                pdf.text(`Стр. ${pageNum} из ${totalPages}`, pageWidth - margin, pageHeight - 5, { align: 'right' });
            }

            // Генерируем имя файла с текущей датой
            const now = new Date();
            const dateStr = now.toISOString().split('T')[0];
            const fileName = `Реестр_объектов_${dateStr}.pdf`;

            // Сохраняем PDF
            pdf.save(fileName);
            console.log('PDF файл успешно создан с форматированием как в Excel');
        } catch (error) {
            console.error('Ошибка при экспорте в PDF:', error);
            alert('Произошла ошибка при экспорте файла');
        }
    };

    return (
        <Box sx={{
            bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',

            p: 0,
            m: 0,
            display: 'flex',
            flex: 1,
            height: '100%',
            flexDirection: 'column',
            // overflow: 'hidden',
            width: '100%'

        }}>
            <Paper sx={{
                display: 'flex',
                flexDirection: 'column',
                bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                borderRadius: 0,
                boxShadow: 'none',
                overflow: 'hidden',
                border: 'none',
                width: '100%',
                minHeight: '100%',
            }}>
                {/* Первая строка - заголовок, поиск, темная тема */}
                <Box sx={{
                    bgcolor: darkMode ? '#2b2b2b' : '#fff',
                    borderBottom: darkMode
                        ? '1px solid rgba(255, 255, 255, 0.12)'
                        : '1px solid rgba(0, 0, 0, 0.12)',
                    p: { xs: 0.5, md: 1 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: { xs: 1, md: 2 },
                }}>
                    {/* Левая часть - заголовок */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: { xs: '100%', md: 'auto' } }}>
                        {/* <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 48,
                            height: 48,
                            borderRadius: '50%',
                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.1)',
                            border: darkMode ? '2px solid #64b5f6' : '2px solid #1976d2'
                        }}>
                            <BusinessIcon sx={{
                                fontSize: '28px',
                                color: darkMode ? '#64b5f6' : '#1976d2'
                            }} />
                        </Box>
                        <Box>
                            <Typography variant="h5" sx={{
                                fontWeight: 700,
                                color: darkMode ? '#f5f7fa' : '#333',
                                mb: 0.5,
                            }}>
                                Реестр объектов
                            </Typography>
                            <Typography variant="body2" sx={{
                                color: darkMode ? '#bbb' : '#666',
                                fontSize: '0.875rem'
                            }}>
                                Управление объектами строительства
                            </Typography>
                        </Box> */}
                        {/* KDP селект */}
                        <FormControl
                            size="small"
                            sx={{
                                minWidth: { xs: 'auto', md: '300px' },
                                flex: { xs: 1, sm: 'none' },
                                '& .MuiInputLabel-root': {
                                    color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                    '&.Mui-focused': {
                                        color: '#1976d2'
                                    }
                                },
                            }}
                        >
                            {/* <InputLabel>Проект</InputLabel> */}
                            <Select
                                multiple
                                value={selectedProjects}
                                onChange={(e) => {
                                    const { target: { value } } = e;
                                    if (value.includes(0)) {
                                        if (selectedProjects.length === activeProjects.length) {
                                            setSelectedProjects([]);
                                        } else {
                                            setSelectedProjects(activeProjects.map(project => project.id));
                                        }
                                    } else {
                                        setSelectedProjects(
                                            typeof value === 'string' ? value.split(',').map(Number) : value,
                                        );
                                    }
                                }}
                                // label="Проект"
                                displayEmpty
                                // placeholder="Не выбрано"
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                        return "Выбор проектов";
                                    }
                                    if (selected.length === activeProjects.length) {
                                        return "Все проекты"
                                    }
                                    if (selected.length === 1) {
                                        const project = activeProjects.find(project => project.id === selected[0]);
                                        return project ? project.name : `Выбрано: ${selected.length}`;
                                    }
                                    return `Выбрано: ${selected.length}`;
                                }}
                                sx={{
                                    fontSize: { xs: '0.8rem', md: '0.9rem' },
                                    bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#1976d2'
                                    },
                                    '& .MuiSelect-icon': {
                                        color: darkMode ? '#bbb' : 'rgba(0,0,0,0.54)'
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                        '&.Mui-focused': {
                                            color: '#1976d2'
                                        },
                                        '&.MuiInputLabel-shrink': {
                                            color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                        }
                                    },
                                    '& .MuiSelect-select': {
                                        '&:empty::before': {
                                            content: 'attr(placeholder)',
                                            color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                        }
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {

                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
                                            '& .MuiMenuItem-root': {

                                                color: darkMode ? '#f5f7fa' : '#333',
                                                '&:hover': {
                                                    bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                                }
                                            },
                                            '& .MuiTypography-root': {
                                                fontSize: { xs: '0.8rem', md: '0.9rem' },
                                            },
                                            '& .MuiButtonBase-root': {
                                                minHeight: 0,
                                                padding: '4px'
                                            }
                                        }
                                    }
                                }}
                            >
                                <MenuItem value={0}>
                                    <Checkbox
                                        size="small"
                                        checked={selectedProjects.length === activeProjects.length && activeProjects.length > 0}
                                        sx={{
                                            color: darkMode ? '#bbb' : 'rgba(0,0,0,0.54)',
                                            '&.Mui-checked': {
                                                color: darkMode ? '#64b5f6' : '#1976d2'
                                            }
                                        }}
                                    />
                                    <ListItemText primary="Все проекты" />
                                </MenuItem>
                                {activeProjects.map((project) => (
                                    <MenuItem key={project.id} value={project.id}>
                                        <Checkbox
                                            size="small"
                                            checked={selectedProjects.includes(project.id)}
                                            sx={{
                                                color: darkMode ? '#bbb' : 'rgba(0,0,0,0.54)',
                                                '&.Mui-checked': {
                                                    color: darkMode ? '#64b5f6' : '#1976d2'
                                                }
                                            }}
                                        />
                                        <ListItemText primary={project.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    {/* Центральная часть - поиск и KDP селект */}
                    <Box sx={{
                        flex: 1,
                        display: 'flex',
                        gap: 2,
                        maxWidth: { xs: '100%', md: '600px' },
                        minWidth: { xs: '100%', sm: '400px', md: '500px' },
                        order: { xs: 3, md: 0 }
                    }}>


                        {/* Поиск */}
                        <Box sx={{
                            flex: 1,
                            position: 'relative'
                        }}>
                            <TextField
                                size="small"
                                placeholder="Поиск объектов..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                fullWidth
                                slotProps={{
                                    input: {
                                        startAdornment: <SearchIcon sx={{
                                            mr: 1,
                                            color: darkMode ? '#bbb' : 'text.secondary',
                                            fontSize: { xs: '16px', md: '20px' }
                                        }} />,
                                        endAdornment: searchQuery && (
                                            <IconButton
                                                size="small"
                                                onClick={() => setSearchQuery('')}
                                                sx={{
                                                    color: darkMode ? '#bbb' : '#666',
                                                    '&:hover': {
                                                        color: darkMode ? '#f5f7fa' : '#333',
                                                    }
                                                }}
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )
                                    }
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        bgcolor: darkMode ? '#1e1e1e' : '#f8fafc',
                                        color: darkMode ? '#f5f7fa' : '#333',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#1976d2'
                                        }
                                    },
                                    '& .MuiInputBase-input': {
                                        fontSize: { xs: '0.8rem', md: '0.9rem' },
                                        color: darkMode ? '#f5f7fa' : '#333',
                                        '&::placeholder': {
                                            color: darkMode ? '#bbb' : '#666',
                                            opacity: 1
                                        }
                                    }
                                }}
                            />
                            {/* Индикатор результатов поиска */}
                            {/* {searchQuery && (
                                <Typography
                                    variant="caption"
                                    sx={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        mt: 0.5,
                                        color: darkMode ? '#bbb' : '#666',
                                        fontSize: '0.75rem',
                                    }}
                                >
                                    Найдено: {filteredData.length} из {data.length}
                                </Typography>
                            )} */}
                        </Box>
                        {/* Правая часть - кнопки управления */}
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            {/* Кнопка скрытия меню кнопок управления */}
                            <Tooltip title={showControlMenu ? "Скрыть меню кнопок управления" : "Показать меню кнопок управления"}>
                                <IconButton
                                    onClick={() => setShowControlMenu(!showControlMenu)}
                                    sx={{
                                        color: darkMode ? '#f5f7fa' : '#666',
                                        bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                                        '&:hover': {
                                            bgcolor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                                        },
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    {showControlMenu ?
                                        <VisibilityOffIcon sx={{ fontSize: { xs: '16px', md: '20px' } }} /> :
                                        <VisibilityIcon sx={{ fontSize: { xs: '16px', md: '20px' } }} />
                                    }
                                </IconButton>
                            </Tooltip>

                            {/* Кнопка настроек столбцов */}
                            <Tooltip title="Настроить видимость столбцов">
                                <IconButton
                                    onClick={handleColumnMenuOpen}
                                    sx={{
                                        color: darkMode ? '#f5f7fa' : '#666',
                                        bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                                        '&:hover': {
                                            bgcolor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                                        },
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    <ViewColumnIcon sx={{ fontSize: { xs: '16px', md: '20px' } }} />
                                </IconButton>
                            </Tooltip>

                            {/* Кнопка темной темы */}
                            {/* <IconButton
                                onClick={() => dispatch(toggleDarkMode())}
                                sx={{
                                    color: darkMode ? '#f5f7fa' : '#666',
                                    bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                                    '&:hover': {
                                        bgcolor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                                    },
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                {darkMode ? <LightModeIcon sx={{ fontSize: { xs: '16px', md: '20px' } }} /> : <DarkModeIcon sx={{ fontSize: { xs: '16px', md: '20px' } }} />}
                            </IconButton> */}
                        </Box>
                    </Box>


                </Box>

                {/* Вторая строка - панель инструментов */}
                {showControlMenu && (
                    <Box sx={{
                        p: { xs: 1, md: 1 },
                        borderBottom: darkMode
                            ? '1px solid rgba(255, 255, 255, 0.12)'
                            : '1px solid rgba(0, 0, 0, 0.12)',
                        bgcolor: darkMode ? '#252525' : '#f8fafc',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: { xs: 1, md: 2 },
                    }}>
                        {/* Индикатор активных фильтров */}
                        {/* {(searchQuery || filterMode !== 'all' || sortMode !== 'created_desc' || selectedKdp.length > 0) && (
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            flexWrap: 'wrap',
                            p: 1,
                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.1)' : 'rgba(25, 118, 210, 0.1)',
                            borderRadius: 1,
                            border: `1px solid ${darkMode ? 'rgba(100, 181, 246, 0.3)' : 'rgba(25, 118, 210, 0.3)'}`,
                        }}>
                            <Typography variant="caption" sx={{ color: darkMode ? '#64b5f6' : '#1976d2', fontWeight: 600 }}>
                                Активные фильтры:
                            </Typography>
                            {searchQuery && (
                                <Chip
                                    label={`Поиск: "${searchQuery}"`}
                                    size="small"
                                    onDelete={() => setSearchQuery('')}
                                    sx={{
                                        bgcolor: darkMode ? 'rgba(255, 152, 0, 0.2)' : 'rgba(255, 152, 0, 0.1)',
                                        color: darkMode ? '#ffb74d' : '#f57c00',
                                        fontSize: '0.7rem',
                                    }}
                                />
                            )}
                            {selectedKdp.length > 0 && (
                                <Chip
                                    label={`KDP: ${selectedKdp.length} выбрано`}
                                    size="small"
                                    onDelete={() => setSelectedKdp([])}
                                    sx={{
                                        bgcolor: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.1)',
                                        color: darkMode ? '#ce93d8' : '#9c27b0',
                                        fontSize: '0.7rem',
                                    }}
                                />
                            )}
                            {filterMode !== 'all' && (
                                <Chip
                                    label={`Фильтр: ${filterMode === 'my' ? 'Мои объекты' : 'Активные этапы'}`}
                                    size="small"
                                    onDelete={() => setFilterMode('all')}
                                    sx={{
                                        bgcolor: darkMode ? 'rgba(156, 39, 176, 0.2)' : 'rgba(156, 39, 176, 0.1)',
                                        color: darkMode ? '#ce93d8' : '#9c27b0',
                                        fontSize: '0.7rem',
                                    }}
                                />
                            )}
                            {sortMode !== 'created_desc' && (
                                <Chip
                                    label={`Сортировка: ${sortMode}`}
                                    size="small"
                                    onDelete={() => setSortMode('created_desc')}
                                    sx={{
                                        bgcolor: darkMode ? 'rgba(76, 175, 80, 0.2)' : 'rgba(76, 175, 80, 0.1)',
                                        color: darkMode ? '#81c784' : '#388e3c',
                                        fontSize: '0.7rem',
                                    }}
                                />
                            )}
                        </Box>
                    )} */}

                        {/* Основные элементы управления */}
                        <Box sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            gap: { xs: 1, md: 2 },
                            alignItems: { xs: 'stretch', md: 'center' },
                            justifyContent: 'space-between'
                        }}>
                            {/* Левая группа - кнопка создания и фильтры */}
                            <Box sx={{
                                display: 'flex',
                                gap: { xs: 1, md: 2 },
                                flex: 1,
                                flexDirection: { xs: 'column', sm: 'row' },
                                flexWrap: 'wrap',
                                alignItems: { xs: 'stretch', sm: 'center' }
                            }}>
                                {/* Кнопка создания */}
                                {user.roles?.includes('project_manager') && (
                                    <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        startIcon={<AddIcon />}
                                        onClick={() => handleOpenCreateDialog()}
                                        sx={{
                                            bgcolor: '#4caf50',
                                            color: 'white',
                                            px: 1.5,
                                            py: 0.5,
                                            textTransform: 'none',
                                            fontSize: '0.75rem',
                                            fontWeight: 600,
                                            borderRadius: 1.5,
                                            boxShadow: '0 2px 4px rgba(76, 175, 80, 0.3)',
                                            '&:hover': {
                                                bgcolor: '#388e3c',
                                                transform: 'translateY(-1px)',
                                                boxShadow: '0 4px 8px rgba(76, 175, 80, 0.4)'
                                            },
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        Создать объект
                                    </Button>
                                )}
                                {/* Кнопка продвинутых фильтров */}
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<FilterIcon />}
                                    onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                                    sx={{
                                        borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                        color: darkMode ? '#64b5f6' : '#1976d2',
                                        px: 1,
                                        py: 0.5,
                                        textTransform: 'none',
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        borderRadius: 1,
                                        minWidth: 'auto',
                                        '&:hover': {
                                            borderColor: darkMode ? '#42a5f5' : '#1565c0',
                                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.1)' : 'rgba(25, 118, 210, 0.1)',
                                            transform: 'translateY(-1px)',
                                        },
                                        transition: 'all 0.2s ease',
                                        ...(getActiveAdvancedFiltersCount() > 0 && {
                                            bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.2)',
                                            borderColor: darkMode ? '#42a5f5' : '#1565c0',
                                        })
                                    }}
                                >
                                    Фильтры
                                    {getActiveAdvancedFiltersCount() > 0 && (
                                        <Chip
                                            label={getActiveAdvancedFiltersCount()}
                                            size="small"
                                            sx={{
                                                ml: 0.5,
                                                bgcolor: darkMode ? '#1976d2' : '#1976d2',
                                                color: '#fff',
                                                fontSize: '0.7rem',
                                                height: '16px',
                                                minWidth: '16px'
                                            }}
                                        />
                                    )}
                                </Button>
                                {/* Объединенная кнопка экспорта с меню */}
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<FileDownloadIcon />}
                                    endIcon={<KeyboardArrowDownIcon />}
                                    onClick={handleExportMenuOpen}
                                    disabled={filteredData.length === 0}
                                    sx={{
                                        borderColor: darkMode ? '#1976d2' : '#1976d2',
                                        color: darkMode ? '#1976d2' : '#1976d2',
                                        px: 1,
                                        py: 0.5,
                                        textTransform: 'none',
                                        fontSize: '0.75rem',
                                        fontWeight: 600,
                                        borderRadius: 1,
                                        minWidth: 'auto',
                                        '&:hover': {
                                            borderColor: darkMode ? '#1565c0' : '#1565c0',
                                            bgcolor: darkMode ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.1)',
                                            transform: 'translateY(-1px)',
                                        },
                                        '&:disabled': {
                                            borderColor: darkMode ? '#666' : '#ccc',
                                            color: darkMode ? '#666' : '#ccc',
                                            transform: 'none',
                                        },
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    Экспорт
                                </Button>
                                {/* Меню выбора формата экспорта */}
                                <Menu
                                    anchorEl={exportMenuAnchor}
                                    open={Boolean(exportMenuAnchor)}
                                    onClose={handleExportMenuClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    sx={{
                                        '& .MuiPaper-root': {
                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            border: darkMode ? '1px solid rgba(255, 255, 255, 0.12)' : '1px solid rgba(0, 0, 0, 0.12)',
                                            boxShadow: darkMode ? '0 4px 20px rgba(0, 0, 0, 0.5)' : '0 4px 20px rgba(0, 0, 0, 0.15)',
                                        }
                                    }}
                                >
                                    <MenuItem
                                        onClick={() => handleExportFormatSelect('excel')}
                                        sx={{
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            '&:hover': {
                                                bgcolor: darkMode ? 'rgba(76, 175, 80, 0.1)' : 'rgba(76, 175, 80, 0.1)',
                                            }
                                        }}
                                    >
                                        <FileDownloadIcon sx={{ mr: 1, color: '#4caf50' }} />
                                        Экспорт в Excel
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => handleExportFormatSelect('pdf')}
                                        sx={{
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            '&:hover': {
                                                bgcolor: darkMode ? 'rgba(244, 67, 54, 0.1)' : 'rgba(244, 67, 54, 0.1)',
                                            }
                                        }}
                                    >
                                        <PictureAsPdfIcon sx={{ mr: 1, color: '#f44336' }} />
                                        Экспорт в PDF
                                    </MenuItem>
                                </Menu>
                                {/* Фильтр */}
                                {/* <FormControl
                                size="small"
                                sx={{
                                    minWidth: { xs: 'auto', md: '150px' },
                                    flex: { xs: 1, sm: 'none' },
                                    '& .MuiInputLabel-root': {
                                        color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                        '&.Mui-focused': {
                                            color: '#1976d2'
                                        }
                                    }
                                }}
                            >
                                <InputLabel>Фильтр</InputLabel>
                                <Select
                                    value={filterMode}
                                    size='small'
                                    onChange={(e) => setFilterMode(e.target.value)}
                                    label="Фильтр"
                                    startAdornment={<FilterIcon sx={{
                                        mr: 1,
                                        color: darkMode ? '#bbb' : 'text.secondary',
                                        fontSize: '18px'
                                    }} />}
                                    sx={{
                                        fontSize: '0.75rem',
                                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                        color: darkMode ? '#f5f7fa' : '#333',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#1976d2'
                                        },
                                        '& .MuiSelect-icon': {
                                            color: darkMode ? '#bbb' : 'rgba(0,0,0,0.54)'
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '0.7rem'
                                        }
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                                border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
                                                '& .MuiMenuItem-root': {
                                                    fontSize: '0.75rem',
                                                    color: darkMode ? '#f5f7fa' : '#333',
                                                    '&:hover': {
                                                        bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                                    }
                                                }
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value="all">Все объекты ({data.length})</MenuItem>
                                   
                                </Select>
                            </FormControl> */}

                                {/* Кнопка сброса фильтров */}
                                {/* {(searchQuery || filterMode !== 'all' || selectedKdp.length > 0) && (
                                <Button
                                    size="small"
                                    onClick={() => {
                                        setSearchQuery('');
                                        setFilterMode('all');
                                        setSelectedKdp([]);
                                    }}
                                    sx={{
                                        mb: 1,
                                        color: darkMode ? '#bbb' : '#666',
                                        fontSize: '0.75rem',
                                        textTransform: 'none',
                                        '&:hover': {
                                            color: darkMode ? '#f5f7fa' : '#333',
                                        }
                                    }}
                                >
                                    Сбросить фильтры
                                </Button>
                            )} */}
                            </Box>

                            {/* Правая группа - кнопка редактирования */}
                            <Box sx={{
                                display: 'flex',
                                gap: { xs: 1, md: 2 },
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: { xs: 'stretch', md: 'center' },
                                justifyContent: 'space-between'
                            }}>
                                {/* Индикатор режима редактирования */}
                                {/* {editMode && (
                                <Chip
                                    label="Режим редактирования"
                                    size="small"
                                    sx={{
                                        bgcolor: darkMode ? 'rgba(25, 118, 210, 0.2)' : 'rgba(25, 118, 210, 0.1)',
                                        color: darkMode ? '#64b5f6' : '#1976d2',
                                        fontSize: '0.7rem',
                                        fontWeight: 600,
                                        border: `1px solid ${darkMode ? 'rgba(100, 181, 246, 0.3)' : 'rgba(25, 118, 210, 0.3)'}`,
                                    }}
                                />
                            )} */}

                                {/* Индикатор изменений */}
                                {/* {editedRows.length > 0 && (
                                <Chip
                                    label={`${editedRows.length} изменений`}
                                    size="small"
                                    sx={{
                                        bgcolor: darkMode ? 'rgba(255, 152, 0, 0.2)' : 'rgba(255, 152, 0, 0.1)',
                                        color: darkMode ? '#ffb74d' : '#f57c00',
                                        fontSize: '0.7rem',
                                        fontWeight: 600,
                                        border: `1px solid ${darkMode ? 'rgba(255, 152, 0, 0.3)' : 'rgba(255, 152, 0, 0.3)'}`,
                                    }}
                                />
                            )} */}

                                {/* Кнопки отмены и сохранения */}
                                {Object.keys(editedRows).length > 0 && (
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: { xs: 1, md: 2 },
                                        alignItems: { xs: 'stretch', md: 'center' },
                                        justifyContent: 'center'
                                    }}>
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            size="small"
                                            onClick={handleCancelChanges}
                                            sx={{
                                                borderColor: darkMode ? '#f44336' : '#d32f2f',
                                                color: darkMode ? '#f44336' : '#d32f2f',
                                                px: 1.5,
                                                py: 0.5,
                                                textTransform: 'none',
                                                fontSize: '0.75rem',
                                                fontWeight: 600,
                                                borderRadius: 1.5,
                                                '&:hover': {
                                                    bgcolor: darkMode ? 'rgba(244, 67, 54, 0.1)' : 'rgba(211, 47, 47, 0.1)',
                                                    borderColor: darkMode ? '#f44336' : '#d32f2f',
                                                },
                                                transition: 'all 0.2s ease',
                                            }}
                                        >
                                            Отменить
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            size="small"
                                            startIcon={<SaveIcon />}
                                            onClick={handleSaveChanges}
                                            sx={{
                                                bgcolor: '#4caf50',
                                                color: 'white',
                                                px: 1.5,
                                                py: 0.5,
                                                textTransform: 'none',
                                                fontSize: '0.75rem',
                                                fontWeight: 600,
                                                borderRadius: 1.5,
                                                boxShadow: '0 2px 4px rgba(76, 175, 80, 0.3)',
                                                '&:hover': {
                                                    bgcolor: '#388e3c',
                                                    transform: 'translateY(-1px)',
                                                    boxShadow: '0 4px 8px rgba(76, 175, 80, 0.4)'
                                                },
                                                transition: 'all 0.2s ease',
                                            }}
                                        >
                                            Сохранить
                                        </Button>
                                    </Box>
                                )}

                                {/* Кнопка редактирования */}
                                {user.roles?.includes('project_manager') && (
                                    <Button
                                        variant={editMode ? "contained" : "outlined"}
                                        startIcon={<EditIcon />}
                                        onClick={() => {
                                            if (editMode && editedRows.length > 0) {
                                                if (window.confirm('У вас есть несохраненные изменения. Выйти из режима редактирования?')) {
                                                    setEditMode(false);
                                                    setSelectedRows(new Set());
                                                    // setEditedRows([]);
                                                    handleCancelChanges()
                                                }
                                            } else {
                                                setEditMode(!editMode);
                                                if (!editMode) {
                                                    // Входим в режим редактирования
                                                    setSelectedRows(new Set());
                                                } else {
                                                    // Выходим из режима редактирования
                                                    setSelectedRows(new Set());
                                                }
                                            }
                                        }}
                                        sx={{
                                            bgcolor: editMode ? '#1976d2' : 'transparent',
                                            color: editMode ? 'white' : (darkMode ? '#64b5f6' : '#1976d2'),
                                            borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                            px: 1,
                                            py: 0.5,
                                            textTransform: 'none',
                                            fontSize: '0.8rem',
                                            fontWeight: 600,
                                            borderRadius: 2,
                                            boxShadow: editMode ? '0 2px 8px rgba(25, 118, 210, 0.3)' : 'none',
                                            '&:hover': {
                                                bgcolor: editMode ? '#1565c0' : (darkMode ? 'rgba(100, 181, 246, 0.1)' : 'rgba(25, 118, 210, 0.1)'),
                                                transform: editMode ? 'translateY(-1px)' : 'none',
                                                boxShadow: editMode ? '0 4px 12px rgba(25, 118, 210, 0.4)' : 'none'
                                            },
                                            transition: 'all 0.2s ease',
                                            minWidth: { xs: '100%', sm: 'auto' },
                                        }}
                                    >
                                        {editMode ? 'Завершить редактирование' : 'Редактировать'}
                                    </Button>
                                )}

                                {/* Кнопка удаления выбранных строк */}
                                {editMode && selectedRows.size > 0 && (
                                    <Button
                                        variant="contained"
                                        color="error"
                                        startIcon={<DeleteIcon />}
                                        onClick={handleBulkDelete}
                                        sx={{
                                            bgcolor: '#f44336',
                                            color: 'white',
                                            px: 1,
                                            py: 0.5,
                                            textTransform: 'none',
                                            fontSize: '0.8rem',
                                            fontWeight: 600,
                                            borderRadius: 2,
                                            boxShadow: '0 2px 8px rgba(244, 67, 54, 0.3)',
                                            '&:hover': {
                                                bgcolor: '#d32f2f',
                                                transform: 'translateY(-1px)',
                                                boxShadow: '0 4px 12px rgba(244, 67, 54, 0.4)'
                                            },
                                            transition: 'all 0.2s ease',
                                            minWidth: { xs: '100%', sm: 'auto' },
                                        }}
                                    >
                                        Удалить ({selectedRows.size})
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Box>
                )}

                {/* Продвинутые фильтры */}
                {showAdvancedFilters && (
                    <AdvancedFiltersComponent
                        darkMode={darkMode}
                        advancedFilters={advancedFilters}
                        setAdvancedFilters={setAdvancedFilters}
                        responsible={responsible}
                        equipment={equipment}
                        stages={stages}
                        onApplyFilters={handleApplyAdvancedFilters}
                        onClearFilters={handleClearAdvancedFilters}
                        addFilter={addFilter}
                        removeFilter={removeFilter}
                        updateFilter={updateFilter}
                        getAvailableFiltersForSelect={getAvailableFiltersForSelect}
                    />
                )}

                {/* Таблица */}
                <Box sx={{
                    display: 'flex',
                    flex: 1,
                    height: '100%',
                    bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                    width: '100%',
                }}>
                    {loading ? (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%',
                            color: darkMode ? '#f5f7fa' : '#333',
                            gap: 2,
                        }}>
                            <CircularProgress size={40} sx={{ color: darkMode ? '#64b5f6' : '#1976d2' }} />
                            <Typography variant="h6">Загрузка данных...</Typography>
                        </Box>
                    ) : error ? (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%',
                            color: darkMode ? '#f44336' : '#d32f2f',
                        }}>
                            <Typography variant="h6">Ошибка загрузки: {error}</Typography>
                        </Box>
                    ) : (filteredData.length === 0 && groupedData.groupedData.length === 0) ? (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%',
                            color: darkMode ? '#bbb' : '#666',
                        }}>
                            <Typography variant="h6">
                                {searchQuery || advancedFilters.length > 0
                                    ? 'По вашему запросу ничего не найдено'
                                    : 'Нет данных для отображения'
                                }
                            </Typography>
                        </Box>
                    ) : (
                        <GroupedTableVirtuoso
                            key={'grouped-table'}
                            data={groupedData.groupedData}
                            overscan={200}
                            // followOutput={false}
                            // atBottomThreshold={200}
                            // atTopThreshold={200}
                            // Предварительный рендер вне вьюпорта - уменьшено для стабильности

                            // increaseViewportBy={{ top: 500, bottom: 500 }}
                            // Фиксированная высота строки для стабильности прокрутки при rowSpan
                            // defaultItemHeight={200}
                            // minOverscanItemCount={3}
                            // Плавная деградация контента при быстром скролле
                            // scrollSeekConfiguration={{
                            //     enter: (velocity) => Math.abs(velocity) > 800,
                            //     exit: (velocity) => Math.abs(velocity) < 30,
                            //     change: (_, range) => range,
                            // }}
                            groupCounts={groupedData.groupCounts}
                            totalCount={groupedData.groupedData.length}
                            components={VirtuosoTableComponents}
                            fixedHeaderContent={() => fixedHeaderContent(darkMode, editMode, selectedRows, filteredData, handleSelectAll, sortBy, sortDirection, handleSort, visibleColumns, columnWidths, getColumnWidth, handleResizeStart)}
                            groupContent={(index) => groupContent(index, groupedData, darkMode, user, handleOpenCreateDialog, activeProjects, visibleColumns)}
                            // Ключ для правильной идентификации элементов при виртуализации
                            // computeItemKey={(index) => {
                            //     const row = groupedData.groupedData[index];
                            //     if (!row) return `row-${index}`;
                            //     return row.isPadding ? `padding-${row.id}` : `${row.id}-${row.equipmentIndex || 0}`;
                            // }}
                            itemContent={(index, groupIndex) => {
                                const row = groupedData.groupedData[index];
                                if (!row) {
                                    console.warn('Missing row at index:', index);
                                    return null;
                                }
                                const cells = rowContent(index, row, {
                                    editMode,
                                    editing,
                                    openHistoryDialog: handleOpenHistoryDialog,
                                    openCommentDialog: handleOpenCommentDialog,
                                    openNameByActsDialog: handleOpenNameByActsDialog,
                                    saveEditedField: handleEditedField,
                                    setEditingField: handleChangeEdititng,
                                    users: responsible,
                                    equipmentMap: equipment,
                                    equipmentTree,
                                    darkMode,
                                    editedRows,
                                    selectedRows,
                                    handleRowSelection,
                                    handleOpenEditDialog,
                                    visibleColumns,
                                    handleMoveEquipment,
                                    searchQuery,
                                    advancedFilters,
                                    getColumnWidth,
                                    expandedCategories,
                                    toggleCategory,
                                    handleAddCategoryClick,
                                    handleDeleteCategory,
                                    handleAddWorkClick,
                                    handleDeleteWork,
                                    handleMoveCategoryUp,
                                    handleMoveCategoryDown,
                                    handleMoveWorkUp,
                                    handleMoveWorkDown,
                                    equipment: Object.keys(equipment).map(id => ({ id: Number(id), name: equipment[id] })),
                                    stages,
                                    sortBy,
                                    sortDirection
                                });


                                // Возвращаем ячейки как есть - фильтрация видимости столбцов 
                                // уже обрабатывается в функции rowContent через параметр visibleColumns
                                return cells;
                            }}
                            style={{
                                backgroundColor: darkMode ? '#1e1e1e' : '#f5f7fa',
                                width: '100%',
                                height: '100%',
                                minHeight: '400px',
                            }}

                        />

                    )}
                </Box>
            </Paper >

            <ObjectDialog
                open={objectDialogOpen}
                currentUser={user}
                onClose={handleCloseObjectDialog}
                objectData={selectedObject}
                darkMode={darkMode}
                responsible={Object.entries(responsible).map(([id, name]) => ({ id: Number(id), name }))}
                equipment={Object.entries(equipment).map(([id, name]) => ({ id: Number(id), name }))}
                stages={stages}
                projects={projects}
                selectedProjectId={selectedProjectId}
            />
            <AuditHistoryDialog
                open={historyDialogOpen}
                onClose={handleCloseHistoryDialog}
                tableName="objects_reestr_new"
                tableTitle="Реестр объектов"
                recordId={selectedObject?.id}
                recordTitle={selectedObject?.object?.name}
                darkMode={darkMode}
                fieldPathHandler={handleFieldPath}
                translates={fieldTranslates}
                formatting={
                    {
                        'name_by_acts': (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (item && item.equipment) {
                            //         return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${newValue[indx] || ''}`))
                            //     } else {
                            //         return newValue || ''
                            //     }
                            // }
                            return newValue || ''
                        },
                        'plan_start': (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (Array.isArray(newValue)) {
                            //         if (item && item.equipment) {
                            //             return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${formatDateShort(newValue[indx])}`))
                            //         } else {
                            //             return newValue.map((v, i) => formatDateShort(v))
                            //         }
                            //     }
                            // }
                            return formatDateShort(newValue)
                        },
                        'plan_end': (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (Array.isArray(newValue)) {
                            //         if (item && item.equipment) {
                            //             return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${formatDateShort(newValue[indx])}`))
                            //         } else {
                            //             return newValue.map((v, i) => formatDateShort(v))
                            //         }
                            //     }
                            // }
                            return formatDateShort(newValue)
                        },
                        'fact_start': (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (Array.isArray(newValue)) {
                            //         if (item && item.equipment) {
                            //             return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${formatDateShort(newValue[indx])}`))
                            //         } else {
                            //             return newValue.map((v, i) => formatDateShort(v))
                            //         }
                            //     }
                            // }
                            return formatDateShort(newValue)
                        },
                        'fact_end': (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (Array.isArray(newValue)) {
                            //         if (item && item.equipment) {
                            //             return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${formatDateShort(newValue[indx])}`))
                            //         } else {
                            //             return newValue.map((v, i) => formatDateShort(v))
                            //         }
                            //     }
                            // }
                            return formatDateShort(newValue)
                        },
                        'stage': (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (Array.isArray(newValue)) {
                            //         if (item && item.equipment) {
                            //             return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${newValue[indx]}`))
                            //         } else {
                            //             return newValue
                            //         }
                            //     }
                            // }
                            return newValue
                        },
                        'closing': (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (Array.isArray(newValue)) {
                            //         if (item && item.equipment) {
                            //             return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${formatRuble(newValue[indx] || 0)}`))
                            //         } else {
                            //             return newValue.map((v, i) => formatRuble(v || 0))
                            //         }
                            //     }
                            // }
                            return formatRuble(newValue || 0)
                        },
                        'cost': (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (Array.isArray(newValue)) {
                            //         if (item && item.equipment) {
                            //             return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${formatRuble(newValue[indx] || 0)}`))
                            //         } else {
                            //             return newValue.map((v, i) => formatRuble(v || 0))
                            //         }
                            //     }
                            // }
                            return formatRuble(newValue || 0)
                        },
                        'comment': (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (item && item.equipment) {
                            //         return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${newValue[indx] || ''}`))
                            //     } else {
                            //         return newValue || ''
                            //     }

                            // }
                            return newValue || ''
                        },
                        responsible: (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (Array.isArray(newValue)) {
                            //     if (item && item.equipment) {
                            //         return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${newValue[indx]}`))
                            //     } else {
                            //         return newValue.map((v, i) => responsible[v] || ' ')
                            //     }
                            // }
                            return responsible[newValue] || ' '
                        },
                        coexecutors: (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            // if (newValue && newValue[0] && Array.isArray(newValue[0])) {
                            //     if (item && item.equipment) {
                            //         return item.equipment.v.map((id, indx) => (`${equipment[id]}: ${newValue[indx].map(u => responsible[u] || ' ').join(', ')}`))
                            //     } else {
                            //         return newValue.map(v => `(${v.map(u => responsible[u] || ' ').join(', ')})`)
                            //     }
                            // }
                            return (Array.isArray(newValue) ? newValue : [newValue]).map(c => responsible[c] || ' ')
                        },
                        equipment: (value, item = null) => {
                            const newValue = value.v ? value.v : value
                            return newValue.map(c => equipment[c])
                        },
                        'project_id': (value) => {
                            return projects.find(p => p.id === value)?.name
                        }
                    }
                }
                ignore={
                    ['modifier']
                }
            />

            <EquipmentTextEditDialog
                open={commentDialogOpen}
                onClose={handleCloseCommentDialog}
                onSave={handleSaveComments}
                equipment={commentEditObject?.equipment?.v?.map(id => ({
                    id,
                    name: equipment[id] || `ID: ${id}`
                })) || []}
                comments={commentEditObject?.comment?.v || []}
                darkMode={darkMode}
                objectName={commentEditObject?.object?.name || 'Объект'}
                title="Редактирование комментариев"
                equipmentLabel="Оснащение"
                textLabel="Комментарий"
                previewLabel="Превью"
                placeholder="Введите комментарий (поддерживается Markdown: **жирный**, *курсив*, # заголовок, - список)"
                generalItemLabel="Общий комментарий"
            />

            <EquipmentTextEditDialog
                open={nameByActsDialogOpen}
                onClose={handleCloseNameByActsDialog}
                onSave={handleSaveNameByActs}
                equipment={nameByActsEditObject?.equipment?.v?.map(id => ({
                    id,
                    name: equipment[id] || `ID: ${id}`
                })) || []}
                comments={nameByActsEditObject?.name_by_acts?.v || []}
                darkMode={darkMode}
                objectName={nameByActsEditObject?.object?.name || 'Объект'}
                title="Редактирование наименования по актам"
                equipmentLabel="Оснащение"
                textLabel="Наименование по актам"
                previewLabel="Превью"
                placeholder="Введите наименование по актам (поддерживается Markdown: **жирный**, *курсив*, # заголовок, - список)"
                generalItemLabel="Общее наименование по актам"
            />

            {/* Меню настройки видимости столбцов */}
            <Menu
                anchorEl={columnMenuAnchor}
                open={Boolean(columnMenuAnchor)}
                onClose={handleColumnMenuClose}
                PaperProps={{
                    sx: {
                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                        border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
                        minWidth: 250,
                        maxHeight: 400,
                        '& .MuiMenuItem-root': {
                            fontSize: '0.875rem',
                            color: darkMode ? '#f5f7fa' : '#333',
                            padding: '0',
                            pr: 1,
                            borderRadius: '6px',
                            '&:hover': {
                                bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                            }
                        }
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {/* Заголовок меню */}
                <MenuItem disabled sx={{ display: 'flex', justifyContent: 'center', margin: '0 !important', padding: '0 !important', borderRadius: '0 !important' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: darkMode ? '#f5f7fa' : '#333' }}>
                        Видимость столбцов
                    </Typography>
                </MenuItem>

                <Divider sx={{
                    bgcolor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',
                    margin: '4px 0'
                }} />

                {/* Кнопки управления всеми столбцами */}
                <MenuItem onClick={handleShowAllColumns} sx={{ justifyContent: 'center' }}>
                    <Typography variant="body2" sx={{ color: darkMode ? '#64b5f6' : '#1976d2', fontWeight: 500 }}>
                        Показать все
                    </Typography>
                </MenuItem>
                <MenuItem onClick={handleHideAllColumns} sx={{ justifyContent: 'center' }}>
                    <Typography variant="body2" sx={{ color: darkMode ? '#64b5f6' : '#1976d2', fontWeight: 500 }}>
                        Скрыть все
                    </Typography>
                </MenuItem>

                <Divider sx={{
                    bgcolor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',
                    margin: '4px 0'
                }} />

                {/* Список столбцов с чекбоксами */}
                {columns.map((column) => (
                    <MenuItem
                        key={column.id}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Checkbox
                            checked={visibleColumns[column.id] || false}
                            onChange={(e) => handleColumnVisibilityChange(column.id, e.target.checked)}
                            size="small"
                            sx={{
                                color: darkMode ? '#64b5f6' : '#1976d2',
                                '&.Mui-checked': {
                                    color: darkMode ? '#64b5f6' : '#1976d2',
                                },
                                mr: 0
                            }}
                        />
                        <ListItemText
                            primary={column.label}
                            primaryTypographyProps={{
                                fontSize: '0.875rem',
                                color: darkMode ? '#f5f7fa' : '#333'
                            }}
                        />
                    </MenuItem>
                ))}
            </Menu>

            {/* Autocomplete для выбора категории для добавления */}
            {selectedRowForCategory && categoryMenuAnchor && (() => {
                let row = data.find(r => r.id === selectedRowForCategory);
                if (!row) return null;

                // Учитываем изменения из editedRows
                row = {
                    ...row,
                    ...editedRows[selectedRowForCategory]?.changes
                };

                // Получаем все категории из всего equipmentMap
                const allCategories = Object.keys(equipment).map(id => ({
                    id: Number(id),
                    name: equipment[id] || `Категория ${id}`
                }));

                return (
                    <Popper
                        open={Boolean(categoryMenuAnchor)}
                        anchorEl={categoryMenuAnchor}
                        placement="bottom-start"
                        style={{ zIndex: 1300, width: categoryMenuAnchor?.offsetWidth || 300 }}
                    >
                        <Autocomplete
                            open={true}
                            onClose={handleCategoryMenuClose}
                            options={allCategories}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    handleAddCategory(newValue.id);
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    // label="Поиск категории"
                                    variant="outlined"
                                    size="small"
                                    autoFocus
                                    sx={{
                                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                        '& .MuiOutlinedInput-root': {
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            '& fieldset': {
                                                borderColor: darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: darkMode ? '#64b5f6' : '#1976d2',
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: darkMode ? '#bbb' : '#666',
                                        },
                                    }}
                                />
                            )}
                            renderOption={(props, option) => {
                                return (
                                    <Box
                                        component="li"
                                        {...props}
                                        sx={{
                                            ...props.sx,
                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            '&:hover': {
                                                bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                            },
                                            cursor: 'pointer',
                                            fontSize: '0.875rem',
                                        }}
                                        onClick={() => handleAddCategory(option.id)}
                                    >
                                        {option.name}
                                    </Box>
                                );
                            }}
                            PaperComponent={(props) => (
                                <Paper
                                    {...props}
                                    sx={{
                                        ...props.sx,
                                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                        border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
                                        minWidth: 300,
                                        maxHeight: 500,
                                    }}
                                />
                            )}
                            sx={{
                                width: categoryMenuAnchor?.offsetWidth || 300,
                                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                            }}
                        />
                    </Popper>
                );
            })()}

            {/* Меню выбора работы для добавления */}
            <Menu
                anchorEl={workMenuAnchor}
                open={Boolean(workMenuAnchor)}
                onClose={handleWorkMenuClose}
                PaperProps={{
                    sx: {
                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                        border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
                        minWidth: 250,
                        maxHeight: 400,
                        '& .MuiMenuItem-root': {
                            fontSize: '0.875rem',
                            color: darkMode ? '#f5f7fa' : '#333',
                            '&:hover': {
                                bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                            },
                            '&.Mui-disabled': {
                                opacity: 0.5,
                            }
                        }
                    }
                }}
            >
                {selectedRowForCategory && selectedCategoryForWork && (() => {
                    let row = data.find(r => r.id === selectedRowForCategory);
                    if (!row) return null;

                    // Учитываем изменения из editedRows
                    row = {
                        ...row,
                        ...editedRows[selectedRowForCategory]?.changes
                    };

                    const currentData = row?.data || { categories: [] };
                    // Ищем категорию по uuid (selectedCategoryForWork содержит uuid категории)
                    const category = currentData.categories?.find(cat => cat.uuid === selectedCategoryForWork);
                    if (!category) return null;
                    
                    const existingWorkIds = (category.works || []).map(w => w.id);

                    // Получаем доступные работы для этой категории из equipmentTree по id категории
                    const availableWorkIds = equipmentTree[String(category.id)] || [];

                    return availableWorkIds.map(workId => {
                        const isDisabled = existingWorkIds.includes(workId);
                        const workName = equipment[workId] || `Работа ${workId}`;

                        return (
                            <MenuItem
                                key={workId}
                                onClick={() => !isDisabled && handleAddWork(workId)}
                                disabled={isDisabled}
                            >
                                {workName}
                                {isDisabled && <Typography variant="caption" sx={{ ml: 1, color: darkMode ? '#999' : '#666' }}>(уже добавлена)</Typography>}
                            </MenuItem>
                        );
                    });
                })()}
            </Menu>
        </Box >
    );
};

export default ObjectsReestrView;
